// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comp-page {
  --comp-bg: #0b0f19;
  --comp-slate: #121826;
  --comp-text: #f8fafc;
  --comp-muted: #94a3b8;
  --comp-border: rgba(255, 255, 255, 0.08);
  --comp-glass: rgba(15, 23, 42, 0.72);
  --comp-primary: var(--brand-primary, #0877bc);
  --comp-home: #34d399;
  --comp-away: #fbbf24;
  --comp-loss: #f87171;
  --comp-in: #34d399;
  --comp-out: #fb7185;
  --comp-ease: cubic-bezier(0.16, 1, 0.3, 1);
  --comp-ink: var(--comp-text);
  --comp-surface: var(--comp-slate);
  --comp-accent: var(--comp-primary);
  min-height: 100vh;
  padding-top: 1.25rem;
  padding-bottom: calc(120px + env(safe-area-inset-bottom, 0px));
  padding-left: max(1.1rem, env(safe-area-inset-left, 0px));
  padding-right: max(1.1rem, env(safe-area-inset-right, 0px));
  background:
    radial-gradient(1100px 520px at 8% -18%, color-mix(in srgb, var(--comp-primary) 32%, transparent), transparent 58%),
    radial-gradient(720px 380px at 108% 4%, rgba(251, 191, 36, 0.1), transparent 52%),
    radial-gradient(640px 280px at 50% 120%, rgba(52, 211, 153, 0.07), transparent 55%),
    var(--comp-bg);
  color: var(--comp-text);
  font-family: Outfit, Inter, -apple-system, sans-serif;
  width: 100%;
  max-width: 100%;
  margin-inline: auto;
  overflow-x: clip;
  box-sizing: border-box;
}

.comp-page__inner {
  max-width: min(520px, 100%);
  width: 100%;
  min-width: 0;
  margin-inline: auto;
  box-sizing: border-box;
}

.comp-page--light {
  --comp-bg: #f3f5f8;
  --comp-slate: #ffffff;
  --comp-text: #0f172a;
  --comp-muted: #475569;
  --comp-border: rgba(15, 23, 42, 0.08);
  --comp-glass: rgba(255, 255, 255, 0.86);
  --comp-home: #047857;
  --comp-away: #b45309;
  --comp-loss: #dc2626;
  --comp-in: #047857;
  --comp-out: #e11d48;
}

.comp-hero {
  position: relative;
  padding: 0.15rem 0.1rem 0.2rem;
}

.comp-hero__glow {
  pointer-events: none;
  position: absolute;
  top: -24px;
  left: 0;
  right: 0;
  height: 160px;
  background: radial-gradient(
    closest-side,
    color-mix(in srgb, var(--comp-primary) 22%, transparent),
    transparent 78%
  );
  filter: blur(8px);
}

.comp-page__hero-bar h1,
.comp-hero h1 {
  position: relative;
  margin: 0.2rem 0 0;
  font-size: 2rem;
  letter-spacing: -0.04em;
  font-weight: 800;
  line-height: 1.05;
}

.comp-page__kicker {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;
  color: var(--comp-muted);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.comp-hero__lede {
  position: relative;
  margin: 0.55rem 0 0;
  max-width: 36rem;
  color: var(--comp-muted);
  font-size: 0.95rem;
  line-height: 1.5;
}

.comp-hero__schema {
  position: relative;
  display: inline-block;
  margin-top: 0.7rem;
  color: #7dd3fc;
  font-weight: 700;
  font-size: 0.85rem;
}

.comp-page__round {
  position: relative;
  display: inline-flex;
  margin: 0.7rem 0 0;
  padding: 0.28rem 0.7rem;
  border-radius: 999px;
  border: 1px solid var(--comp-border);
  background: color-mix(in srgb, var(--comp-primary) 12%, transparent);
  color: var(--comp-text);
  font-size: 0.78rem;
  font-weight: 650;
}

.comp-hero__stats {
  position: relative;
  list-style: none;
  margin: 1rem 0 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(110px, 100%), 1fr));
  gap: 0.5rem;
  max-width: 100%;
  min-width: 0;
}

.comp-hero__stats li {
  min-width: 0;
  padding: 0.7rem 0.65rem;
  border-radius: 16px;
  border: 1px solid var(--comp-border);
  background: var(--comp-glass);
  backdrop-filter: blur(16px);
}

.comp-hero__stats strong {
  display: block;
  font-size: 0.92rem;
  letter-spacing: -0.02em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.comp-hero__stats span {
  display: block;
  margin-top: 0.15rem;
  color: var(--comp-muted);
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.comp-phone-videos {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  margin-top: 1rem;
  padding: 0.7rem 0.85rem;
  border-radius: 16px;
  border: 1px solid color-mix(in srgb, var(--comp-away) 45%, transparent);
  background: color-mix(in srgb, var(--comp-away) 10%, var(--comp-glass));
  color: var(--comp-text);
  text-decoration: none;
}

.comp-phone-videos > svg:first-child {
  flex: 0 0 auto;
  color: var(--comp-away);
}

.comp-phone-videos > svg:last-child {
  flex: 0 0 auto;
  color: var(--comp-muted);
}

.comp-phone-videos__text {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.comp-phone-videos__text strong {
  font-size: 0.92rem;
  font-weight: 800;
}

.comp-phone-videos__text span {
  font-size: 0.8rem;
  color: var(--comp-muted);
  font-variant-numeric: tabular-nums;
}

.comp-phone-videos:focus-visible {
  outline: 2px solid var(--comp-primary);
  outline-offset: 2px;
}

.comp-tabs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.28rem;
  margin-top: 1.15rem;
  padding: 0.28rem;
  border-radius: 16px;
  border: 1px solid var(--comp-border);
  background: rgba(255, 255, 255, 0.04);
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.comp-tabs--with-cups {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

@media (max-width: 380px) {
  .comp-tabs--with-cups button {
    position: relative;
    flex-direction: column;
    gap: 0.12rem;
    min-height: 3.25rem;
    padding: 0.3rem 0.2rem;
    font-size: 0.68rem;
  }

  .comp-tabs--with-cups button em {
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
    min-width: 0.95rem;
    padding: 0.02rem 0.22rem;
    font-size: 0.55rem;
  }
}

.comp-page--light .comp-tabs {
  background: rgba(15, 23, 42, 0.04);
}

.comp-tabs button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.28rem;
  min-width: 0;
  min-height: 44px;
  max-width: 100%;
  padding: 0.35rem 0.4rem;
  border: 0;
  border-radius: 12px;
  background: transparent;
  color: var(--comp-muted);
  font: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1.1;
  cursor: pointer;
  overflow: hidden;
  transition: background 0.28s var(--comp-ease), color 0.28s var(--comp-ease), transform 0.2s var(--comp-ease);
}

.comp-tabs button svg {
  flex-shrink: 0;
  width: 1rem;
  height: 1rem;
}

.comp-tabs__text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.comp-tabs__full {
  display: none;
}

.comp-tabs__abbr {
  display: inline;
}

.comp-tabs button em {
  flex-shrink: 0;
  font-style: normal;
  min-width: 1.1rem;
  max-width: 2rem;
  padding: 0.05rem 0.3rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  font-size: 0.62rem;
  line-height: 1.2;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.comp-tabs button.is-active {
  background: var(--comp-primary);
  color: #fff;
  box-shadow: 0 8px 18px color-mix(in srgb, var(--comp-primary) 35%, transparent);
}

.comp-tabs button:active {
  transform: scale(0.98);
}

@media (min-width: 480px) {
  .comp-tabs button {
    gap: 0.4rem;
    padding-inline: 0.55rem;
    font-size: 0.88rem;
  }

  .comp-tabs__full {
    display: inline;
  }

  .comp-tabs__abbr {
    display: none;
  }

  .comp-tabs button em {
    min-width: 1.25rem;
    padding: 0.05rem 0.38rem;
    font-size: 0.68rem;
  }
}

.comp-page__status,
.comp-page__error {
  margin-top: 1.25rem;
  color: var(--comp-muted);
}

.comp-page__error {
  color: #fb7185;
}

.comp-skel {
  margin-top: 1.15rem;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}

.comp-skel__bar,
.comp-skel__hero,
.comp-skel__row,
.comp-skel__cards span {
  display: block;
  border-radius: 16px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.04),
    rgba(255, 255, 255, 0.1),
    rgba(255, 255, 255, 0.04)
  );
  background-size: 200% 100%;
  animation: comp-pulse 1.4s ease-in-out infinite;
}

.comp-skel__bar {
  height: 48px;
}

.comp-skel__hero {
  height: 220px;
  border-radius: 24px;
}

.comp-skel__row {
  height: 76px;
}

.comp-skel__cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
}

.comp-skel__cards span {
  height: 108px;
  border-radius: 18px;
}

.comp-page--light .comp-skel__bar,
.comp-page--light .comp-skel__hero,
.comp-page--light .comp-skel__row,
.comp-page--light .comp-skel__cards span {
  background: linear-gradient(
    90deg,
    rgba(15, 23, 42, 0.05),
    rgba(15, 23, 42, 0.1),
    rgba(15, 23, 42, 0.05)
  );
  background-size: 200% 100%;
}

@keyframes comp-pulse {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

.comp-empty {
  margin-top: 1.35rem;
  padding: 1.5rem 1.25rem;
  border-radius: 24px;
  background: var(--comp-glass);
  backdrop-filter: blur(20px);
  border: 1px solid var(--comp-border);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.18);
}

.comp-empty__icon {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: grid;
  place-items: center;
  background: color-mix(in srgb, var(--comp-primary) 18%, transparent);
  color: var(--comp-primary);
  margin-bottom: 0.85rem;
}

.comp-empty h2 {
  margin: 0 0 0.4rem;
  font-size: 1.15rem;
}

.comp-empty p {
  margin: 0;
  color: var(--comp-muted);
  line-height: 1.55;
}

.comp-empty__cta {
  display: inline-flex;
  margin-top: 1rem;
  min-height: 44px;
  align-items: center;
  padding: 0.55rem 1rem;
  border: 0;
  border-radius: 12px;
  background: var(--comp-primary);
  color: #fff;
  font: inherit;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.25s var(--comp-ease), box-shadow 0.25s var(--comp-ease);
}

.comp-empty__cta:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 22px color-mix(in srgb, var(--comp-primary) 38%, transparent);
}

.comp-empty__cta:active {
  transform: scale(0.97);
}

.comp-championship {
  min-width: 0;
  max-width: 100%;
}

.comp-stage-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 1.25rem;
  min-width: 0;
}

.comp-stage-head > div {
  min-width: 0;
  flex: 1 1 12rem;
}

.comp-stage-head__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.45rem;
  flex: 0 1 auto;
}

.comp-get-results {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  min-height: 40px;
  padding: 0.35rem 0.85rem;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--comp-primary) 55%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-primary) 22%, var(--comp-glass));
  color: inherit;
  font: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: transform 0.25s var(--comp-ease), border-color 0.2s ease, opacity 0.2s ease;
}

.comp-get-results:hover:not(:disabled) {
  transform: translateY(-1px);
}

.comp-get-results:active:not(:disabled) {
  transform: scale(0.97);
}

.comp-get-results:disabled {
  opacity: 0.65;
  cursor: wait;
}

.comp-sync-notice {
  margin: 0.65rem 0 0;
  padding: 0.55rem 0.75rem;
  border-radius: 12px;
  border: 1px solid var(--comp-border);
  background: color-mix(in srgb, var(--comp-home) 12%, var(--comp-glass));
  color: var(--comp-text);
  font-size: 0.82rem;
  font-weight: 550;
}

.comp-stage-head__kicker {
  margin: 0;
  font-size: 0.7rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  font-weight: 700;
  color: var(--comp-muted);
}

.comp-stage-head h2 {
  margin: 0.2rem 0 0;
  font-size: 1.15rem;
  letter-spacing: -0.03em;
}

.comp-browse {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  min-height: 40px;
  padding: 0.35rem 0.7rem;
  border-radius: 999px;
  border: 1px solid var(--comp-border);
  background: var(--comp-glass);
  color: inherit;
  font: inherit;
  font-size: 0.78rem;
  font-weight: 650;
  cursor: pointer;
  white-space: nowrap;
  transition: transform 0.25s var(--comp-ease), border-color 0.2s ease;
}

.comp-browse:hover {
  transform: translateY(-1px);
}

.comp-browse:active {
  transform: scale(0.97);
}

.comp-teams {
  margin: 0.9rem 0 0;
  padding: 0 0 0.35rem;
  max-width: 100%;
  min-width: 0;
}

.comp-teams__slide {
  outline: none;
}

.comp-teams .react-slideshow-container,
.comp-teams .react-slideshow-fadezoom-wrapper,
.comp-teams .react-slideshow-wrapper,
.comp-teams .images-wrap {
  width: 100%;
}

.comp-teams .react-slideshow-container + .indicators {
  display: flex;
  justify-content: center;
  gap: 4px;
  margin-top: 0.35rem;
  padding-bottom: 0.15rem;
}

.comp-teams .indicators .each-slideshow-indicator {
  cursor: pointer;
}

.comp-teams .indicators .each-slideshow-indicator::before {
  background: color-mix(in srgb, var(--comp-primary) 35%, var(--comp-muted)) !important;
}

.comp-teams .indicators .each-slideshow-indicator.active::before {
  background: var(--comp-primary) !important;
}

.comp-teams__card {
  width: calc(100% - 12px);
  min-width: 0;
  max-width: none;
  margin: 6px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0.4rem;
  min-height: 132px;
  height: auto;
  overflow: visible;
  padding: 0.9rem 0.85rem 0.85rem;
  border-radius: 20px;
  border: 1px solid var(--comp-border);
  background: var(--comp-glass);
  backdrop-filter: blur(16px);
  color: inherit;
  text-align: left;
  cursor: pointer;
  font: inherit;
  transition: transform 0.3s var(--comp-ease), border-color 0.2s ease, box-shadow 0.3s var(--comp-ease);
}

.comp-teams__card:hover {
  transform: translateY(-2px);
}

.comp-teams__card:active {
  transform: scale(0.98);
}

.comp-teams__card.is-active {
  border-color: color-mix(in srgb, var(--comp-primary) 65%, transparent);
  box-shadow:
    0 0 0 1px color-mix(in srgb, var(--comp-primary) 30%, transparent),
    0 14px 28px rgba(0, 0, 0, 0.18);
  background: linear-gradient(
      180deg,
      color-mix(in srgb, var(--comp-primary) 18%, transparent),
      transparent 70%
    ),
    var(--comp-glass);
}

.comp-teams__card strong {
  display: block;
  overflow: visible;
  font-size: 0.86rem;
  letter-spacing: -0.02em;
  line-height: 1.35;
  padding-block: 0.12em;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.comp-teams__card em {
  font-style: normal;
  color: var(--comp-muted);
  font-size: 0.72rem;
}

.comp-teams__mine {
  margin-top: auto;
  font-size: 0.62rem;
  font-weight: 750;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--comp-home);
}

.comp-teams__rank {
  font-size: 0.72rem;
  font-weight: 750;
  color: var(--comp-primary);
}

.comp-ladder {
  --ladder-win: var(--comp-home);
  --ladder-draw: var(--comp-away);
  --ladder-loss: var(--comp-loss);
  --ladder-rail: color-mix(in srgb, var(--comp-primary) 72%, #fff);
  margin: 0.95rem 0 0;
  padding: 1rem 0.85rem 0.85rem;
  border-radius: 24px;
  border: 1px solid color-mix(in srgb, var(--comp-primary) 26%, var(--comp-border));
  background:
    linear-gradient(
      165deg,
      color-mix(in srgb, var(--comp-primary) 18%, transparent) 0%,
      transparent 42%
    ),
    radial-gradient(
      90% 70% at 100% 0%,
      color-mix(in srgb, var(--comp-away) 12%, transparent),
      transparent 55%
    ),
    var(--comp-glass);
  backdrop-filter: blur(18px);
  box-shadow:
    0 18px 40px rgba(2, 8, 23, 0.18),
    inset 0 1px 0 color-mix(in srgb, #fff 10%, transparent);
  animation: comp-ladder-in 0.55s var(--comp-ease) both;
}

@keyframes comp-ladder-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .comp-ladder {
    animation: none;
  }
}

.comp-ladder__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
}

.comp-ladder__head-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
}

.comp-ladder__kicker {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin: 0;
  font-size: 0.68rem;
  font-weight: 750;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--comp-muted);
}

.comp-ladder__head h3 {
  margin: 0;
  font-size: 1.12rem;
  font-weight: 800;
  letter-spacing: -0.035em;
  line-height: 1.15;
}

.comp-ladder__lede {
  margin: 0.1rem 0 0;
  font-size: 0.74rem;
  line-height: 1.35;
  color: var(--comp-muted);
}

.comp-ladder__place-chip {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;
  align-content: center;
  justify-items: end;
  gap: 0 0.2rem;
  margin: 0;
  padding: 0.45rem 0.65rem;
  border-radius: 16px;
  border: 1px solid color-mix(in srgb, var(--comp-primary) 35%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-primary) 14%, transparent);
  flex-shrink: 0;
}

.comp-ladder__place-chip > span {
  grid-column: 1 / -1;
  font-size: 0.58rem;
  font-weight: 750;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--comp-muted);
}

.comp-ladder__place-chip strong {
  font-size: 1.45rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.05em;
  line-height: 1;
  color: var(--comp-primary);
}

.comp-ladder__place-chip em {
  font-style: normal;
  font-size: 0.72rem;
  font-weight: 650;
  color: var(--comp-muted);
  align-self: end;
  padding-bottom: 0.12rem;
}

.comp-ladder__us {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 0.65rem 0.8rem;
  margin-bottom: 0.8rem;
  padding: 0.8rem 0.85rem;
  border-radius: 18px;
  position: relative;
  overflow: hidden;
  background:
    linear-gradient(
      118deg,
      color-mix(in srgb, var(--comp-primary) 42%, #07111f) 0%,
      color-mix(in srgb, var(--comp-primary) 18%, transparent) 68%,
      color-mix(in srgb, var(--comp-away) 10%, transparent) 100%
    );
  box-shadow:
    inset 0 0 0 1px color-mix(in srgb, #fff 14%, transparent),
    0 10px 28px color-mix(in srgb, var(--comp-primary) 28%, transparent);
  color: #fff;
  animation: comp-ladder-us 0.65s var(--comp-ease) 0.08s both;
}

.comp-ladder__us::before {
  content: "";
  position: absolute;
  left: 0;
  top: 12%;
  bottom: 12%;
  width: 4px;
  border-radius: 0 4px 4px 0;
  background: #fff;
  box-shadow: 0 0 16px rgba(255, 255, 255, 0.45);
}

@keyframes comp-ladder-us {
  from {
    opacity: 0;
    transform: scale(0.985);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .comp-ladder__us {
    animation: none;
  }
}

.comp-page--light .comp-ladder__us {
  color: var(--comp-text);
  background:
    linear-gradient(
      118deg,
      color-mix(in srgb, var(--comp-primary) 26%, #fff) 0%,
      color-mix(in srgb, var(--comp-primary) 10%, #fff) 70%,
      color-mix(in srgb, var(--comp-away) 8%, #fff) 100%
    );
  box-shadow:
    inset 0 0 0 1px color-mix(in srgb, var(--comp-primary) 30%, transparent),
    0 10px 24px color-mix(in srgb, var(--comp-primary) 14%, transparent);
}

.comp-page--light .comp-ladder__us::before {
  background: var(--comp-primary);
  box-shadow: none;
}

.comp-ladder__us-rank {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 3rem;
  min-height: 3rem;
  padding: 0.3rem 0.4rem;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.14);
  line-height: 1;
}

.comp-page--light .comp-ladder__us-rank {
  background: color-mix(in srgb, var(--comp-primary) 12%, #fff);
}

.comp-ladder__us-rank span {
  font-size: 1.55rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.05em;
}

.comp-ladder__us-rank small {
  margin-top: 0.18rem;
  font-size: 0.56rem;
  font-weight: 750;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  opacity: 0.78;
}

.comp-ladder__us-meta {
  min-width: 0;
}

.comp-ladder__us-tag {
  display: inline-block;
  margin-bottom: 0.18rem;
  padding: 0.12rem 0.42rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  font-size: 0.58rem;
  font-weight: 750;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.comp-page--light .comp-ladder__us-tag {
  background: color-mix(in srgb, var(--comp-primary) 16%, #fff);
  color: var(--comp-primary);
}

.comp-ladder__us-meta strong {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 1.02rem;
  font-weight: 780;
  letter-spacing: -0.02em;
}

.comp-ladder__us-meta em {
  display: block;
  margin-top: 0.14rem;
  font-style: normal;
  font-size: 0.72rem;
  opacity: 0.84;
}

.comp-ladder__us-stats {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.35rem;
  margin: 0;
}

.comp-ladder__us-stats > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.15rem;
  padding: 0.38rem 0.2rem 0.42rem;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.comp-page--light .comp-ladder__us-stats > div {
  background: rgba(255, 255, 255, 0.72);
  border-color: color-mix(in srgb, var(--comp-primary) 12%, transparent);
}

.comp-ladder__us-stats dt {
  margin: 0;
  font-size: 0.58rem;
  font-weight: 750;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.78;
}

.comp-ladder__us-stats dd {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}

.comp-ladder__us-stats .is-win dt,
.comp-ladder__us-stats .is-win dd {
  color: var(--ladder-win);
}

.comp-ladder__us-stats .is-draw dt,
.comp-ladder__us-stats .is-draw dd {
  color: var(--ladder-draw);
}

.comp-ladder__us-stats .is-loss dt,
.comp-ladder__us-stats .is-loss dd {
  color: var(--ladder-loss);
}

.comp-ladder__us-stats .is-pts {
  background: color-mix(in srgb, var(--comp-primary) 35%, rgba(0, 0, 0, 0.18));
}

.comp-page--light .comp-ladder__us-stats .is-pts {
  background: color-mix(in srgb, var(--comp-primary) 18%, #fff);
}

.comp-ladder__us-stats .is-pts dd {
  font-size: 1.2rem;
  color: inherit;
}

.comp-ladder__board {
  border-radius: 16px;
  border: 1px solid var(--comp-border);
  background: color-mix(in srgb, var(--comp-slate) 70%, transparent);
  overflow: hidden;
  max-height: 22rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.comp-ladder__table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.78rem;
}

.comp-ladder__caption {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.comp-ladder__table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0.55rem 0.35rem;
  background: color-mix(in srgb, var(--comp-slate) 92%, var(--comp-primary));
  border-bottom: 1px solid var(--comp-border);
  font-size: 0.62rem;
  font-weight: 750;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--comp-muted);
  text-align: center;
  white-space: nowrap;
}

.comp-page--light .comp-ladder__table thead th {
  background: color-mix(in srgb, #fff 88%, var(--comp-primary));
}

.comp-ladder__table thead th abbr {
  text-decoration: none;
  cursor: help;
}

.comp-ladder__th-team {
  text-align: left !important;
  padding-left: 0.55rem !important;
}

.comp-ladder__th-pos {
  width: 2.4rem;
}

.comp-ladder__th-num {
  width: 1.85rem;
}

.comp-ladder__th-pts {
  width: 2.35rem;
  padding-right: 0.55rem !important;
  text-align: right !important;
}

.comp-ladder__table thead th.is-win {
  color: var(--ladder-win);
}

.comp-ladder__table thead th.is-draw {
  color: var(--ladder-draw);
}

.comp-ladder__table thead th.is-loss {
  color: var(--ladder-loss);
}

.comp-ladder__row td {
  padding: 0.48rem 0.35rem;
  border-bottom: 1px solid color-mix(in srgb, var(--comp-border) 80%, transparent);
  vertical-align: middle;
  transition: background 0.22s var(--comp-ease);
}

.comp-ladder__row:last-child td {
  border-bottom: 0;
}

.comp-ladder__row:hover td {
  background: color-mix(in srgb, var(--comp-primary) 8%, transparent);
}

.comp-ladder__pos {
  text-align: center;
  font-variant-numeric: tabular-nums;
  font-weight: 760;
  color: var(--comp-muted);
}

.comp-ladder__pos span {
  display: inline-grid;
  place-items: center;
  min-width: 1.55rem;
  height: 1.55rem;
  border-radius: 8px;
  background: color-mix(in srgb, var(--comp-muted) 12%, transparent);
  font-size: 0.78rem;
}

.comp-ladder__row.is-podium .comp-ladder__pos span {
  color: #fbbf24;
  background: color-mix(in srgb, #fbbf24 16%, transparent);
}

.comp-ladder__name {
  max-width: 0;
  width: 100%;
  padding-left: 0.45rem !important;
}

.comp-ladder__name span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 650;
  letter-spacing: -0.01em;
}

.comp-ladder__name em {
  display: block;
  margin-top: 0.08rem;
  font-style: normal;
  font-size: 0.58rem;
  font-weight: 750;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--comp-primary);
}

.comp-ladder__num {
  text-align: center;
  font-variant-numeric: tabular-nums;
  font-weight: 650;
  color: var(--comp-muted);
}

.comp-ladder__num.is-win {
  color: var(--ladder-win);
  font-weight: 750;
}

.comp-ladder__num.is-draw {
  color: var(--ladder-draw);
}

.comp-ladder__num.is-loss {
  color: var(--ladder-loss);
}

.comp-ladder__pts {
  padding-right: 0.55rem !important;
  text-align: right;
  font-variant-numeric: tabular-nums;
  font-weight: 820;
  font-size: 0.9rem;
  letter-spacing: -0.02em;
}

.comp-ladder__row.is-us td {
  background: color-mix(in srgb, var(--comp-primary) 18%, transparent);
}

.comp-ladder__row.is-us td:first-child {
  box-shadow: inset 3px 0 0 var(--ladder-rail);
}

.comp-ladder__row.is-us .comp-ladder__pos span {
  background: var(--comp-primary);
  color: #fff;
  font-weight: 800;
}

.comp-ladder__row.is-us .comp-ladder__name span {
  font-weight: 780;
}

.comp-ladder__row.is-us .comp-ladder__pts {
  color: var(--comp-primary);
  font-size: 0.98rem;
}

.comp-page--light .comp-ladder__row.is-us td {
  background: color-mix(in srgb, var(--comp-primary) 12%, #fff);
}

.comp-ladder__legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  list-style: none;
  margin: 0.75rem 0 0;
  padding: 0;
}

.comp-ladder__legend li {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.28rem 0.48rem;
  border-radius: 999px;
  border: 1px solid var(--comp-border);
  background: color-mix(in srgb, var(--comp-slate) 55%, transparent);
  font-size: 0.62rem;
  color: var(--comp-muted);
  line-height: 1.25;
}

.comp-ladder__legend strong {
  font-weight: 800;
  letter-spacing: 0.04em;
  color: var(--comp-text);
}

.comp-ladder__legend strong.is-win {
  color: var(--ladder-win);
}

.comp-ladder__legend strong.is-draw {
  color: var(--ladder-draw);
}

.comp-ladder__legend strong.is-loss {
  color: var(--ladder-loss);
}

@media (min-width: 420px) {
  .comp-ladder__us {
    grid-template-columns: auto minmax(0, 1fr) auto;
  }

  .comp-ladder__us-stats {
    grid-column: auto;
    width: min(11.5rem, 42vw);
  }
}

.comp-browse-note {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin: 0.85rem 0 0;
  padding: 0.7rem 0.8rem;
  border-radius: 16px;
  border: 1px dashed var(--comp-border);
  color: var(--comp-muted);
  font-size: 0.86rem;
}

.comp-browse-note span {
  min-width: 0;
  flex: 1 1;
}

.comp-browse-note em {
  display: block;
  font-style: normal;
  font-size: 0.75rem;
}

.comp-browse-note button {
  border: 0;
  background: color-mix(in srgb, var(--comp-primary) 16%, transparent);
  color: inherit;
  border-radius: 999px;
  padding: 0.4rem 0.7rem;
  font: inherit;
  font-size: 0.75rem;
  font-weight: 700;
  cursor: pointer;
}

.comp-team-chip {
  width: 100%;
  margin-top: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.95rem 1rem;
  border-radius: 18px;
  border: 1px solid var(--comp-border);
  background: var(--comp-glass);
  backdrop-filter: blur(18px);
  color: inherit;
  text-align: left;
  cursor: pointer;
  transition: transform 0.3s var(--comp-ease), border-color 0.2s ease;
}

.comp-team-chip:hover {
  transform: translateY(-1px);
}

.comp-team-chip:active {
  transform: scale(0.98);
}

.comp-team-chip__main {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}

.comp-team-chip__main > span {
  min-width: 0;
}

.comp-team-chip strong {
  display: block;
  font-size: 1.05rem;
}

.comp-team-chip em {
  display: block;
  font-style: normal;
  color: var(--comp-muted);
  font-size: 0.82rem;
  margin-top: 0.15rem;
}

.comp-days {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  overflow: visible;
  margin: 1rem 0 0;
  padding: 0;
}

.comp-days button {
  flex: 0 0 auto;
  min-height: 36px;
  border: 1px solid var(--comp-border);
  background: rgba(255, 255, 255, 0.04);
  color: var(--comp-muted);
  border-radius: 999px;
  padding: 0.42rem 0.8rem;
  font: inherit;
  font-size: 0.78rem;
  font-weight: 650;
  cursor: pointer;
  transition: all 0.25s var(--comp-ease);
}

.comp-days button.is-active {
  background: var(--comp-primary);
  border-color: transparent;
  color: #fff;
}

.comp-stage {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.comp-stage__primary {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
}

.comp-tour-inscribe {
  padding: 1.1rem 1.05rem 1rem;
  border-radius: 24px;
  border: 1px solid var(--comp-border);
  background:
    linear-gradient(
      165deg,
      color-mix(in srgb, var(--comp-primary) 14%, transparent),
      transparent 48%
    ),
    var(--comp-glass);
  backdrop-filter: blur(14px);
}

.comp-tour-inscribe__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.35rem;
}

.comp-tour-inscribe__kicker {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin: 0;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--comp-muted);
}

.comp-tour-inscribe__open {
  border: 1px solid color-mix(in srgb, var(--comp-primary) 45%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-primary) 16%, transparent);
  color: inherit;
  font: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  border-radius: 999px;
  padding: 0.3rem 0.75rem;
  cursor: pointer;
}

.comp-tour-inscribe__open:hover {
  border-color: color-mix(in srgb, var(--comp-primary) 70%, var(--comp-border));
}

.comp-tour-inscribe h3 {
  margin: 0;
  font-size: 1.05rem;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.comp-tour-inscribe__meta {
  margin: 0.25rem 0 0.75rem;
  color: var(--comp-muted);
  font-size: 0.86rem;
}

.comp-tour-inscribe__date {
  font-weight: 750;
  color: color-mix(in srgb, var(--comp-primary) 78%, var(--comp-muted));
}

.comp-tour-inscribe__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.comp-tour-inscribe__list > li {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  padding: 0.55rem 0.6rem;
  border-radius: 14px;
  border: 1px solid color-mix(in srgb, var(--comp-border) 80%, transparent);
  background: color-mix(in srgb, var(--comp-glass) 70%, transparent);
}

.comp-tour-inscribe__cats {
  list-style: none;
  margin: 0;
  padding: 0 0 0 2.35rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.comp-tour-inscribe__cats li {
  font-size: 0.78rem;
  font-weight: 650;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  border: 1px solid var(--comp-border);
  color: var(--comp-muted);
}

.comp-tour-inscribe__cats li.is-in {
  border-color: color-mix(in srgb, var(--comp-home) 45%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-home) 14%, transparent);
  color: inherit;
}

.comp-tour-inscribe__cats li.is-maybe {
  border-color: color-mix(in srgb, var(--comp-away) 40%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-away) 12%, transparent);
  color: inherit;
}

.comp-stage__primary > .comp-next {
  margin-top: 0;
}

.comp-next {
  margin-top: 1.15rem;
  padding: 1.25rem 1.15rem 1.15rem;
  border-radius: 24px;
  border: 1px solid var(--comp-border);
  background:
    linear-gradient(
      165deg,
      color-mix(in srgb, var(--comp-primary) 22%, transparent),
      transparent 46%
    ),
    var(--comp-glass);
  backdrop-filter: blur(20px);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.2);
}

.comp-next__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
}

.comp-next__top-end {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  flex-shrink: 0;
}

.comp-next__score-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  min-height: 2rem;
  padding: 0.22rem 0.65rem;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--comp-primary) 40%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-primary) 16%, var(--comp-glass));
  color: var(--comp-text);
  font-variant-numeric: tabular-nums;
  line-height: 1;
}

.comp-next__score-badge strong {
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.comp-score-sets {
  display: block;
  margin: 0.08rem 0 0;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  opacity: 0.78;
}

.comp-next__score-badge .comp-score-sets,
.comp-row__score-corner .comp-score-sets {
  display: inline;
  margin: 0 0 0 0.35rem;
  text-transform: none;
  letter-spacing: 0.01em;
  font-variant-numeric: tabular-nums;
}

.comp-next__live-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  margin: 0;
  font-style: normal;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #fecaca;
}

.comp-next__live-tag::before {
  content: "";
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 999px;
  background: #ef4444;
  box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.55);
  animation: comp-live-pulse 1.4s ease-out infinite;
}

.comp-next__score-badge.is-live {
  border-color: color-mix(in srgb, #ef4444 55%, transparent);
  background: color-mix(in srgb, #ef4444 18%, var(--comp-glass));
  color: #fecaca;
  box-shadow: 0 0 0 1px color-mix(in srgb, #ef4444 25%, transparent);
}

.comp-next__score-badge.is-final.is-win {
  border-color: color-mix(in srgb, var(--comp-home) 45%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-home) 18%, var(--comp-glass));
  color: var(--comp-home);
}

.comp-next__score-badge.is-final.is-loss {
  border-color: color-mix(in srgb, var(--comp-loss) 48%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-loss) 16%, var(--comp-glass));
  color: var(--comp-loss);
}

.comp-next__score-badge.is-final.is-draw {
  border-color: color-mix(in srgb, var(--comp-muted) 40%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-muted) 14%, var(--comp-glass));
  color: var(--comp-muted);
}

.comp-page--light .comp-next__score-badge.is-live {
  color: #b91c1c;
  background: color-mix(in srgb, #dc2626 12%, #fff);
}

.comp-page--light .comp-next__live-tag {
  color: #b91c1c;
}

@keyframes comp-live-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.55);
  }
  70% {
    box-shadow: 0 0 0 0.55rem rgba(239, 68, 68, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0);
  }
}

.comp-next__label {
  margin: 0;
  font-size: 0.72rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  font-weight: 700;
  color: var(--comp-muted);
}

.comp-next__when {
  border-radius: 999px;
  padding: 0.18rem 0.55rem;
  background: color-mix(in srgb, var(--comp-home) 16%, transparent);
  color: var(--comp-home);
  font-size: 0.7rem;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.comp-next__rec {
  position: relative;
  width: 2.5rem;
  height: 2.5rem;
  margin: 0;
  padding: 0;
  display: grid;
  place-items: center;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--comp-primary) 40%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-primary) 16%, transparent);
  color: var(--comp-text);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform 0.2s var(--comp-ease), background 0.2s ease, border-color 0.2s ease;
}

.comp-next__rec:hover:not(:disabled),
.comp-next__rec:focus-visible {
  background: color-mix(in srgb, var(--comp-primary) 28%, transparent);
  border-color: color-mix(in srgb, var(--comp-primary) 55%, transparent);
  outline: none;
}

.comp-next__rec:active:not(:disabled) {
  transform: scale(0.94);
}

.comp-next__rec:disabled {
  opacity: 0.5;
  cursor: wait;
}

.comp-next__rec.is-live {
  border-color: color-mix(in srgb, #ef4444 55%, transparent);
  background: color-mix(in srgb, #ef4444 18%, transparent);
  color: #fecaca;
}

.comp-page--light .comp-next__rec {
  border-color: color-mix(in srgb, var(--comp-primary) 55%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-primary) 14%, #fff);
  color: var(--comp-primary);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.comp-page--light .comp-next__rec:hover:not(:disabled),
.comp-page--light .comp-next__rec:focus-visible {
  background: color-mix(in srgb, var(--comp-primary) 22%, #fff);
  border-color: color-mix(in srgb, var(--comp-primary) 70%, transparent);
}

.comp-page--light .comp-next__rec.is-live {
  border-color: color-mix(in srgb, #dc2626 65%, transparent);
  background: color-mix(in srgb, #dc2626 12%, #fff);
  color: #b91c1c;
}

.comp-next__rec.is-live::before {
  content: "";
  position: absolute;
  top: 0.35rem;
  right: 0.35rem;
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 999px;
  background: #ef4444;
  box-shadow: 0 0 0 2px color-mix(in srgb, #ef4444 25%, transparent);
}

.comp-page--light .comp-next__rec.is-live::before {
  background: #dc2626;
  box-shadow: 0 0 0 2px color-mix(in srgb, #dc2626 20%, #fff);
}

.comp-next__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.45rem;
  color: var(--comp-muted);
  font-size: 0.86rem;
  min-width: 0;
}

.comp-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--comp-muted);
}

.comp-next__matchup {
  margin: 1rem 0 0.55rem;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: start;
  gap: 0.55rem;
  font-size: 0.92rem;
  letter-spacing: -0.02em;
}

.comp-next__side {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  min-width: 0;
  text-align: center;
}

.comp-next__names {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.12rem;
  min-width: 0;
  max-width: 100%;
}

.comp-next__club-name {
  font-size: 0.88rem;
  font-weight: 700;
  line-height: 1.3;
  display: block;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.comp-next__team-name {
  margin: 0;
  font-size: 0.72rem;
  font-style: normal;
  font-weight: 650;
  line-height: 1.25;
  color: var(--comp-muted);
  overflow-wrap: anywhere;
}

.comp-next__club {
  appearance: none;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  max-width: 100%;
  cursor: pointer;
  text-align: center;
  border-radius: 16px;
}

.comp-next__club:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 3px;
}

.comp-next__club:active {
  transform: scale(0.98);
}

.comp-next__side strong.comp-next__club-name,
.comp-next__club strong {
  font-size: 0.88rem;
  font-weight: 700;
  line-height: 1.35;
  display: block;
  overflow: visible;
  padding-block: 0.12em;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.comp-next__vs {
  display: grid;
  place-items: center;
  align-self: start;
  margin-top: 1.15rem;
  min-width: 42px;
  height: 42px;
  padding: 0 0.35rem;
  border-radius: 50%;
  border: 1px solid var(--comp-border);
  background: rgba(255, 255, 255, 0.04);
  color: var(--comp-muted);
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.comp-next__vs.comp-next__score {
  width: auto;
  min-width: 52px;
  border-radius: 14px;
  letter-spacing: 0.02em;
  text-transform: none;
  font-size: 1rem;
  font-variant-numeric: tabular-nums;
  color: inherit;
  background: color-mix(in srgb, var(--comp-primary) 18%, var(--comp-glass));
  border-color: color-mix(in srgb, var(--comp-primary) 40%, var(--comp-border));
}

.comp-next__vs.comp-next__score.is-final {
  background: color-mix(in srgb, var(--comp-home) 22%, var(--comp-glass));
  border-color: color-mix(in srgb, var(--comp-home) 45%, var(--comp-border));
}

.comp-next__vs.comp-next__score.is-final.is-win {
  background: color-mix(in srgb, var(--comp-home) 22%, var(--comp-glass));
  border-color: color-mix(in srgb, var(--comp-home) 45%, var(--comp-border));
  color: var(--comp-home);
}

.comp-next__vs.comp-next__score.is-final.is-loss {
  background: color-mix(in srgb, var(--comp-loss) 20%, var(--comp-glass));
  border-color: color-mix(in srgb, var(--comp-loss) 48%, var(--comp-border));
  color: var(--comp-loss);
}

.comp-next__vs.comp-next__score.is-final.is-draw {
  background: color-mix(in srgb, var(--comp-muted) 18%, var(--comp-glass));
  border-color: color-mix(in srgb, var(--comp-muted) 40%, var(--comp-border));
  color: var(--comp-muted);
}

.comp-next__vs.comp-next__score.is-live {
  background: color-mix(in srgb, #ef4444 18%, var(--comp-glass));
  border-color: color-mix(in srgb, #ef4444 50%, var(--comp-border));
}

.comp-next.has-score {
  cursor: pointer;
}

.comp-next.is-past,
.comp-next.is-final {
  border-color: color-mix(in srgb, var(--comp-home) 42%, var(--comp-border));
  background:
    linear-gradient(
      165deg,
      color-mix(in srgb, var(--comp-home) 18%, transparent),
      transparent 48%
    ),
    var(--comp-glass);
}

.comp-next.is-final.is-win,
.comp-next.is-past.is-win {
  border-color: color-mix(in srgb, var(--comp-home) 42%, var(--comp-border));
  background:
    linear-gradient(
      165deg,
      color-mix(in srgb, var(--comp-home) 18%, transparent),
      transparent 48%
    ),
    var(--comp-glass);
}

.comp-next.is-final.is-loss,
.comp-next.is-past.is-loss {
  border-color: color-mix(in srgb, var(--comp-loss) 46%, var(--comp-border));
  background:
    linear-gradient(
      165deg,
      color-mix(in srgb, var(--comp-loss) 18%, transparent),
      transparent 48%
    ),
    var(--comp-glass);
}

.comp-next.is-final.is-draw,
.comp-next.is-past.is-draw {
  border-color: color-mix(in srgb, var(--comp-muted) 36%, var(--comp-border));
  background:
    linear-gradient(
      165deg,
      color-mix(in srgb, var(--comp-muted) 14%, transparent),
      transparent 48%
    ),
    var(--comp-glass);
}

.comp-next.is-waiting {
  border-color: color-mix(in srgb, var(--comp-away) 40%, var(--comp-border));
  background:
    linear-gradient(
      165deg,
      color-mix(in srgb, var(--comp-away) 16%, transparent),
      transparent 48%
    ),
    var(--comp-glass);
}

.comp-next.is-live {
  border-color: color-mix(in srgb, #ef4444 62%, var(--comp-border));
  box-shadow:
    0 0 0 1px color-mix(in srgb, #ef4444 35%, transparent),
    0 18px 40px rgba(0, 0, 0, 0.22),
    0 0 28px color-mix(in srgb, #ef4444 22%, transparent);
  background:
    linear-gradient(
      165deg,
      color-mix(in srgb, #ef4444 22%, transparent),
      transparent 52%
    ),
    var(--comp-glass);
  animation: comp-live-card-glow 2.4s ease-in-out infinite;
}

@keyframes comp-live-card-glow {
  0%,
  100% {
    box-shadow:
      0 0 0 1px color-mix(in srgb, #ef4444 35%, transparent),
      0 18px 40px rgba(0, 0, 0, 0.22),
      0 0 22px color-mix(in srgb, #ef4444 18%, transparent);
  }
  50% {
    box-shadow:
      0 0 0 2px color-mix(in srgb, #ef4444 48%, transparent),
      0 18px 44px rgba(0, 0, 0, 0.24),
      0 0 36px color-mix(in srgb, #ef4444 30%, transparent);
  }
}

.comp-page--light .comp-next.is-live {
  background:
    linear-gradient(
      165deg,
      color-mix(in srgb, #dc2626 12%, transparent),
      transparent 52%
    ),
    var(--comp-glass);
}

.comp-next.is-final .comp-next__label,
.comp-next.is-past .comp-next__label {
  color: var(--comp-home);
}

.comp-next.is-final.is-win .comp-next__label,
.comp-next.is-past.is-win .comp-next__label {
  color: var(--comp-home);
}

.comp-next.is-final.is-loss .comp-next__label,
.comp-next.is-past.is-loss .comp-next__label {
  color: var(--comp-loss);
}

.comp-next.is-final.is-draw .comp-next__label,
.comp-next.is-past.is-draw .comp-next__label {
  color: var(--comp-muted);
}

.comp-next.is-waiting .comp-next__label {
  color: var(--comp-away);
}

.comp-next.is-live .comp-next__label {
  color: #fecaca;
}

.comp-page--light .comp-next.is-live .comp-next__label {
  color: #b91c1c;
}

.comp-next__when.is-past {
  background: color-mix(in srgb, var(--comp-home) 16%, transparent);
  color: var(--comp-home);
}

.comp-next.is-loss .comp-next__when.is-past {
  background: color-mix(in srgb, var(--comp-loss) 16%, transparent);
  color: var(--comp-loss);
}

.comp-results-note {
  margin: 0.75rem 0 0;
  padding: 0.55rem 0.7rem;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--comp-away) 38%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-away) 12%, var(--comp-glass));
  color: var(--comp-text);
  font-size: 0.8rem;
  font-weight: 550;
  line-height: 1.4;
  text-align: left;
}

.comp-results-note.is-later {
  border-color: color-mix(in srgb, var(--comp-away) 50%, var(--comp-border));
}

.comp-next[role="button"] {
  cursor: pointer;
}

.comp-row__score {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.15rem;
  min-width: 2.6rem;
  padding: 0.2rem 0.5rem;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--comp-home) 40%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-home) 16%, transparent);
  font-size: 0.82rem;
  font-weight: 750;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
}

.comp-row__score.is-win {
  border-color: color-mix(in srgb, var(--comp-home) 40%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-home) 16%, transparent);
  color: var(--comp-home);
}

.comp-row__score.is-loss {
  border-color: color-mix(in srgb, var(--comp-loss) 45%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-loss) 16%, transparent);
  color: var(--comp-loss);
}

.comp-row__score.is-draw {
  border-color: color-mix(in srgb, var(--comp-muted) 40%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-muted) 14%, transparent);
  color: var(--comp-muted);
}

.comp-row.has-score {
  cursor: pointer;
}

.comp-row__waiting {
  display: inline-flex;
  align-items: center;
  margin-top: 0.15rem;
  padding: 0.18rem 0.5rem;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--comp-away) 40%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-away) 14%, transparent);
  color: var(--comp-away);
  font-size: 0.68rem;
  font-weight: 750;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.comp-next__venue {
  margin: 0.15rem 0 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.comp-page .comp-club-logo {
  object-fit: contain;
  background: #fff;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.16);
}

.comp-page .comp-club-logo.club-logo-mark--md {
  width: 72px;
  height: 72px;
  border-radius: 20px;
  padding: 7px;
  border: 0;
}

.comp-page .comp-club-logo.club-logo-mark--sm {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  padding: 3px;
}

.comp-page .comp-club-logo.club-logo-mark--fallback {
  background: color-mix(in srgb, var(--comp-primary) 22%, transparent);
  color: var(--comp-primary);
  box-shadow: none;
  padding: 0;
}

.comp-page .comp-club-logo.club-logo-mark--fallback.club-logo-mark--letter {
  background:
    radial-gradient(
      120% 90% at 18% 12%,
      color-mix(in srgb, #fff 28%, transparent),
      transparent 55%
    ),
    linear-gradient(
      145deg,
      color-mix(in srgb, var(--comp-primary) 88%, #0b3d66) 0%,
      var(--comp-primary) 52%,
      color-mix(in srgb, var(--comp-primary) 60%, #0ea5e9) 100%
    );
  color: #fff;
  border: 1px solid color-mix(in srgb, var(--comp-primary) 40%, #fff);
  box-shadow: 0 6px 14px color-mix(in srgb, var(--comp-primary) 22%, transparent);
}

.comp-page .comp-club-logo.club-logo-mark--sm .club-logo-mark__letter {
  font-size: 0.95rem;
}

.comp-page .comp-club-logo.club-logo-mark--md .club-logo-mark__letter {
  font-size: 1.65rem;
}

.comp-next__div {
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: var(--comp-muted);
  font-size: 0.88rem;
}

.pill {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 0.18rem 0.55rem;
  font-size: 0.68rem;
  font-weight: 750;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.pill--home {
  background: rgba(52, 211, 153, 0.16);
  color: var(--comp-home);
}

.pill--away {
  background: rgba(251, 191, 36, 0.16);
  color: var(--comp-away);
}

.comp-rsvp {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.75rem;
}

.comp-rsvp__btn {
  flex: 1 1;
  min-width: 0;
  min-height: 36px;
  border: 1px solid var(--comp-border);
  background: rgba(255, 255, 255, 0.04);
  color: var(--comp-text);
  border-radius: 999px;
  padding: 0.4rem 0.7rem;
  font: inherit;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: transform 0.25s var(--comp-ease), background 0.2s ease, border-color 0.2s ease;
}

.comp-rsvp__btn:active {
  transform: scale(0.97);
}

.comp-rsvp__btn.is-in {
  background: rgba(52, 211, 153, 0.18);
  border-color: color-mix(in srgb, var(--comp-in) 45%, transparent);
  color: var(--comp-in);
}

.comp-rsvp__btn.is-out {
  background: rgba(251, 113, 133, 0.16);
  border-color: color-mix(in srgb, var(--comp-out) 45%, transparent);
  color: var(--comp-out);
}

.comp-rsvp__btn.is-maybe {
  background: rgba(251, 191, 36, 0.16);
  border-color: color-mix(in srgb, var(--comp-away) 45%, transparent);
  color: var(--comp-away);
}

.comp-lineup {
  margin-top: 1rem;
}

.comp-lineup--side {
  margin-top: 0.35rem;
  width: 100%;
  text-align: left;
}

.comp-lineup--side .comp-lineup__label {
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 0.3rem;
  font-size: 0.66rem;
}

.comp-lineup__side-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
  width: 100%;
}

.comp-lineup__side-list li {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  min-width: 0;
  padding: 0.22rem 0;
  border-bottom: 1px solid var(--comp-border);
  font-size: 0.72rem;
  line-height: 1.25;
}

.comp-lineup__side-list li img,
.comp-lineup__initials {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  flex: 0 0 auto;
  object-fit: cover;
}

.comp-lineup__initials {
  display: grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid var(--comp-border);
  font-size: 0.55rem;
  font-weight: 700;
  color: var(--comp-muted);
}

.comp-lineup__side-list li strong {
  font-size: 0.72rem;
  font-weight: 650;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.comp-lineup__side-list li.is-out {
  opacity: 0.55;
}

.comp-lineup__side-list li.is-in strong {
  color: var(--comp-home, #34d399);
}

.comp-lineup__label {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin: 0 0 0.45rem;
  color: var(--comp-muted);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.comp-mates {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  list-style: none;
  margin: 0;
  padding: 0;
  max-width: 100%;
  min-width: 0;
}

.comp-mates__item {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  display: grid;
  place-items: center;
  font-size: 0.68rem;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.08);
  border: 2px solid transparent;
}

.comp-mates__item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.comp-mates__item.is-in {
  border-color: var(--comp-in);
}

.comp-mates__item.is-out {
  border-color: var(--comp-out);
  opacity: 0.7;
}

.comp-presence-block {
  margin: 0.65rem 0 0;
}

.comp-presence__label {
  margin: 0 0 0.35rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--comp-muted);
}

.comp-presence-phase {
  margin-top: 0.65rem;
  padding-top: 0.55rem;
  border-top: 1px dashed var(--comp-border);
}

.comp-presence {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.comp-presence__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 0.45rem;
  padding: 0.28rem 0;
  border-bottom: 1px solid var(--comp-border);
  min-width: 0;
}

.comp-presence__who {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  min-width: 0;
  flex: 1 1 auto;
}

.comp-presence__who img,
.comp-presence__ini {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.comp-presence__ini {
  display: grid;
  place-items: center;
  font-size: 0.62rem;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.08);
}

.comp-presence__who strong {
  font-size: 0.82rem;
  font-weight: 650;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.comp-presence__cls {
  flex-shrink: 0;
  font-size: 0.68rem;
  font-weight: 700;
  font-style: normal;
  letter-spacing: 0.03em;
  color: var(--comp-muted);
  border: 1px solid var(--comp-border);
  border-radius: 4px;
  padding: 0.08rem 0.28rem;
}

.comp-presence__hint {
  margin: 0 0 0.35rem;
  font-size: 0.72rem;
  line-height: 1.35;
  color: var(--comp-muted);
}

.comp-presence__row.is-alt {
  opacity: 0.95;
}

.comp-presence__acts {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.25rem;
  flex: 0 0 auto;
}

.comp-presence__acts button {
  min-height: 30px;
  border: 1px solid var(--comp-border);
  background: rgba(255, 255, 255, 0.04);
  color: var(--comp-muted);
  border-radius: 999px;
  padding: 0.2rem 0.55rem;
  font: inherit;
  font-size: 0.68rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  line-height: 1.1;
}

.comp-presence__acts button:active {
  transform: scale(0.97);
}

.comp-opp-preview {
  margin: 0.75rem 0 0;
  padding-top: 0.65rem;
  border-top: 1px dashed var(--comp-border);
  text-align: left;
  width: 100%;
}

.comp-opp-preview.is-embedded {
  margin: 0.35rem 0 0;
  padding-top: 0;
  border-top: 0;
}

.comp-opp-preview.is-embedded .comp-opp-preview__label {
  font-size: 0.66rem;
}

.comp-opp-preview.is-embedded .comp-opp-preview__who strong {
  font-size: 0.72rem;
}

.comp-opp-preview.is-embedded .comp-opp-preview__who small {
  font-size: 0.62rem;
}

.comp-opp-preview.is-embedded .comp-opp-preview__acts button {
  font-size: 0.62rem;
  padding: 0.18rem 0.4rem;
}

.comp-opp-preview__label {
  margin: 0 0 0.35rem;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--comp-muted);
}

.comp-opp-preview__label span {
  font-weight: 650;
  letter-spacing: 0.02em;
  text-transform: none;
  color: var(--comp-primary);
}

.comp-opp-preview.is-last-match .comp-opp-preview__label span {
  padding: 0.1rem 0.4rem;
  border-radius: 999px;
  background: color-mix(in srgb, var(--comp-primary) 16%, transparent);
}

.comp-opp-preview__source {
  margin: -0.15rem 0 0.4rem;
  font-size: 0.68rem;
  line-height: 1.35;
  color: var(--comp-muted);
}

.comp-opp-preview__list {
  list-style: none;
  margin: 0 0 0.55rem;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.comp-opp-preview__list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.45rem;
  padding: 0.28rem 0;
  border-bottom: 1px solid var(--comp-border);
  min-width: 0;
}

.comp-opp-preview__who {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1 auto;
}

.comp-opp-preview__who strong {
  font-size: 0.84rem;
  font-weight: 650;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.comp-opp-preview__who small {
  color: var(--comp-muted);
  font-size: 0.7rem;
}

.comp-opp-preview__memory {
  list-style: none;
  margin: 0.28rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.comp-opp-preview__memory li {
  border: 0;
  border-bottom: 0;
  padding: 0.28rem 0.35rem;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.04);
  display: flex;
  flex-direction: column;
  gap: 0.08rem;
  align-items: flex-start;
  justify-content: flex-start;
}

.comp-opp-preview__memory li.is-note {
  background: color-mix(in srgb, #a78bfa 12%, transparent);
}

.comp-opp-preview__memory li.is-feedback {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, transparent);
}

.comp-opp-preview__memory em {
  font-style: normal;
  font-size: 0.58rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--comp-muted);
}

.comp-opp-preview__memory span {
  font-size: 0.7rem;
  font-weight: 650;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.comp-opp-preview__acts {
  display: inline-flex;
  flex: 0 0 auto;
  gap: 0.25rem;
}

.comp-opp-preview__acts button {
  min-height: 30px;
  border: 1px solid var(--comp-border);
  background: rgba(255, 255, 255, 0.04);
  color: var(--comp-muted);
  border-radius: 999px;
  padding: 0.2rem 0.55rem;
  font: inherit;
  font-size: 0.68rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}

.comp-opp-preview__acts button.is-in {
  background: rgba(52, 211, 153, 0.18);
  border-color: color-mix(in srgb, var(--comp-in) 45%, transparent);
  color: var(--comp-in);
}

.comp-opp-preview__acts button.is-out {
  background: rgba(251, 113, 133, 0.16);
  border-color: color-mix(in srgb, var(--comp-out) 45%, transparent);
  color: var(--comp-out);
}

.comp-opp-preview__acts button.is-icon {
  width: 1.7rem;
  height: 1.7rem;
  min-width: 1.7rem;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.comp-opp-preview.is-embedded .comp-opp-preview__acts button.is-icon {
  width: 1.55rem;
  height: 1.55rem;
  min-width: 1.55rem;
  padding: 0;
  font-size: 0;
}

.comp-opp-preview__hint {
  margin: 0.15rem 0 0;
  color: var(--comp-muted);
  font-size: 0.72rem;
  line-height: 1.35;
}

.comp-presence__row.is-phase-out {
  opacity: 0.78;
}

.comp-presence__acts button.is-phase {
  border-color: color-mix(in srgb, var(--comp-out) 55%, var(--comp-border));
  color: var(--comp-out);
}

.comp-presence__acts button.is-in {
  background: rgba(52, 211, 153, 0.18);
  border-color: color-mix(in srgb, var(--comp-in) 45%, transparent);
  color: var(--comp-in);
}

.comp-presence__acts button.is-out {
  background: rgba(251, 113, 133, 0.16);
  border-color: color-mix(in srgb, var(--comp-out) 45%, transparent);
  color: var(--comp-out);
}

.comp-presence__status {
  flex: 0 0 auto;
  min-height: 28px;
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 0.18rem 0.55rem;
  font-size: 0.68rem;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border: 1px solid var(--comp-border);
  color: var(--comp-muted);
}

.comp-presence__status.is-in {
  background: rgba(52, 211, 153, 0.18);
  border-color: color-mix(in srgb, var(--comp-in) 45%, transparent);
  color: var(--comp-in);
}

.comp-presence__status.is-out {
  background: rgba(251, 113, 133, 0.16);
  border-color: color-mix(in srgb, var(--comp-out) 45%, transparent);
  color: var(--comp-out);
}

.comp-presence__row.is-in {
  border-color: color-mix(in srgb, var(--comp-in) 28%, var(--comp-border));
}

.comp-presence__row.is-out {
  border-color: color-mix(in srgb, var(--comp-out) 28%, var(--comp-border));
}

.comp-list {
  margin-top: 0.35rem;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.comp-list__title {
  margin: 0.4rem 0 0.15rem;
  font-size: 0.78rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--comp-muted);
}

.comp-list__md {
  margin: 0.55rem 0 0.15rem;
  font-size: 0.72rem;
  font-weight: 750;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--comp-muted);
}

.comp-row {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 92px) minmax(0, 1fr);
  gap: 0.75rem;
  padding: 0.85rem 0.95rem;
  border-radius: 16px;
  border: 1px solid var(--comp-border);
  background: var(--comp-glass);
  backdrop-filter: blur(14px);
  cursor: pointer;
  text-align: left;
  color: inherit;
  font: inherit;
  transition: border-color 0.2s ease, transform 0.25s var(--comp-ease),
    box-shadow 0.2s ease;
}

.comp-row:has(.comp-row__score-corner) {
  padding-right: 4.75rem;
}

.comp-row:hover {
  transform: translateY(-1px);
}

.comp-row.is-active {
  border-color: color-mix(in srgb, var(--comp-primary) 55%, transparent);
  box-shadow: 0 0 0 1px color-mix(in srgb, var(--comp-primary) 28%, transparent);
}

.comp-row.is-past {
  opacity: 1;
  border-color: color-mix(in srgb, var(--comp-home) 28%, var(--comp-border));
}

.comp-row.is-past.is-waiting {
  border-color: color-mix(in srgb, var(--comp-away) 36%, var(--comp-border));
  opacity: 1;
}

.comp-row.has-score,
.comp-row.is-final {
  border-color: color-mix(in srgb, var(--comp-home) 40%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-home) 8%, var(--comp-glass));
}

.comp-row.has-score.is-win,
.comp-row.is-final.is-win {
  border-color: color-mix(in srgb, var(--comp-home) 40%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-home) 8%, var(--comp-glass));
}

.comp-row.has-score.is-loss,
.comp-row.is-final.is-loss {
  border-color: color-mix(in srgb, var(--comp-loss) 42%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-loss) 10%, var(--comp-glass));
}

.comp-row.has-score.is-draw,
.comp-row.is-final.is-draw {
  border-color: color-mix(in srgb, var(--comp-muted) 34%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-muted) 8%, var(--comp-glass));
}

.comp-row.is-live {
  border-color: color-mix(in srgb, #ef4444 58%, var(--comp-border));
  background:
    linear-gradient(
      90deg,
      color-mix(in srgb, #ef4444 18%, transparent),
      transparent 42%
    ),
    color-mix(in srgb, #ef4444 8%, var(--comp-glass));
  box-shadow:
    0 0 0 1px color-mix(in srgb, #ef4444 28%, transparent),
    0 0 18px color-mix(in srgb, #ef4444 16%, transparent);
  padding-left: 0.85rem;
  border-left: 3px solid #ef4444;
}

.comp-row.is-live.is-active {
  border-color: color-mix(in srgb, #ef4444 72%, transparent);
  box-shadow:
    0 0 0 1px color-mix(in srgb, #ef4444 40%, transparent),
    0 0 22px color-mix(in srgb, #ef4444 22%, transparent);
}

.comp-page--light .comp-row.is-live {
  background:
    linear-gradient(
      90deg,
      color-mix(in srgb, #dc2626 10%, transparent),
      transparent 42%
    ),
    color-mix(in srgb, #dc2626 5%, #fff);
}

.comp-row__score-corner {
  position: absolute;
  top: 0.55rem;
  right: 0.55rem;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  min-height: 1.55rem;
  padding: 0.16rem 0.5rem;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--comp-primary) 36%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-primary) 14%, var(--comp-glass));
  color: var(--comp-text);
  font-variant-numeric: tabular-nums;
  line-height: 1;
  pointer-events: none;
}

.comp-row__score-corner strong {
  font-size: 0.88rem;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.comp-row__live-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.22rem;
  margin: 0;
  font-style: normal;
  font-size: 0.58rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #fecaca;
}

.comp-row__live-tag::before {
  content: "";
  width: 0.38rem;
  height: 0.38rem;
  border-radius: 999px;
  background: #ef4444;
  box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.55);
  animation: comp-live-pulse 1.4s ease-out infinite;
}

.comp-row__score-corner.is-live {
  border-color: color-mix(in srgb, #ef4444 55%, transparent);
  background: color-mix(in srgb, #ef4444 18%, var(--comp-glass));
  color: #fecaca;
}

.comp-row__score-corner.is-final.is-win {
  border-color: color-mix(in srgb, var(--comp-home) 42%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-home) 16%, var(--comp-glass));
  color: var(--comp-home);
}

.comp-row__score-corner.is-final.is-loss {
  border-color: color-mix(in srgb, var(--comp-loss) 46%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-loss) 14%, var(--comp-glass));
  color: var(--comp-loss);
}

.comp-row__score-corner.is-final.is-draw {
  border-color: color-mix(in srgb, var(--comp-muted) 40%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-muted) 12%, var(--comp-glass));
  color: var(--comp-muted);
}

.comp-row__score-corner.is-waiting {
  border-color: color-mix(in srgb, var(--comp-away) 40%, var(--comp-border));
  background: color-mix(in srgb, var(--comp-away) 14%, transparent);
  color: var(--comp-away);
  font-size: 0.62rem;
  font-weight: 750;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.comp-page--light .comp-row__score-corner.is-live {
  color: #b91c1c;
  background: color-mix(in srgb, #dc2626 12%, #fff);
}

.comp-page--light .comp-row__live-tag {
  color: #b91c1c;
}

.comp-row__when strong {
  display: block;
  font-size: 0.86rem;
}

.comp-row__when span {
  color: var(--comp-muted);
  font-size: 0.75rem;
}

.comp-row__body p {
  margin: 0.25rem 0 0;
  font-weight: 650;
}

.comp-row__name {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
}

.comp-row__name span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.comp-row__body small {
  color: var(--comp-muted);
}

.comp-events {
  margin-top: 1.15rem;
}

.comp-events__head h2 {
  margin: 0;
  font-size: 1.2rem;
  letter-spacing: -0.03em;
}

.comp-events__head-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem 1rem;
}

.comp-events__head p {
  margin: 0.35rem 0 0;
  color: var(--comp-muted);
  line-height: 1.5;
}

.comp-fltt-card__toggle {
  width: 100%;
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr) auto;
  align-items: start;
  gap: 0.55rem 0.85rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  font: inherit;
  cursor: pointer;
}

.comp-fltt-card__toggle .comp-event-card__icon,
.comp-fltt-card__toggle .comp-fltt-card__date,
.comp-fltt-card__toggle .comp-event-card__body,
.comp-fltt-card__toggle .comp-fltt-card__meta {
  grid-area: auto;
}

.comp-fltt-card__toggle .comp-event-card__icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  margin-top: 0.1rem;
}

.comp-fltt-card__date {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 3.35rem;
  min-height: 3.35rem;
  padding: 0.35rem 0.25rem;
  border-radius: 14px;
  border: 1px solid color-mix(in srgb, var(--comp-primary) 45%, var(--comp-border));
  background:
    linear-gradient(
      165deg,
      color-mix(in srgb, var(--comp-primary) 28%, transparent),
      color-mix(in srgb, var(--comp-primary) 8%, var(--comp-glass))
    );
  box-shadow: inset 0 1px 0 color-mix(in srgb, #fff 18%, transparent);
  line-height: 1.05;
  text-align: center;
}

.comp-fltt-card__date-weekday {
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--comp-muted);
}

.comp-fltt-card__date-day {
  display: block;
  margin: 0.08rem 0;
  font-size: 1.35rem;
  font-weight: 800;
  letter-spacing: -0.04em;
  font-variant-numeric: tabular-nums;
  color: inherit;
}

.comp-fltt-card__date-month {
  font-size: 0.68rem;
  font-weight: 750;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: color-mix(in srgb, var(--comp-primary) 72%, var(--comp-muted));
}

.comp-fltt-card__when {
  display: inline;
  font-weight: 750;
  color: color-mix(in srgb, var(--comp-primary) 78%, var(--comp-muted));
}

.comp-fltt-card__toggle .comp-event-card__body {
  min-width: 0;
  overflow-wrap: anywhere;
}

.comp-fltt-card__venue {
  display: inline-flex;
  align-items: flex-start;
  gap: 0.3rem;
  margin: 0.15rem 0.85rem 0.55rem 4.2rem;
  max-width: calc(100% - 5.05rem);
  font-size: 0.78rem;
  color: var(--comp-muted);
  line-height: 1.35;
  text-decoration: none;
  overflow-wrap: anywhere;
}

.comp-fltt-card__venue:hover {
  color: var(--comp-primary);
  text-decoration: underline;
}

.comp-fltt-card__venue:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--comp-primary) 70%, transparent);
  outline-offset: 2px;
  border-radius: 4px;
}

.comp-fltt-card__meta {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding-top: 0.2rem;
  flex-shrink: 0;
}

.comp-fltt-card__meta .is-rot,
.comp-fltt-card__meta svg.is-rot {
  transform: rotate(180deg);
  transition: transform 0.2s ease;
}

.comp-event-card.comp-event-card--fltt {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  grid-template-columns: none;
  grid-template-areas: none;
  gap: 0;
}

.comp-event-card.kind-tournament.is-open {
  grid-template-columns: 1fr;
  grid-template-areas: none;
  align-items: stretch;
}

.comp-fltt-card__detail {
  margin-top: 0.85rem;
  padding-top: 0.85rem;
  border-top: 1px solid var(--comp-border);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.comp-fltt-card__ball {
  margin: 0;
  font-size: 0.85rem;
  color: var(--comp-muted);
}

.comp-fltt-card__notes {
  margin: 0;
  font-size: 0.82rem;
  color: var(--comp-muted);
  white-space: pre-line;
  line-height: 1.4;
}

.comp-fltt-card__detail .comp-rsvp {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.45rem;
  align-items: stretch;
}

.comp-fltt-card__detail .comp-rsvp__btn,
.comp-fltt-card__detail .comp-get-results {
  flex: unset;
  width: 100%;
  min-width: 0;
  justify-content: center;
  white-space: normal;
  line-height: 1.25;
  text-align: center;
  overflow-wrap: anywhere;
}

/* Primary RSVP action needs the full row — long labels (FR/PT/NL) must not collide. */
.comp-fltt-card__detail .comp-rsvp > .comp-rsvp__btn:first-child {
  grid-column: 1 / -1;
}

.comp-fltt-cats {
  margin: 0;
  padding: 0;
  border: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.comp-fltt-cats legend {
  padding: 0;
  margin-bottom: 0.35rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--comp-muted);
}

.comp-fltt-cat {
  display: grid;
  grid-template-columns: auto 3.2rem 1fr auto;
  align-items: center;
  gap: 0.5rem;
  padding: 0.45rem 0.55rem;
  border-radius: 12px;
  border: 1px solid var(--comp-border);
  background: color-mix(in srgb, var(--comp-glass) 80%, transparent);
  cursor: pointer;
  font-size: 0.9rem;
}

.comp-fltt-cat.is-in {
  border-color: color-mix(in srgb, var(--comp-primary) 45%, var(--comp-border));
}

.comp-fltt-cat__time {
  font-variant-numeric: tabular-nums;
  color: var(--comp-muted);
}

.comp-fltt-cat__code {
  font-weight: 600;
}

.comp-fltt-cat em {
  font-style: normal;
  font-size: 0.72rem;
  color: var(--comp-primary);
}

.comp-fltt-participants h3 {
  margin: 0 0 0.4rem;
  font-size: 0.9rem;
}

.comp-fltt-participants ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.comp-fltt-participants li {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 0.25rem 0.75rem;
  padding: 0.4rem 0.5rem;
  border-radius: 10px;
  background: color-mix(in srgb, var(--comp-primary) 8%, transparent);
  font-size: 0.88rem;
}

.comp-fltt-participants li span {
  color: var(--comp-muted);
}

.comp-muted {
  color: var(--comp-muted);
  font-size: 0.9rem;
}

.comp-get-results .is-spin,
.is-spin {
  animation: comp-spin 0.9s linear infinite;
}

a.comp-get-results {
  text-decoration: none;
}

@keyframes comp-spin {
  to {
    transform: rotate(360deg);
  }
}

.comp-events__grid {
  list-style: none;
  margin: 0.9rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.comp-event-card {
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-areas:
    "icon body"
    "icon pill";
  align-items: center;
  gap: 0.35rem 0.75rem;
  padding: 1rem 0.95rem;
  border-radius: 20px;
  border: 1px solid var(--comp-border);
  background: var(--comp-glass);
  backdrop-filter: blur(16px);
  color: inherit;
  text-align: left;
  font: inherit;
  cursor: default;
}

button.comp-event-card {
  cursor: pointer;
  transition: transform 0.3s var(--comp-ease), border-color 0.2s ease;
}

button.comp-event-card:hover {
  transform: translateY(-1px);
}

.comp-event-card--champ {
  margin-top: 0.95rem;
  background: linear-gradient(
      120deg,
      color-mix(in srgb, var(--comp-primary) 22%, transparent),
      transparent 60%
    ),
    var(--comp-glass);
}

.comp-event-card__icon {
  grid-area: icon;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  background: color-mix(in srgb, var(--comp-primary) 16%, transparent);
  color: var(--comp-primary);
}

.comp-event-card .pill {
  grid-area: pill;
  justify-self: start;
}

.kind-cup .comp-event-card__icon {
  background: rgba(251, 191, 36, 0.16);
  color: var(--comp-away);
}

.kind-tournament .comp-event-card__icon {
  background: rgba(167, 139, 250, 0.16);
  color: #c4b5fd;
}

.comp-page--light .kind-tournament .comp-event-card__icon {
  color: #6d28d9;
}

.comp-event-card__body {
  grid-area: body;
  min-width: 0;
}

.comp-event-card__body strong {
  display: block;
  font-size: 0.98rem;
  letter-spacing: -0.02em;
}

.comp-event-card__body em {
  display: block;
  margin-top: 0.2rem;
  font-style: normal;
  color: var(--comp-muted);
  font-size: 0.78rem;
}

.comp-sheet {
  position: fixed;
  inset: 0;
  z-index: 1200;
}

.comp-sheet__scrim {
  position: absolute;
  inset: 0;
  border: 0;
  background: rgba(2, 6, 23, 0.55);
  backdrop-filter: blur(6px);
}

.comp-sheet__panel {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  max-height: min(82vh, 720px);
  overflow: auto;
  padding: 0.6rem 1.1rem calc(1.4rem + env(safe-area-inset-bottom, 0px));
  border-radius: 24px 24px 0 0;
  background: var(--comp-slate);
  border: 1px solid var(--comp-border);
  animation: comp-sheet-up 0.4s var(--comp-ease);
}

@keyframes comp-sheet-up {
  from {
    transform: translateY(24px);
    opacity: 0.6;
  }
  to {
    transform: none;
    opacity: 1;
  }
}

.comp-sheet__grab {
  width: 42px;
  height: 4px;
  border-radius: 99px;
  background: rgba(148, 163, 184, 0.45);
  margin: 0.25rem auto 0.7rem;
}

.comp-sheet__panel header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.comp-sheet__panel h2 {
  margin: 0;
  font-size: 1.1rem;
}

.comp-sheet__panel header button {
  border: 0;
  background: rgba(255, 255, 255, 0.06);
  color: inherit;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  cursor: pointer;
}

.comp-search {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.9rem 0 0.4rem;
  padding: 0.65rem 0.8rem;
  border-radius: 12px;
  border: 1px solid var(--comp-border);
  background: rgba(255, 255, 255, 0.04);
  color: var(--comp-muted);
}

.comp-search input {
  flex: 1 1;
  border: 0;
  background: transparent;
  color: var(--comp-text);
  font: inherit;
  outline: none;
}

.comp-sheet__sec {
  margin: 1rem 0 0.4rem;
  font-size: 0.72rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--comp-muted);
  font-weight: 700;
}

.comp-sheet__list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.comp-sheet__list button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  min-height: 48px;
  padding: 0.75rem 0.1rem;
  border: 0;
  border-bottom: 1px solid var(--comp-border);
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
  font: inherit;
}

.comp-sheet__team {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  min-width: 0;
}

.comp-sheet__team strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.comp-sheet__div {
  color: var(--comp-muted);
  font-size: 0.82rem;
  flex-shrink: 0;
}

.comp-rsvp__btn:focus-visible,
.comp-team-chip:focus-visible,
.comp-days button:focus-visible,
.comp-sheet__list button:focus-visible,
.comp-tabs button:focus-visible,
.comp-teams__card:focus-visible,
.comp-browse:focus-visible,
.comp-get-results:focus-visible,
.comp-empty__cta:focus-visible,
.comp-row:focus-visible,
.comp-event-card:focus-visible {
  outline: 2px solid var(--comp-primary);
  outline-offset: 2px;
}

.comp-championship,
.comp-stage,
.comp-stage-head,
.comp-next,
.comp-list,
.comp-events,
.comp-events__grid,
.comp-row,
.comp-presence,
.comp-presence__row,
.comp-opp-preview,
.comp-opp-preview__list,
.comp-teams,
.comp-days {
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

@media (max-width: 719px) {
  .comp-page {
    padding-left: max(1.15rem, env(safe-area-inset-left, 0px));
    padding-right: max(1.15rem, env(safe-area-inset-right, 0px));
  }

  .comp-page__inner {
    max-width: 100%;
  }

  .comp-hero__stats {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .comp-next__matchup {
    gap: 0.35rem;
  }

  .comp-row {
    grid-template-columns: minmax(0, 78px) minmax(0, 1fr);
    gap: 0.55rem;
    padding: 0.8rem 0.8rem;
  }

  .comp-row:has(.comp-row__score-corner) {
    padding-right: 4.35rem;
  }

  .comp-row.is-live {
    padding-left: 0.7rem;
  }

  .comp-days {
    overflow-x: auto;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    padding-bottom: 0.15rem;
    margin-inline: 0;
  }

  .comp-days::-webkit-scrollbar {
    display: none;
  }
}

@media (min-width: 900px) {
  .comp-page {
    padding-top: 1.75rem;
    padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px));
    padding-left: max(1.5rem, env(safe-area-inset-left, 0px));
    padding-right: max(1.5rem, env(safe-area-inset-right, 0px));
  }

  .comp-page__inner {
    max-width: min(1080px, 100%);
  }

  .comp-hero h1 {
    font-size: 2.55rem;
  }

  .comp-hero__stats {
    max-width: 520px;
  }

  .comp-tabs {
    max-width: 420px;
  }

  .comp-stage {
    display: grid;
    grid-template-columns: 1.12fr 0.88fr;
    align-items: start;
    gap: 1.25rem;
  }

  .comp-stage__primary {
    gap: 1.15rem;
  }

  .comp-next {
    margin-top: 0.85rem;
  }

  .comp-list {
    margin-top: 0.85rem;
  }

  .comp-page .comp-club-logo.club-logo-mark--md {
    width: 88px;
    height: 88px;
  }

  .comp-events__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .comp-event-card:not(.comp-event-card--fltt) {
    grid-template-columns: auto 1fr auto;
    grid-template-areas: "icon body pill";
  }

  .comp-event-card:not(.comp-event-card--fltt) .pill {
    justify-self: end;
  }
}

@media (prefers-reduced-motion: reduce) {
  .comp-page *,
  .comp-page *::before,
  .comp-page *::after {
    animation: none !important;
    transition: none !important;
  }
}

/* FLTT apps STD singles results (team-info) — player "My matches" */
.comp-std-matches {
  margin: 1.25rem 0 1.75rem;
  padding: 1rem 1.1rem 1.15rem;
  border: 1px solid var(--comp-border);
  border-radius: 20px;
  background: var(--comp-glass);
  color: var(--comp-text);
}

.comp-std-matches__head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem 1rem;
  margin-bottom: 0.85rem;
}

.comp-std-matches__head h3 {
  margin: 0 0 0.25rem;
  font-size: 1.05rem;
}

.comp-std-matches__head p {
  margin: 0;
  font-size: 0.88rem;
  color: var(--comp-muted);
}

.comp-std-matches__groups {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.comp-std-matches__group-head {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.45rem;
  font-size: 0.86rem;
}

.comp-std-matches__group-head span {
  opacity: 0.7;
  white-space: nowrap;
}

.comp-std-matches__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.45rem;
}

.comp-std-match {
  --match-tone: color-mix(in srgb, var(--comp-primary) 10%, var(--comp-slate));
  --match-edge: transparent;
  --match-score: var(--comp-text);
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  grid-template-areas:
    "outcome main"
    "outcome actions"
    "editor editor";
  column-gap: 0.55rem;
  row-gap: 0.28rem;
  align-items: start;
  padding: 0.55rem 0.65rem 0.55rem 0.5rem;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--match-edge) 28%, var(--comp-border));
  background:
    linear-gradient(
      105deg,
      color-mix(in srgb, var(--match-edge) 22%, transparent) 0%,
      color-mix(in srgb, var(--match-edge) 8%, transparent) 42%,
      transparent 72%
    ),
    var(--match-tone);
  color: var(--comp-text);
  box-shadow: inset 3px 0 0 var(--match-edge);
}

.comp-std-match.is-win {
  --match-edge: #16a34a;
  --match-tone: color-mix(in srgb, #16a34a 14%, var(--comp-slate));
  --match-score: #86efac;
}

.comp-std-match.is-loss {
  --match-edge: #dc2626;
  --match-tone: color-mix(in srgb, #dc2626 14%, var(--comp-slate));
  --match-score: #fca5a5;
}

.comp-std-match__outcome {
  grid-area: outcome;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.7rem;
  height: 1.7rem;
  margin-top: 0.05rem;
  border-radius: 8px;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  background: color-mix(in srgb, var(--match-edge, var(--comp-muted)) 22%, transparent);
  color: var(--match-score);
  border: 1px solid color-mix(in srgb, var(--match-edge, var(--comp-border)) 45%, transparent);
}

.comp-std-match__main {
  grid-area: main;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.1rem 0.65rem;
  align-items: baseline;
  min-width: 0;
}

.comp-std-match__opp {
  font-weight: 700;
  font-size: 0.88rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.comp-std-match__opp em {
  font-style: normal;
  font-weight: 500;
  color: var(--comp-muted);
}

.comp-std-match__score {
  font-variant-numeric: tabular-nums;
  font-weight: 800;
  font-size: 1rem;
  line-height: 1.1;
  color: var(--match-score);
  letter-spacing: 0.01em;
}

.comp-std-match__meta {
  grid-column: 1 / -1;
  font-size: 0.72rem;
  color: var(--comp-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.comp-std-match__actions {
  grid-area: actions;
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.comp-std-match__btn {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  border: 1px solid var(--comp-border);
  background: color-mix(in srgb, var(--comp-primary) 10%, var(--comp-slate));
  border-radius: 999px;
  padding: 0.24rem 0.58rem;
  font-size: 0.72rem;
  font-weight: 650;
  cursor: pointer;
  color: var(--comp-text);
  text-decoration: none;
}

.comp-std-match__notes {
  grid-area: editor;
  margin: 0.1rem 0 0;
  font-size: 0.8rem;
  opacity: 0.88;
  white-space: pre-wrap;
}

.comp-std-match__editor {
  grid-area: editor;
  margin-top: 0.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.comp-std-match__editor label {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  font-size: 0.82rem;
}

.comp-std-match__editor textarea {
  width: 100%;
  resize: vertical;
  border-radius: 8px;
  border: 1px solid var(--comp-border);
  background: var(--comp-slate);
  color: var(--comp-text);
  padding: 0.45rem 0.55rem;
  font: inherit;
}

.comp-std-match__editor-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.comp-std-match__editor-actions button {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  border: 1px solid var(--comp-border);
  border-radius: 8px;
  padding: 0.35rem 0.7rem;
  font: inherit;
  font-size: 0.85rem;
  cursor: pointer;
  background: color-mix(in srgb, var(--comp-primary) 18%, var(--comp-slate));
  color: var(--comp-text);
}

.comp-std-match__videos {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.comp-std-match__videos button {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
  font: inherit;
  font-size: 0.85rem;
  padding: 0.25rem 0;
}

.comp-std-matches__create {
  margin-top: 1rem;
}

.comp-std-matches__create summary {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
}

.comp-std-matches__form {
  margin-top: 0.75rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(11rem, 1fr));
  gap: 0.65rem;
}

.comp-std-matches__form label {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.8rem;
}

.comp-std-matches__form input,
.comp-std-matches__form textarea {
  border-radius: 8px;
  border: 1px solid var(--comp-border);
  background: var(--comp-slate);
  color: var(--comp-text);
  padding: 0.4rem 0.5rem;
  font: inherit;
}

.comp-std-matches__form-notes {
  grid-column: 1 / -1;
}

.comp-std-matches__form button[type="submit"] {
  grid-column: 1 / -1;
  justify-self: start;
  border: 0;
  border-radius: 8px;
  padding: 0.45rem 0.9rem;
  font: inherit;
  cursor: pointer;
  background: color-mix(in srgb, var(--comp-primary) 22%, var(--comp-slate));
  color: var(--comp-text);
}

/* Club tournament results — Finalized shell + podium + matches */
.comp-std-results {
  margin: 1.25rem 0 1.5rem;
  border: 1px solid var(--comp-border);
  border-radius: 20px;
  background: var(--comp-glass);
  color: var(--comp-text);
  overflow: hidden;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.comp-std-results.is-open {
  border-color: color-mix(in srgb, var(--comp-primary) 42%, var(--comp-border));
}

.comp-std-results__shell {
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 0.75rem;
  align-items: center;
  padding: 0.95rem 1rem;
  border: 0;
  background: color-mix(in srgb, var(--comp-primary) 12%, transparent);
  text-align: left;
  cursor: pointer;
  font: inherit;
  color: var(--comp-text);
}

.comp-std-results__shell:hover {
  background: color-mix(in srgb, var(--comp-primary) 18%, transparent);
}

.comp-std-results__panel {
  padding: 0.85rem 1rem 1.1rem;
  border-top: 1px solid var(--comp-border);
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  color: var(--comp-text);
}

.comp-std-results__head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem 1rem;
}

.comp-std-results__head p {
  margin: 0;
  font-size: 0.88rem;
  color: var(--comp-muted);
  max-width: 36rem;
}

.comp-std-results__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.comp-std-results__card {
  border: 1px solid var(--comp-border);
  border-radius: 12px;
  background: var(--comp-slate);
  color: var(--comp-text);
  overflow: hidden;
  transition:
    border-color 0.18s ease,
    box-shadow 0.18s ease;
}

.comp-std-results__card.has-data {
  border-left: 3px solid color-mix(in srgb, var(--comp-primary) 70%, transparent);
}

.comp-std-results__card.is-selected {
  border-color: color-mix(in srgb, var(--comp-primary) 45%, var(--comp-border));
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--comp-primary) 22%, transparent);
}

.comp-std-results__toggle {
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 0.75rem;
  align-items: center;
  padding: 0.85rem 1rem;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
  font: inherit;
  color: var(--comp-text);
}

.comp-std-results__icon {
  display: grid;
  place-items: center;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 10px;
  background: color-mix(in srgb, var(--comp-primary) 18%, var(--comp-slate));
  color: var(--comp-primary);
}

.comp-std-results__body {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
}

.comp-std-results__body strong {
  font-size: 0.98rem;
  color: var(--comp-text);
}

.comp-std-results__body em {
  font-style: normal;
  font-size: 0.82rem;
  color: var(--comp-muted);
}

.comp-std-results__shell .is-rot,
.comp-std-results__toggle .is-rot {
  transform: rotate(180deg);
}

.comp-std-results__detail {
  padding: 0 1rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  border-top: 1px solid var(--comp-border);
}

.comp-std-results__congrats {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.comp-std-results__congrats-banner {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.75rem 0.9rem;
  border-radius: 12px;
  background:
    linear-gradient(
      135deg,
      color-mix(in srgb, #f59e0b 22%, transparent),
      color-mix(in srgb, var(--comp-primary) 16%, transparent)
    );
  border: 1px solid color-mix(in srgb, #f59e0b 35%, var(--comp-border));
  color: var(--comp-text);
}

.comp-std-results__congrats-banner p {
  margin: 0;
  font-weight: 650;
  font-size: 0.98rem;
  line-height: 1.35;
}

.comp-std-results__congrats h4,
.comp-std-results__category h4,
.comp-std-results__matches-title {
  margin: 0.35rem 0 0.25rem;
  font-size: 0.82rem;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--comp-muted);
}

.comp-std-results__podium-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.comp-std-results__podium-list li {
  display: block;
  padding: 0;
  border-radius: 10px;
  background: color-mix(in srgb, var(--comp-primary) 10%, var(--comp-slate));
  font-size: 0.9rem;
  color: var(--comp-text);
}

.comp-std-results__finalist {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.35rem;
  align-items: center;
  padding: 0.2rem 0.3rem 0.2rem 0.2rem;
  border: 0;
  background: transparent;
  text-align: left;
  font: inherit;
  color: var(--comp-text);
}

.comp-std-results__finalist-main {
  min-width: 0;
  display: grid;
  grid-template-columns: 2.6rem 2.2rem minmax(0, 1fr);
  gap: 0.5rem;
  align-items: center;
  padding: 0.35rem 0.35rem;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
  font: inherit;
  color: inherit;
}

.comp-std-medal {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.28));
}

.comp-page .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.comp-std-results__avatar {
  position: relative;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 999px;
  overflow: hidden;
  display: grid;
  place-items: center;
  background: color-mix(in srgb, var(--comp-primary) 18%, var(--comp-slate));
  color: var(--comp-text);
}

.comp-std-results__avatar img,
.comp-std-results__avatar video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.comp-std-results__avatar > span {
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 0.02em;
}

.comp-std-results__winner-badge {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 1rem;
  height: 1rem;
  border-radius: 999px;
  background: #ca8a04;
  color: #fff;
  font-size: 0.62rem;
  font-weight: 700;
  display: grid;
  place-items: center;
  border: 1px solid #fff;
}

.comp-std-results__finalist-text {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
}

.comp-std-results__finalist-text strong {
  font-size: 0.92rem;
}

.comp-std-results__gallery-btn {
  appearance: none;
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  padding: 0.4rem 0.55rem;
  border-radius: 999px;
  border: 1px solid var(--comp-border);
  background: color-mix(in srgb, var(--comp-primary) 12%, var(--comp-slate));
  color: var(--comp-text);
  font-size: 0.72rem;
  font-weight: 650;
  cursor: pointer;
  font: inherit;
}

.comp-std-gallery {
  position: fixed;
  inset: 0;
  z-index: 21000;
  width: auto;
  height: auto;
  background: #07080d;
  color: #f7f4ee;
  overflow: hidden;
  outline: none;
  /* Fill the visual viewport — avoid 100svh/100dvh mismatch leaving a bottom gap. */
}

.comp-std-gallery__reel {
  position: absolute;
  inset: 0;
  height: auto;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-snap-type: y mandatory;
  overscroll-behavior: none;
  touch-action: pan-y;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.comp-std-gallery__reel::-webkit-scrollbar {
  display: none;
}

.comp-std-gallery.is-picking .comp-std-gallery__reel {
  overflow: hidden;
  pointer-events: none;
}

.comp-std-gallery__slide {
  position: relative;
  box-sizing: border-box;
  /* Exact gallery viewport — chrome/dock overlay; no empty padded band. */
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
  min-height: 100%;
  padding: 0;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  display: grid;
  place-items: center;
  overflow: hidden;
  background: #07080d;
}

.comp-std-gallery__blur {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: blur(32px) saturate(1.2);
  transform: scale(1.12);
  opacity: 0.38;
  pointer-events: none;
}

.comp-std-gallery__media {
  position: absolute;
  inset: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  max-width: none;
  max-height: none;
  object-fit: contain;
  object-position: center;
  background: transparent;
}

.comp-std-gallery__audio {
  position: absolute;
  inset: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  color: #fff;
  background: #0b0f19;
  padding: 1.5rem;
  box-sizing: border-box;
}

.comp-std-gallery__media.is-audio {
  position: relative;
  inset: auto;
  width: min(90%, 28rem);
  height: auto;
  max-width: 100%;
}

.comp-std-gallery__chrome,
.comp-std-gallery__dock,
.comp-std-gallery__rail,
.comp-std-gallery__step,
.comp-std-gallery__mute {
  position: absolute;
  z-index: 3;
}

.comp-std-gallery__chrome {
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  padding: calc(0.7rem + env(safe-area-inset-top, 0px)) 0.85rem 2.4rem;
  background: linear-gradient(
    180deg,
    rgba(7, 8, 13, 0.78) 0%,
    rgba(7, 8, 13, 0.18) 62%,
    transparent 100%
  );
  pointer-events: none;
}

.comp-std-gallery__who {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  min-width: 0;
  pointer-events: none;
}

.comp-std-gallery__chrome-actions {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-shrink: 0;
  pointer-events: auto;
}

.comp-std-gallery__remove {
  color: #fecaca;
  background: rgba(127, 29, 29, 0.55);
}

.comp-std-gallery__remove:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.comp-std-gallery__kicker {
  margin: 0 0 0.08rem;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(247, 244, 238, 0.72);
}

.comp-std-gallery__who h3 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.15;
}

.comp-std-gallery__close,
.comp-std-gallery__mute,
.comp-std-gallery__nav,
.comp-std-gallery__remove {
  pointer-events: auto;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(12, 14, 20, 0.55);
  color: #f7f4ee;
  border-radius: 999px;
  width: 2.35rem;
  height: 2.35rem;
  display: grid;
  place-items: center;
  cursor: pointer;
  backdrop-filter: blur(14px);
}

.comp-std-gallery__close:focus-visible,
.comp-std-gallery__mute:focus-visible,
.comp-std-gallery__nav:focus-visible,
.comp-std-gallery__remove:focus-visible,
.comp-std-gallery__rail button:focus-visible,
.comp-std-gallery__device:focus-visible {
  outline: 2px solid #f5c542;
  outline-offset: 2px;
}

.comp-std-gallery__mute {
  right: 0.85rem;
  bottom: calc(7.4rem + env(safe-area-inset-bottom, 0px));
}

.comp-std-gallery__rail {
  right: 0.72rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 0.32rem;
  pointer-events: none;
}

.comp-std-gallery__rail button {
  pointer-events: auto;
  width: 0.38rem;
  height: 0.38rem;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: rgba(247, 244, 238, 0.32);
  cursor: pointer;
}

.comp-std-gallery__rail button.is-active {
  height: 1.15rem;
  background: #f5c542;
}

.comp-std-gallery__step {
  right: 0.72rem;
  top: calc(50% + 4.6rem);
  display: none;
  flex-direction: column;
  gap: 0.35rem;
}

.comp-std-gallery__nav:disabled {
  opacity: 0.35;
  cursor: default;
}

.comp-std-gallery__dock {
  left: 0;
  right: 0;
  bottom: 0;
  padding: 2.4rem 0.85rem calc(0.85rem + env(safe-area-inset-bottom, 0px));
  background: linear-gradient(
    0deg,
    rgba(7, 8, 13, 0.88) 0%,
    rgba(7, 8, 13, 0.28) 58%,
    transparent 100%
  );
  pointer-events: none;
}

.comp-std-gallery__hint {
  pointer-events: none;
  margin: 0 0 0.65rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.28rem;
  font-size: 0.78rem;
  font-weight: 650;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(247, 244, 238, 0.82);
  animation: comp-std-gallery-hint 1.6s ease-in-out infinite;
}

.comp-std-gallery__actions {
  pointer-events: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.comp-std-gallery__file {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.comp-std-gallery__device {
  flex: 1 1 10rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  margin: 0;
  min-height: 2.55rem;
  padding: 0.45rem 0.85rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(247, 244, 238, 0.12);
  color: #f7f4ee;
  font: inherit;
  font-size: 0.82rem;
  font-weight: 650;
  cursor: pointer;
  backdrop-filter: blur(12px);
}

.comp-std-gallery__device.is-busy,
.comp-std-gallery__device:disabled {
  opacity: 0.65;
  pointer-events: none;
}

.comp-std-gallery__empty {
  position: absolute;
  inset: 0;
  height: auto;
  margin: 0;
  padding: 1.5rem 1.2rem calc(7rem + env(safe-area-inset-bottom, 0px));
  border: 0;
  background: radial-gradient(ellipse at 50% 42%, #1b2230 0%, #07080d 68%);
  color: #f7f4ee;
  display: grid;
  place-content: center;
  gap: 0.4rem;
  cursor: pointer;
  font: inherit;
  text-align: center;
  box-sizing: border-box;
}

.comp-std-gallery__empty.is-busy {
  opacity: 0.65;
  cursor: wait;
  pointer-events: none;
}

.comp-std-gallery__empty strong {
  font-size: 1.05rem;
  font-weight: 700;
}

.comp-std-gallery__empty span {
  font-size: 0.86rem;
  color: rgba(247, 244, 238, 0.7);
  max-width: 18rem;
  justify-self: center;
}

.comp-std-gallery__pick {
  position: absolute;
  z-index: 4;
  left: 0;
  right: 0;
  bottom: 0;
  max-height: min(72vh, 34rem);
  overflow: auto;
  padding: 1rem 0.9rem calc(1rem + env(safe-area-inset-bottom, 0px));
  border-radius: 18px 18px 0 0;
  background: #12141c;
  color: #f7f4ee;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 -18px 40px rgba(0, 0, 0, 0.45);
}

.comp-std-gallery__pick-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.7rem;
}

.comp-std-gallery__pick-head p {
  margin: 0;
  font-size: 0.9rem;
}

.comp-std-gallery__pick-empty {
  margin: 0;
  color: rgba(247, 244, 238, 0.7);
}

.comp-std-gallery__pick-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(6.5rem, 1fr));
  gap: 0.5rem;
}

.comp-std-gallery__pick-list button {
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  overflow: hidden;
  padding: 0;
  background: #1a1d27;
  cursor: pointer;
  color: #f7f4ee;
  font: inherit;
}

.comp-std-gallery__pick-list img,
.comp-std-gallery__pick-list video {
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  display: block;
}

.comp-std-gallery__pick-list span {
  display: block;
  padding: 0.35rem 0.45rem;
  font-size: 0.72rem;
  text-align: left;
}

.comp-std-gallery .comp-page__error {
  color: #fecaca;
}

@keyframes comp-std-gallery-hint {
  0%,
  100% {
    transform: translateY(0);
    opacity: 0.72;
  }
  50% {
    transform: translateY(-5px);
    opacity: 1;
  }
}

@media (min-width: 720px) {
  .comp-std-gallery__step {
    display: flex;
  }

  .comp-std-gallery__pick {
    left: 50%;
    right: auto;
    width: min(34rem, calc(100% - 2rem));
    transform: translateX(-50%);
    border-radius: 18px 18px 0 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .comp-std-gallery__hint {
    animation: none;
  }

  .comp-std-gallery__reel {
    scroll-behavior: auto;
  }
}

.comp-std-results__place {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.comp-std-results__podium-list li em,
.comp-std-results__vs em {
  font-style: normal;
  color: var(--comp-muted);
  font-size: 0.82rem;
}

.comp-events__section-title {
  margin: 0 0 0.65rem;
  font-size: 0.78rem;
  font-weight: 650;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.7;
}

.comp-std-results__cat-podium {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem 0.85rem;
  margin: 0 0 0.45rem;
  font-size: 0.85rem;
  font-weight: 600;
}

.comp-std-results__cat-podium span {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
}

.comp-std-results__matches {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.4rem;
}

.comp-std-results__match-block + .comp-std-results__congrats,
.comp-std-results__congrats + .comp-std-results__match-block,
.comp-std-results__match-block + .comp-std-results__match-block {
  margin-top: 0.75rem;
  padding-top: 0.55rem;
  border-top: 1px dashed var(--comp-border);
}

.comp-std-results__gallery-hint {
  margin: 0.45rem 0 0;
  font-size: 0.72rem;
  line-height: 1.35;
  color: var(--comp-muted);
}

.comp-std-results__match {
  --match-tone: color-mix(in srgb, var(--comp-primary) 8%, var(--comp-slate));
  --match-edge: transparent;
  --match-score: var(--comp-text);
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.35rem 0.5rem;
  align-items: center;
  padding: 0.45rem 0.55rem;
  border-radius: 11px;
  background: var(--match-tone);
  color: var(--comp-text);
  font-size: 0.84rem;
  border: 1px solid color-mix(in srgb, var(--match-edge) 26%, var(--comp-border));
  box-shadow: inset 3px 0 0 var(--match-edge);
  overflow: visible;
}

.comp-std-results__match.is-compact {
  grid-template-columns: auto minmax(0, 1fr) auto auto;
  grid-template-areas:
    "outcome main score notes";
  align-items: center;
  column-gap: 0.5rem;
  row-gap: 0.15rem;
  padding: 0.48rem 0.55rem 0.48rem 0.42rem;
  background:
    linear-gradient(
      105deg,
      color-mix(in srgb, var(--match-edge) 24%, transparent) 0%,
      color-mix(in srgb, var(--match-edge) 9%, transparent) 48%,
      transparent 78%
    ),
    var(--match-tone);
}

.comp-std-results__outcome {
  grid-area: outcome;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.55rem;
  height: 1.55rem;
  border-radius: 7px;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  background: color-mix(in srgb, var(--match-edge, var(--comp-muted)) 22%, transparent);
  color: var(--match-score);
  border: 1px solid color-mix(in srgb, var(--match-edge, var(--comp-border)) 45%, transparent);
  flex: 0 0 auto;
}

.comp-std-results__match.is-compact > .comp-std-results__score {
  grid-area: score;
  justify-self: end;
  align-self: center;
  margin: 0;
  padding: 0.12rem 0.45rem;
  border-radius: 999px;
  font-variant-numeric: tabular-nums;
  font-weight: 800;
  font-size: 0.92rem;
  line-height: 1.15;
  white-space: nowrap;
  letter-spacing: 0.01em;
  color: var(--match-score);
  background: color-mix(in srgb, var(--match-edge, var(--comp-muted)) 16%, transparent);
  border: 1px solid color-mix(in srgb, var(--match-edge, var(--comp-border)) 32%, transparent);
}

.comp-std-results__match.is-compact .comp-std-results__match-main {
  grid-area: main;
  min-width: 0;
  padding-right: 0.1rem;
}

.comp-std-results__match .cm-player-notes {
  --cm-primary: var(--comp-primary, #0877bc);
  --cm-text: var(--comp-text);
  margin: 0;
  justify-self: end;
}

.comp-std-results__match.is-compact .cm-player-notes {
  grid-area: notes;
  align-self: center;
  justify-self: end;
  margin-top: 0;
}

.comp-std-results__match.is-compact .cm-player-notes__icon-btn {
  width: 1.75rem;
  height: 1.75rem;
}

.comp-std-results__match.is-win {
  --match-edge: #16a34a;
  --match-tone: color-mix(in srgb, #16a34a 13%, var(--comp-slate));
  --match-score: #86efac;
}

.comp-std-results__match.is-loss {
  --match-edge: #dc2626;
  --match-tone: color-mix(in srgb, #dc2626 13%, var(--comp-slate));
  --match-score: #fca5a5;
}

.comp-page--light .comp-std-results__match.is-win,
.comp-page--light .comp-std-match.is-win {
  --match-score: #15803d;
}

.comp-page--light .comp-std-results__match.is-loss,
.comp-page--light .comp-std-match.is-loss {
  --match-score: #b91c1c;
}

.comp-std-results__match-hit {
  appearance: none;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  width: 100%;
  padding: 0.4rem 0.5rem;
  cursor: pointer;
}

.comp-std-results__match.is-open .comp-std-results__match-hit {
  background: color-mix(in srgb, var(--comp-primary) 14%, transparent);
}

.comp-std-results__match-main {
  min-width: 0;
}

.comp-std-results__match-compact {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-areas:
    "player"
    "rating"
    "vs"
    "opp-rating";
  row-gap: 0.08rem;
  align-items: baseline;
}

.comp-std-results__match-compact .comp-std-results__player-row {
  grid-area: player;
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  min-width: 0;
  max-width: 100%;
}

.comp-std-results__match-compact .comp-std-results__player {
  font-size: 0.78rem;
  font-weight: 650;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  padding-right: 0;
}

.comp-std-results__media-btn {
  appearance: none;
  border: 0;
  background: color-mix(in srgb, var(--comp-primary, #0877bc) 16%, transparent);
  color: var(--comp-primary, #0877bc);
  width: 1.35rem;
  height: 1.35rem;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  padding: 0;
  cursor: pointer;
  line-height: 0;
}

.comp-std-results__media-btn:hover,
.comp-std-results__media-btn:focus-visible {
  background: color-mix(in srgb, var(--comp-primary, #0877bc) 28%, transparent);
  outline: none;
}

.comp-std-results__match-compact .comp-std-results__rating,
.comp-std-results__match-compact .comp-std-results__opp-rating {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--comp-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.comp-std-results__match-compact .comp-std-results__rating {
  grid-area: rating;
}

.comp-std-results__match-compact .comp-std-results__opp-rating {
  grid-area: opp-rating;
  display: inline-flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.2rem 0.35rem;
  white-space: normal;
}

.comp-std-results__match-compact .comp-std-results__opp-sep {
  color: var(--comp-muted);
  font-weight: 700;
}

.comp-std-results__match-compact .comp-std-results__vs {
  grid-area: vs;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.8rem;
  color: var(--comp-muted);
}

.comp-std-results__match-compact .comp-std-results__stage {
  display: inline;
  color: var(--comp-muted);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.comp-std-results__fb-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.15rem;
  font-size: 0.68rem;
  font-weight: 700;
  color: var(--comp-muted);
}

.comp-std-results__match-meta {
  margin: 0;
  font-size: 0.72rem;
  color: var(--comp-muted);
}

.comp-std-results__match.is-open .comp-std-results__feedback {
  padding: 0.45rem 0.5rem 0.55rem;
  border-top: 1px solid var(--comp-border);
}

.comp-std-results__match-row {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1.4fr) auto auto;
  gap: 0.35rem 0.55rem;
  align-items: baseline;
}

.comp-std-results__match-tools {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.comp-std-results__match-tools button {
  appearance: none;
  border: 1px solid var(--comp-border);
  background: color-mix(in srgb, var(--comp-primary) 12%, var(--comp-slate));
  color: var(--comp-text);
  border-radius: 999px;
  padding: 0.22rem 0.6rem;
  font: inherit;
  font-size: 0.72rem;
  font-weight: 650;
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  cursor: pointer;
}

.comp-std-results__match-tools button.is-on {
  border-color: color-mix(in srgb, var(--comp-primary) 55%, transparent);
  background: color-mix(in srgb, var(--comp-primary) 22%, var(--comp-slate));
}

.comp-std-results__match-tools button span {
  min-width: 1rem;
  text-align: center;
  font-variant-numeric: tabular-nums;
  opacity: 0.8;
}

.comp-std-results__feedback {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.comp-std-results__feedback ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.comp-std-results__feedback li {
  position: relative;
  padding: 0.4rem 1.7rem 0.4rem 0.5rem;
  border-radius: 10px;
  border: 1px solid var(--comp-border);
  background: color-mix(in srgb, var(--comp-primary) 10%, var(--comp-slate));
}

.comp-std-results__feedback li span {
  display: block;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--comp-muted);
  margin-bottom: 0.15rem;
}

.comp-std-results__feedback li p {
  margin: 0;
  font-size: 0.84rem;
  color: var(--comp-text);
  white-space: pre-wrap;
}

.comp-std-results__feedback li button {
  position: absolute;
  top: 0.35rem;
  right: 0.35rem;
  border: 0;
  background: transparent;
  color: var(--comp-muted);
  cursor: pointer;
  padding: 0.15rem;
}

.comp-std-results__feedback textarea {
  width: 100%;
  border-radius: 10px;
  border: 1px solid var(--comp-border);
  background: var(--comp-slate);
  color: var(--comp-text);
  font: inherit;
  padding: 0.45rem 0.55rem;
  resize: vertical;
  min-height: 3.2rem;
}

.comp-std-results__player {
  font-weight: 600;
}

.comp-std-results__score {
  font-variant-numeric: tabular-nums;
  font-weight: 700;
}

.comp-std-results__stage {
  color: var(--comp-muted);
  font-size: 0.78rem;
  white-space: nowrap;
}

@media (min-width: 641px) {
  .comp-std-matches__list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.55rem;
  }

  .comp-std-results__matches {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.5rem;
  }

  .comp-std-results__match-block.is-mine .comp-std-results__matches {
    grid-template-columns: 1fr;
  }

  .comp-std-results__match-compact {
    grid-template-columns: minmax(0, 1.05fr) minmax(0, 1.4fr);
    grid-template-areas:
      "player vs"
      "rating opp-rating";
    align-items: baseline;
    column-gap: 0.55rem;
  }
}

@media (max-width: 640px) {
  .comp-std-results__match {
    font-size: 0.8rem;
  }
  .comp-std-results__match.is-compact {
    grid-template-columns: auto minmax(0, 1fr) auto;
    grid-template-areas:
      "outcome main score"
      "outcome main notes";
    align-items: start;
  }
  .comp-std-results__match.is-compact .cm-player-notes {
    align-self: end;
  }
  .comp-std-results__match-hit {
    padding: 0.32rem 0.42rem;
  }
  .comp-std-results__match-row {
    grid-template-columns: 1fr auto;
    grid-template-areas:
      "player score"
      "vs vs"
      "stage stage";
  }
  .comp-std-results__match-row .comp-std-results__player {
    grid-area: player;
  }
  .comp-std-results__match-row .comp-std-results__score {
    grid-area: score;
  }
  .comp-std-results__match-row .comp-std-results__vs {
    grid-area: vs;
  }
  .comp-std-results__match-row .comp-std-results__stage {
    grid-area: stage;
  }
}

.comp-events__card {
  margin: 0 0 0.9rem;
  padding: 0.9rem 0;
  border-bottom: 1px solid var(--comp-line, rgba(255, 255, 255, 0.08));
}

.comp-events__card h3 {
  margin: 0 0 0.25rem;
}

.comp-events__card button {
  margin-top: 0.55rem;
  font: inherit;
  cursor: pointer;
}


`, "",{"version":3,"sources":["webpack://./src/pages/common/CompetitionPage.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,wCAAwC;EACxC,oCAAoC;EACpC,6CAA6C;EAC7C,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,4BAA4B;EAC5B,iCAAiC;EACjC,kCAAkC;EAClC,iBAAiB;EACjB,oBAAoB;EACpB,8DAA8D;EAC9D,yDAAyD;EACzD,2DAA2D;EAC3D;;;;kBAIgB;EAChB,uBAAuB;EACvB,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,qCAAqC;EACrC,uCAAuC;EACvC,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,aAAa;EACb;;;;GAIC;EACD,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,oCAAoC;EACpC,oEAAoE;EACpE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sEAAsE;EACtE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,uEAAuE;EACvE,uEAAuE;EACvE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;EACpB;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4GAA4G;AAC9G;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,+EAA+E;AACjF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;IACX,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;EACpB;AACF;;AAEA;;EAEE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;;;EAIE,cAAc;EACd,mBAAmB;EACnB;;;;;GAKC;EACD,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;EAIE;;;;;GAKC;EACD,0BAA0B;AAC5B;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,oEAAoE;EACpE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,+EAA+E;AACjF;;AAEA;EACE,2BAA2B;EAC3B,gFAAgF;AAClF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,iFAAiF;EACjF,0EAA0E;EAC1E,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uFAAuF;AACzF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,oCAAoC;EACpC,uEAAuE;EACvE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,oCAAoC;EACpC,6BAA6B;EAC7B,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,oEAAoE;AACtE;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qFAAqF;AACvF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,qGAAqG;AACvG;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sEAAsE;EACtE;;mCAEiC;EACjC;;;;;qBAKmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,gEAAgE;EAChE,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,iFAAiF;EACjF;;;;;;;;;;;qBAWmB;EACnB,2BAA2B;EAC3B;;2DAEyD;EACzD,qDAAqD;AACvD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,wBAAwB;EACxB,mBAAmB;EACnB,iFAAiF;EACjF,oEAAoE;EACpE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;EACvB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB;;;;;;KAMG;EACH;;wEAEsE;EACtE,WAAW;EACX,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;EACV,0BAA0B;EAC1B,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;IACV,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,uBAAuB;EACvB;;;;;;KAMG;EACH;;wEAEsE;AACxE;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,sEAAsE;AACxE;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,kEAAkE;EAClE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,wBAAwB;EACxB,0EAA0E;EAC1E,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,gFAAgF;EAChF,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kEAAkE;EAClE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,oBAAoB;EACpB,oCAAoC;EACpC,kEAAkE;EAClE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,+CAA+C;EACjD;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,oEAAoE;EACpE,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mEAAmE;AACrE;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,qCAAqC;EACrC,wBAAwB;EACxB,oBAAoB;EACpB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,oCAAoC;EACpC;;;;;;qBAMmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,iFAAiF;EACjF,oEAAoE;EACpE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qEAAqE;AACvE;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,yEAAyE;EACzE,kEAAkE;AACpE;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,0EAA0E;EAC1E,iEAAiE;EACjE,cAAc;AAChB;;AAEA;EACE,0EAA0E;EAC1E,iEAAiE;EACjE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,oCAAoC;EACpC;;;;;;qBAMmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,iFAAiF;EACjF,0EAA0E;EAC1E,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;EACE,0DAA0D;EAC1D,8DAA8D;EAC9D,cAAc;EACd,kEAAkE;AACpE;;AAEA;EACE,0EAA0E;EAC1E,uEAAuE;EACvE,uBAAuB;AACzB;;AAEA;EACE,0EAA0E;EAC1E,uEAAuE;EACvE,uBAAuB;AACzB;;AAEA;EACE,2EAA2E;EAC3E,wEAAwE;EACxE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,8CAA8C;EAChD;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,iEAAiE;EACjE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,iFAAiF;EACjF,oEAAoE;EACpE,uBAAuB;EACvB,eAAe;EACf,wCAAwC;EACxC,yFAAyF;AAC3F;;AAEA;;EAEE,oEAAoE;EACpE,sEAAsE;EACtE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,0DAA0D;EAC1D,wDAAwD;EACxD,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,6DAA6D;EAC7D,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;;EAEE,6DAA6D;EAC7D,sEAAsE;AACxE;;AAEA;EACE,0DAA0D;EAC1D,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA;EACE,mBAAmB;EACnB,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,kCAAkC;EAClC,cAAc;EACd,0EAA0E;EAC1E,6EAA6E;AAC/E;;AAEA;EACE,uEAAuE;EACvE,0EAA0E;AAC5E;;AAEA;EACE,uEAAuE;EACvE,0EAA0E;EAC1E,uBAAuB;AACzB;;AAEA;EACE,uEAAuE;EACvE,0EAA0E;EAC1E,uBAAuB;AACzB;;AAEA;EACE,wEAAwE;EACxE,2EAA2E;EAC3E,wBAAwB;AAC1B;;AAEA;EACE,8DAA8D;EAC9D,iEAAiE;AACnE;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,0EAA0E;EAC1E;;;;;;qBAMmB;AACrB;;AAEA;;EAEE,0EAA0E;EAC1E;;;;;;qBAMmB;AACrB;;AAEA;;EAEE,0EAA0E;EAC1E;;;;;;qBAMmB;AACrB;;AAEA;;EAEE,2EAA2E;EAC3E;;;;;;qBAMmB;AACrB;;AAEA;EACE,0EAA0E;EAC1E;;;;;;qBAMmB;AACrB;;AAEA;EACE,iEAAiE;EACjE;;;yDAGuD;EACvD;;;;;;qBAMmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE;;IAEE;;;2DAGuD;EACzD;EACA;IACE;;;2DAGuD;EACzD;AACF;;AAEA;EACE;;;;;;qBAMmB;AACrB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iEAAiE;EACjE,uBAAuB;AACzB;;AAEA;EACE,iEAAiE;EACjE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,8EAA8E;EAC9E,uEAAuE;EACvE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;EACpB,8EAA8E;EAC9E,iEAAiE;EACjE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,0EAA0E;EAC1E,iEAAiE;EACjE,uBAAuB;AACzB;;AAEA;EACE,0EAA0E;EAC1E,iEAAiE;EACjE,uBAAuB;AACzB;;AAEA;EACE,2EAA2E;EAC3E,kEAAkE;EAClE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,8EAA8E;EAC9E,iEAAiE;EACjE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oEAAoE;EACpE,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE;;;;;;;;;;;KAWG;EACH,WAAW;EACX,mEAAmE;EACnE,+EAA+E;AACjF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,qCAAqC;EACrC,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,0FAA0F;AAC5F;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,iEAAiE;EACjE,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,kEAAkE;EAClE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,mEAAmE;EACnE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,qCAAqC;EACrC,wBAAwB;EACxB,oBAAoB;EACpB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,oEAAoE;AACtE;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,qCAAqC;EACrC,wBAAwB;EACxB,oBAAoB;EACpB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,iEAAiE;EACjE,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,kEAAkE;EAClE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yEAAyE;EACzE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,iEAAiE;EACjE,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,kEAAkE;EAClE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,iEAAiE;EACjE,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,kEAAkE;EAClE,sBAAsB;AACxB;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qDAAqD;EACrD,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb;wBACsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sEAAsE;EACtE,8EAA8E;AAChF;;AAEA;EACE,UAAU;EACV,0EAA0E;AAC5E;;AAEA;EACE,0EAA0E;EAC1E,UAAU;AACZ;;AAEA;;EAEE,0EAA0E;EAC1E,sEAAsE;AACxE;;AAEA;;EAEE,0EAA0E;EAC1E,sEAAsE;AACxE;;AAEA;;EAEE,0EAA0E;EAC1E,uEAAuE;AACzE;;AAEA;;EAEE,2EAA2E;EAC3E,uEAAuE;AACzE;;AAEA;EACE,iEAAiE;EACjE;;;;;;qDAMmD;EACnD;;yDAEuD;EACvD,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,0DAA0D;EAC1D;;yDAEuD;AACzD;;AAEA;EACE;;;;;;wCAMsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,iFAAiF;EACjF,0EAA0E;EAC1E,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;EACE,0DAA0D;EAC1D,8DAA8D;EAC9D,cAAc;AAChB;;AAEA;EACE,0EAA0E;EAC1E,uEAAuE;EACvE,uBAAuB;AACzB;;AAEA;EACE,0EAA0E;EAC1E,uEAAuE;EACvE,uBAAuB;AACzB;;AAEA;EACE,2EAA2E;EAC3E,wEAAwE;EACxE,wBAAwB;AAC1B;;AAEA;EACE,0EAA0E;EAC1E,iEAAiE;EACjE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,+CAA+C;EAC/C,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,iFAAiF;EACjF;;;;;KAKG;EACH,mEAAmE;EACnE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qEAAqE;AACvE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qEAAqE;AACvE;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,sCAAsC;EACtC,+BAA+B;EAC/B,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,2EAA2E;EAC3E,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,yBAAyB;EACzB,MAAM;AACR;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,sFAAsF;AACtF;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,oCAAoC;EACpC,kEAAkE;EAClE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,mEAAmE;EACnE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B;;eAEa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mEAAmE;AACrE;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB;;;;;qBAKmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,oEAAoE;EACpE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,4BAA4B;EAC5B,cAAc;EACd,sEAAsE;EACtE,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE;IACE,2BAA2B;IAC3B,YAAY;EACd;EACA;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,2CAA2C;EAC3C,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;;;;;;;;;EAWE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;EAcE,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE;IACE,0DAA0D;IAC1D,4DAA4D;EAC9D;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,qDAAqD;IACrD,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iCAAiC;IACjC,qBAAqB;IACrB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,6DAA6D;IAC7D,yDAAyD;IACzD,2DAA2D;EAC7D;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,oCAAoC;IACpC,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA,oEAAoE;AACpE;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;EACpC,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,4EAA4E;EAC5E,yBAAyB;EACzB,+BAA+B;EAC/B,aAAa;EACb,0CAA0C;EAC1C;;;mBAGiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,+EAA+E;EAC/E;;;;;;;qBAOmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,gEAAgE;EAChE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gEAAgE;EAChE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qFAAqF;EACrF,yBAAyB;EACzB,4FAA4F;AAC9F;;AAEA;EACE,eAAe;EACf,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,0EAA0E;EAC1E,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,0EAA0E;EAC1E,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,0EAA0E;EAC1E,uBAAuB;AACzB;;AAEA,iEAAiE;AACjE;EACE,wBAAwB;EACxB,oCAAoC;EACpC,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;EACT,oEAAoE;EACpE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,4BAA4B;EAC5B,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB;;yBAEuB;AACzB;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,6EAA6E;EAC7E,8EAA8E;AAChF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,0EAA0E;EAC1E,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB;;;;;KAKG;EACH,qEAAqE;EACrE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;EAGE,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,0EAA0E;EAC1E,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mDAAmD;EACnD,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0EAA0E;EAC1E,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,oCAAoC;EACpC,0EAA0E;EAC1E,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,kFAAkF;AACpF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,wEAAwE;EACxE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,wBAAwB;EACxB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;EACtB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;;;;;EAKE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,oEAAoE;EACpE;;;;;GAKC;EACD,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;;;EAIE,oBAAoB;EACpB,2CAA2C;EAC3C,kCAAkC;EAClC,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;;;;;EAME,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wEAAwE;EACxE;;;;;GAKC;EACD,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,0DAA0D;AAC5D;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,0CAA0C;EAC1C,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,oEAAoE;EACpE,SAAS;EACT,wEAAwE;EACxE,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,SAAS;EACT,4BAA4B;EAC5B,cAAc;EACd,kEAAkE;EAClE,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;EACd,+CAA+C;EAC/C,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;IAEE,wBAAwB;IACxB,aAAa;EACf;EACA;IACE,2BAA2B;IAC3B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,WAAW;IACX,oCAAoC;IACpC,2BAA2B;IAC3B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,0BAA0B;EAC1B,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,2EAA2E;EAC3E,yBAAyB;EACzB,+BAA+B;EAC/B,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;EAClB,+EAA+E;EAC/E,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,oDAAoD;EACpD;8BAC4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC;;;;;;;qBAOmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qFAAqF;EACrF,yBAAyB;EACzB,4FAA4F;EAC5F,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,qFAAqF;EACrF,4FAA4F;AAC9F;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gEAAgE;EAChE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gEAAgE;EAChE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC;;;;gBAIc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,6EAA6E;EAC7E,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,6EAA6E;EAC7E,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,kEAAkE;EAClE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,0EAA0E;EAC1E,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sEAAsE;EACtE,0EAA0E;AAC5E;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,oCAAoC;EACpC,0EAA0E;AAC5E;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;IAChD,YAAY;EACd;;EAEA;IACE,gDAAgD;IAChD,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yDAAyD;IACzD;;yBAEqB;IACrB,qBAAqB;IACrB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,+CAA+C;IAC/C;;0BAEsB;IACtB,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,+BAA+B;IAC/B;;;mBAGe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oEAAoE;AACtE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap\");\n\n.comp-page {\n  --comp-bg: #0b0f19;\n  --comp-slate: #121826;\n  --comp-text: #f8fafc;\n  --comp-muted: #94a3b8;\n  --comp-border: rgba(255, 255, 255, 0.08);\n  --comp-glass: rgba(15, 23, 42, 0.72);\n  --comp-primary: var(--brand-primary, #0877bc);\n  --comp-home: #34d399;\n  --comp-away: #fbbf24;\n  --comp-loss: #f87171;\n  --comp-in: #34d399;\n  --comp-out: #fb7185;\n  --comp-ease: cubic-bezier(0.16, 1, 0.3, 1);\n  --comp-ink: var(--comp-text);\n  --comp-surface: var(--comp-slate);\n  --comp-accent: var(--comp-primary);\n  min-height: 100vh;\n  padding-top: 1.25rem;\n  padding-bottom: calc(120px + env(safe-area-inset-bottom, 0px));\n  padding-left: max(1.1rem, env(safe-area-inset-left, 0px));\n  padding-right: max(1.1rem, env(safe-area-inset-right, 0px));\n  background:\n    radial-gradient(1100px 520px at 8% -18%, color-mix(in srgb, var(--comp-primary) 32%, transparent), transparent 58%),\n    radial-gradient(720px 380px at 108% 4%, rgba(251, 191, 36, 0.1), transparent 52%),\n    radial-gradient(640px 280px at 50% 120%, rgba(52, 211, 153, 0.07), transparent 55%),\n    var(--comp-bg);\n  color: var(--comp-text);\n  font-family: Outfit, Inter, -apple-system, sans-serif;\n  width: 100%;\n  max-width: 100%;\n  margin-inline: auto;\n  overflow-x: clip;\n  box-sizing: border-box;\n}\n\n.comp-page__inner {\n  max-width: min(520px, 100%);\n  width: 100%;\n  min-width: 0;\n  margin-inline: auto;\n  box-sizing: border-box;\n}\n\n.comp-page--light {\n  --comp-bg: #f3f5f8;\n  --comp-slate: #ffffff;\n  --comp-text: #0f172a;\n  --comp-muted: #475569;\n  --comp-border: rgba(15, 23, 42, 0.08);\n  --comp-glass: rgba(255, 255, 255, 0.86);\n  --comp-home: #047857;\n  --comp-away: #b45309;\n  --comp-loss: #dc2626;\n  --comp-in: #047857;\n  --comp-out: #e11d48;\n}\n\n.comp-hero {\n  position: relative;\n  padding: 0.15rem 0.1rem 0.2rem;\n}\n\n.comp-hero__glow {\n  pointer-events: none;\n  position: absolute;\n  top: -24px;\n  left: 0;\n  right: 0;\n  height: 160px;\n  background: radial-gradient(\n    closest-side,\n    color-mix(in srgb, var(--comp-primary) 22%, transparent),\n    transparent 78%\n  );\n  filter: blur(8px);\n}\n\n.comp-page__hero-bar h1,\n.comp-hero h1 {\n  position: relative;\n  margin: 0.2rem 0 0;\n  font-size: 2rem;\n  letter-spacing: -0.04em;\n  font-weight: 800;\n  line-height: 1.05;\n}\n\n.comp-page__kicker {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin: 0;\n  color: var(--comp-muted);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.comp-hero__lede {\n  position: relative;\n  margin: 0.55rem 0 0;\n  max-width: 36rem;\n  color: var(--comp-muted);\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.comp-hero__schema {\n  position: relative;\n  display: inline-block;\n  margin-top: 0.7rem;\n  color: #7dd3fc;\n  font-weight: 700;\n  font-size: 0.85rem;\n}\n\n.comp-page__round {\n  position: relative;\n  display: inline-flex;\n  margin: 0.7rem 0 0;\n  padding: 0.28rem 0.7rem;\n  border-radius: 999px;\n  border: 1px solid var(--comp-border);\n  background: color-mix(in srgb, var(--comp-primary) 12%, transparent);\n  color: var(--comp-text);\n  font-size: 0.78rem;\n  font-weight: 650;\n}\n\n.comp-hero__stats {\n  position: relative;\n  list-style: none;\n  margin: 1rem 0 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(110px, 100%), 1fr));\n  gap: 0.5rem;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.comp-hero__stats li {\n  min-width: 0;\n  padding: 0.7rem 0.65rem;\n  border-radius: 16px;\n  border: 1px solid var(--comp-border);\n  background: var(--comp-glass);\n  backdrop-filter: blur(16px);\n}\n\n.comp-hero__stats strong {\n  display: block;\n  font-size: 0.92rem;\n  letter-spacing: -0.02em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.comp-hero__stats span {\n  display: block;\n  margin-top: 0.15rem;\n  color: var(--comp-muted);\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n.comp-phone-videos {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  margin-top: 1rem;\n  padding: 0.7rem 0.85rem;\n  border-radius: 16px;\n  border: 1px solid color-mix(in srgb, var(--comp-away) 45%, transparent);\n  background: color-mix(in srgb, var(--comp-away) 10%, var(--comp-glass));\n  color: var(--comp-text);\n  text-decoration: none;\n}\n\n.comp-phone-videos > svg:first-child {\n  flex: 0 0 auto;\n  color: var(--comp-away);\n}\n\n.comp-phone-videos > svg:last-child {\n  flex: 0 0 auto;\n  color: var(--comp-muted);\n}\n\n.comp-phone-videos__text {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.comp-phone-videos__text strong {\n  font-size: 0.92rem;\n  font-weight: 800;\n}\n\n.comp-phone-videos__text span {\n  font-size: 0.8rem;\n  color: var(--comp-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.comp-phone-videos:focus-visible {\n  outline: 2px solid var(--comp-primary);\n  outline-offset: 2px;\n}\n\n.comp-tabs {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.28rem;\n  margin-top: 1.15rem;\n  padding: 0.28rem;\n  border-radius: 16px;\n  border: 1px solid var(--comp-border);\n  background: rgba(255, 255, 255, 0.04);\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.comp-tabs--with-cups {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n@media (max-width: 380px) {\n  .comp-tabs--with-cups button {\n    position: relative;\n    flex-direction: column;\n    gap: 0.12rem;\n    min-height: 3.25rem;\n    padding: 0.3rem 0.2rem;\n    font-size: 0.68rem;\n  }\n\n  .comp-tabs--with-cups button em {\n    position: absolute;\n    top: 0.2rem;\n    right: 0.2rem;\n    min-width: 0.95rem;\n    padding: 0.02rem 0.22rem;\n    font-size: 0.55rem;\n  }\n}\n\n.comp-page--light .comp-tabs {\n  background: rgba(15, 23, 42, 0.04);\n}\n\n.comp-tabs button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.28rem;\n  min-width: 0;\n  min-height: 44px;\n  max-width: 100%;\n  padding: 0.35rem 0.4rem;\n  border: 0;\n  border-radius: 12px;\n  background: transparent;\n  color: var(--comp-muted);\n  font: inherit;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  line-height: 1.1;\n  cursor: pointer;\n  overflow: hidden;\n  transition: background 0.28s var(--comp-ease), color 0.28s var(--comp-ease), transform 0.2s var(--comp-ease);\n}\n\n.comp-tabs button svg {\n  flex-shrink: 0;\n  width: 1rem;\n  height: 1rem;\n}\n\n.comp-tabs__text {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.comp-tabs__full {\n  display: none;\n}\n\n.comp-tabs__abbr {\n  display: inline;\n}\n\n.comp-tabs button em {\n  flex-shrink: 0;\n  font-style: normal;\n  min-width: 1.1rem;\n  max-width: 2rem;\n  padding: 0.05rem 0.3rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.1);\n  font-size: 0.62rem;\n  line-height: 1.2;\n  text-align: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.comp-tabs button.is-active {\n  background: var(--comp-primary);\n  color: #fff;\n  box-shadow: 0 8px 18px color-mix(in srgb, var(--comp-primary) 35%, transparent);\n}\n\n.comp-tabs button:active {\n  transform: scale(0.98);\n}\n\n@media (min-width: 480px) {\n  .comp-tabs button {\n    gap: 0.4rem;\n    padding-inline: 0.55rem;\n    font-size: 0.88rem;\n  }\n\n  .comp-tabs__full {\n    display: inline;\n  }\n\n  .comp-tabs__abbr {\n    display: none;\n  }\n\n  .comp-tabs button em {\n    min-width: 1.25rem;\n    padding: 0.05rem 0.38rem;\n    font-size: 0.68rem;\n  }\n}\n\n.comp-page__status,\n.comp-page__error {\n  margin-top: 1.25rem;\n  color: var(--comp-muted);\n}\n\n.comp-page__error {\n  color: #fb7185;\n}\n\n.comp-skel {\n  margin-top: 1.15rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n}\n\n.comp-skel__bar,\n.comp-skel__hero,\n.comp-skel__row,\n.comp-skel__cards span {\n  display: block;\n  border-radius: 16px;\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.04),\n    rgba(255, 255, 255, 0.1),\n    rgba(255, 255, 255, 0.04)\n  );\n  background-size: 200% 100%;\n  animation: comp-pulse 1.4s ease-in-out infinite;\n}\n\n.comp-skel__bar {\n  height: 48px;\n}\n\n.comp-skel__hero {\n  height: 220px;\n  border-radius: 24px;\n}\n\n.comp-skel__row {\n  height: 76px;\n}\n\n.comp-skel__cards {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.5rem;\n}\n\n.comp-skel__cards span {\n  height: 108px;\n  border-radius: 18px;\n}\n\n.comp-page--light .comp-skel__bar,\n.comp-page--light .comp-skel__hero,\n.comp-page--light .comp-skel__row,\n.comp-page--light .comp-skel__cards span {\n  background: linear-gradient(\n    90deg,\n    rgba(15, 23, 42, 0.05),\n    rgba(15, 23, 42, 0.1),\n    rgba(15, 23, 42, 0.05)\n  );\n  background-size: 200% 100%;\n}\n\n@keyframes comp-pulse {\n  0% {\n    background-position: 100% 0;\n  }\n  100% {\n    background-position: -100% 0;\n  }\n}\n\n.comp-empty {\n  margin-top: 1.35rem;\n  padding: 1.5rem 1.25rem;\n  border-radius: 24px;\n  background: var(--comp-glass);\n  backdrop-filter: blur(20px);\n  border: 1px solid var(--comp-border);\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.18);\n}\n\n.comp-empty__icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 16px;\n  display: grid;\n  place-items: center;\n  background: color-mix(in srgb, var(--comp-primary) 18%, transparent);\n  color: var(--comp-primary);\n  margin-bottom: 0.85rem;\n}\n\n.comp-empty h2 {\n  margin: 0 0 0.4rem;\n  font-size: 1.15rem;\n}\n\n.comp-empty p {\n  margin: 0;\n  color: var(--comp-muted);\n  line-height: 1.55;\n}\n\n.comp-empty__cta {\n  display: inline-flex;\n  margin-top: 1rem;\n  min-height: 44px;\n  align-items: center;\n  padding: 0.55rem 1rem;\n  border: 0;\n  border-radius: 12px;\n  background: var(--comp-primary);\n  color: #fff;\n  font: inherit;\n  font-weight: 700;\n  text-decoration: none;\n  cursor: pointer;\n  transition: transform 0.25s var(--comp-ease), box-shadow 0.25s var(--comp-ease);\n}\n\n.comp-empty__cta:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 10px 22px color-mix(in srgb, var(--comp-primary) 38%, transparent);\n}\n\n.comp-empty__cta:active {\n  transform: scale(0.97);\n}\n\n.comp-championship {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.comp-stage-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-top: 1.25rem;\n  min-width: 0;\n}\n\n.comp-stage-head > div {\n  min-width: 0;\n  flex: 1 1 12rem;\n}\n\n.comp-stage-head__actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.45rem;\n  flex: 0 1 auto;\n}\n\n.comp-get-results {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  min-height: 40px;\n  padding: 0.35rem 0.85rem;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, var(--comp-primary) 55%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-primary) 22%, var(--comp-glass));\n  color: inherit;\n  font: inherit;\n  font-size: 0.78rem;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: transform 0.25s var(--comp-ease), border-color 0.2s ease, opacity 0.2s ease;\n}\n\n.comp-get-results:hover:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n.comp-get-results:active:not(:disabled) {\n  transform: scale(0.97);\n}\n\n.comp-get-results:disabled {\n  opacity: 0.65;\n  cursor: wait;\n}\n\n.comp-sync-notice {\n  margin: 0.65rem 0 0;\n  padding: 0.55rem 0.75rem;\n  border-radius: 12px;\n  border: 1px solid var(--comp-border);\n  background: color-mix(in srgb, var(--comp-home) 12%, var(--comp-glass));\n  color: var(--comp-text);\n  font-size: 0.82rem;\n  font-weight: 550;\n}\n\n.comp-stage-head__kicker {\n  margin: 0;\n  font-size: 0.7rem;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  font-weight: 700;\n  color: var(--comp-muted);\n}\n\n.comp-stage-head h2 {\n  margin: 0.2rem 0 0;\n  font-size: 1.15rem;\n  letter-spacing: -0.03em;\n}\n\n.comp-browse {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  min-height: 40px;\n  padding: 0.35rem 0.7rem;\n  border-radius: 999px;\n  border: 1px solid var(--comp-border);\n  background: var(--comp-glass);\n  color: inherit;\n  font: inherit;\n  font-size: 0.78rem;\n  font-weight: 650;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: transform 0.25s var(--comp-ease), border-color 0.2s ease;\n}\n\n.comp-browse:hover {\n  transform: translateY(-1px);\n}\n\n.comp-browse:active {\n  transform: scale(0.97);\n}\n\n.comp-teams {\n  margin: 0.9rem 0 0;\n  padding: 0 0 0.35rem;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.comp-teams__slide {\n  outline: none;\n}\n\n.comp-teams .react-slideshow-container,\n.comp-teams .react-slideshow-fadezoom-wrapper,\n.comp-teams .react-slideshow-wrapper,\n.comp-teams .images-wrap {\n  width: 100%;\n}\n\n.comp-teams .react-slideshow-container + .indicators {\n  display: flex;\n  justify-content: center;\n  gap: 4px;\n  margin-top: 0.35rem;\n  padding-bottom: 0.15rem;\n}\n\n.comp-teams .indicators .each-slideshow-indicator {\n  cursor: pointer;\n}\n\n.comp-teams .indicators .each-slideshow-indicator::before {\n  background: color-mix(in srgb, var(--comp-primary) 35%, var(--comp-muted)) !important;\n}\n\n.comp-teams .indicators .each-slideshow-indicator.active::before {\n  background: var(--comp-primary) !important;\n}\n\n.comp-teams__card {\n  width: calc(100% - 12px);\n  min-width: 0;\n  max-width: none;\n  margin: 6px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 0.4rem;\n  min-height: 132px;\n  height: auto;\n  overflow: visible;\n  padding: 0.9rem 0.85rem 0.85rem;\n  border-radius: 20px;\n  border: 1px solid var(--comp-border);\n  background: var(--comp-glass);\n  backdrop-filter: blur(16px);\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n  font: inherit;\n  transition: transform 0.3s var(--comp-ease), border-color 0.2s ease, box-shadow 0.3s var(--comp-ease);\n}\n\n.comp-teams__card:hover {\n  transform: translateY(-2px);\n}\n\n.comp-teams__card:active {\n  transform: scale(0.98);\n}\n\n.comp-teams__card.is-active {\n  border-color: color-mix(in srgb, var(--comp-primary) 65%, transparent);\n  box-shadow:\n    0 0 0 1px color-mix(in srgb, var(--comp-primary) 30%, transparent),\n    0 14px 28px rgba(0, 0, 0, 0.18);\n  background: linear-gradient(\n      180deg,\n      color-mix(in srgb, var(--comp-primary) 18%, transparent),\n      transparent 70%\n    ),\n    var(--comp-glass);\n}\n\n.comp-teams__card strong {\n  display: block;\n  overflow: visible;\n  font-size: 0.86rem;\n  letter-spacing: -0.02em;\n  line-height: 1.35;\n  padding-block: 0.12em;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.comp-teams__card em {\n  font-style: normal;\n  color: var(--comp-muted);\n  font-size: 0.72rem;\n}\n\n.comp-teams__mine {\n  margin-top: auto;\n  font-size: 0.62rem;\n  font-weight: 750;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--comp-home);\n}\n\n.comp-teams__rank {\n  font-size: 0.72rem;\n  font-weight: 750;\n  color: var(--comp-primary);\n}\n\n.comp-ladder {\n  --ladder-win: var(--comp-home);\n  --ladder-draw: var(--comp-away);\n  --ladder-loss: var(--comp-loss);\n  --ladder-rail: color-mix(in srgb, var(--comp-primary) 72%, #fff);\n  margin: 0.95rem 0 0;\n  padding: 1rem 0.85rem 0.85rem;\n  border-radius: 24px;\n  border: 1px solid color-mix(in srgb, var(--comp-primary) 26%, var(--comp-border));\n  background:\n    linear-gradient(\n      165deg,\n      color-mix(in srgb, var(--comp-primary) 18%, transparent) 0%,\n      transparent 42%\n    ),\n    radial-gradient(\n      90% 70% at 100% 0%,\n      color-mix(in srgb, var(--comp-away) 12%, transparent),\n      transparent 55%\n    ),\n    var(--comp-glass);\n  backdrop-filter: blur(18px);\n  box-shadow:\n    0 18px 40px rgba(2, 8, 23, 0.18),\n    inset 0 1px 0 color-mix(in srgb, #fff 10%, transparent);\n  animation: comp-ladder-in 0.55s var(--comp-ease) both;\n}\n\n@keyframes comp-ladder-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .comp-ladder {\n    animation: none;\n  }\n}\n\n.comp-ladder__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.85rem;\n}\n\n.comp-ladder__head-copy {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.18rem;\n}\n\n.comp-ladder__kicker {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  margin: 0;\n  font-size: 0.68rem;\n  font-weight: 750;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--comp-muted);\n}\n\n.comp-ladder__head h3 {\n  margin: 0;\n  font-size: 1.12rem;\n  font-weight: 800;\n  letter-spacing: -0.035em;\n  line-height: 1.15;\n}\n\n.comp-ladder__lede {\n  margin: 0.1rem 0 0;\n  font-size: 0.74rem;\n  line-height: 1.35;\n  color: var(--comp-muted);\n}\n\n.comp-ladder__place-chip {\n  display: grid;\n  grid-template-columns: auto auto;\n  grid-template-rows: auto auto;\n  align-content: center;\n  justify-items: end;\n  gap: 0 0.2rem;\n  margin: 0;\n  padding: 0.45rem 0.65rem;\n  border-radius: 16px;\n  border: 1px solid color-mix(in srgb, var(--comp-primary) 35%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-primary) 14%, transparent);\n  flex-shrink: 0;\n}\n\n.comp-ladder__place-chip > span {\n  grid-column: 1 / -1;\n  font-size: 0.58rem;\n  font-weight: 750;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--comp-muted);\n}\n\n.comp-ladder__place-chip strong {\n  font-size: 1.45rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.05em;\n  line-height: 1;\n  color: var(--comp-primary);\n}\n\n.comp-ladder__place-chip em {\n  font-style: normal;\n  font-size: 0.72rem;\n  font-weight: 650;\n  color: var(--comp-muted);\n  align-self: end;\n  padding-bottom: 0.12rem;\n}\n\n.comp-ladder__us {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  align-items: center;\n  gap: 0.65rem 0.8rem;\n  margin-bottom: 0.8rem;\n  padding: 0.8rem 0.85rem;\n  border-radius: 18px;\n  position: relative;\n  overflow: hidden;\n  background:\n    linear-gradient(\n      118deg,\n      color-mix(in srgb, var(--comp-primary) 42%, #07111f) 0%,\n      color-mix(in srgb, var(--comp-primary) 18%, transparent) 68%,\n      color-mix(in srgb, var(--comp-away) 10%, transparent) 100%\n    );\n  box-shadow:\n    inset 0 0 0 1px color-mix(in srgb, #fff 14%, transparent),\n    0 10px 28px color-mix(in srgb, var(--comp-primary) 28%, transparent);\n  color: #fff;\n  animation: comp-ladder-us 0.65s var(--comp-ease) 0.08s both;\n}\n\n.comp-ladder__us::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 12%;\n  bottom: 12%;\n  width: 4px;\n  border-radius: 0 4px 4px 0;\n  background: #fff;\n  box-shadow: 0 0 16px rgba(255, 255, 255, 0.45);\n}\n\n@keyframes comp-ladder-us {\n  from {\n    opacity: 0;\n    transform: scale(0.985);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .comp-ladder__us {\n    animation: none;\n  }\n}\n\n.comp-page--light .comp-ladder__us {\n  color: var(--comp-text);\n  background:\n    linear-gradient(\n      118deg,\n      color-mix(in srgb, var(--comp-primary) 26%, #fff) 0%,\n      color-mix(in srgb, var(--comp-primary) 10%, #fff) 70%,\n      color-mix(in srgb, var(--comp-away) 8%, #fff) 100%\n    );\n  box-shadow:\n    inset 0 0 0 1px color-mix(in srgb, var(--comp-primary) 30%, transparent),\n    0 10px 24px color-mix(in srgb, var(--comp-primary) 14%, transparent);\n}\n\n.comp-page--light .comp-ladder__us::before {\n  background: var(--comp-primary);\n  box-shadow: none;\n}\n\n.comp-ladder__us-rank {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 3rem;\n  min-height: 3rem;\n  padding: 0.3rem 0.4rem;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.14);\n  line-height: 1;\n}\n\n.comp-page--light .comp-ladder__us-rank {\n  background: color-mix(in srgb, var(--comp-primary) 12%, #fff);\n}\n\n.comp-ladder__us-rank span {\n  font-size: 1.55rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.05em;\n}\n\n.comp-ladder__us-rank small {\n  margin-top: 0.18rem;\n  font-size: 0.56rem;\n  font-weight: 750;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  opacity: 0.78;\n}\n\n.comp-ladder__us-meta {\n  min-width: 0;\n}\n\n.comp-ladder__us-tag {\n  display: inline-block;\n  margin-bottom: 0.18rem;\n  padding: 0.12rem 0.42rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.16);\n  font-size: 0.58rem;\n  font-weight: 750;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.comp-page--light .comp-ladder__us-tag {\n  background: color-mix(in srgb, var(--comp-primary) 16%, #fff);\n  color: var(--comp-primary);\n}\n\n.comp-ladder__us-meta strong {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 1.02rem;\n  font-weight: 780;\n  letter-spacing: -0.02em;\n}\n\n.comp-ladder__us-meta em {\n  display: block;\n  margin-top: 0.14rem;\n  font-style: normal;\n  font-size: 0.72rem;\n  opacity: 0.84;\n}\n\n.comp-ladder__us-stats {\n  grid-column: 1 / -1;\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 0.35rem;\n  margin: 0;\n}\n\n.comp-ladder__us-stats > div {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.15rem;\n  padding: 0.38rem 0.2rem 0.42rem;\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.18);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.comp-page--light .comp-ladder__us-stats > div {\n  background: rgba(255, 255, 255, 0.72);\n  border-color: color-mix(in srgb, var(--comp-primary) 12%, transparent);\n}\n\n.comp-ladder__us-stats dt {\n  margin: 0;\n  font-size: 0.58rem;\n  font-weight: 750;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  opacity: 0.78;\n}\n\n.comp-ladder__us-stats dd {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  line-height: 1;\n}\n\n.comp-ladder__us-stats .is-win dt,\n.comp-ladder__us-stats .is-win dd {\n  color: var(--ladder-win);\n}\n\n.comp-ladder__us-stats .is-draw dt,\n.comp-ladder__us-stats .is-draw dd {\n  color: var(--ladder-draw);\n}\n\n.comp-ladder__us-stats .is-loss dt,\n.comp-ladder__us-stats .is-loss dd {\n  color: var(--ladder-loss);\n}\n\n.comp-ladder__us-stats .is-pts {\n  background: color-mix(in srgb, var(--comp-primary) 35%, rgba(0, 0, 0, 0.18));\n}\n\n.comp-page--light .comp-ladder__us-stats .is-pts {\n  background: color-mix(in srgb, var(--comp-primary) 18%, #fff);\n}\n\n.comp-ladder__us-stats .is-pts dd {\n  font-size: 1.2rem;\n  color: inherit;\n}\n\n.comp-ladder__board {\n  border-radius: 16px;\n  border: 1px solid var(--comp-border);\n  background: color-mix(in srgb, var(--comp-slate) 70%, transparent);\n  overflow: hidden;\n  max-height: 22rem;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.comp-ladder__table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 0.78rem;\n}\n\n.comp-ladder__caption {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.comp-ladder__table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  padding: 0.55rem 0.35rem;\n  background: color-mix(in srgb, var(--comp-slate) 92%, var(--comp-primary));\n  border-bottom: 1px solid var(--comp-border);\n  font-size: 0.62rem;\n  font-weight: 750;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--comp-muted);\n  text-align: center;\n  white-space: nowrap;\n}\n\n.comp-page--light .comp-ladder__table thead th {\n  background: color-mix(in srgb, #fff 88%, var(--comp-primary));\n}\n\n.comp-ladder__table thead th abbr {\n  text-decoration: none;\n  cursor: help;\n}\n\n.comp-ladder__th-team {\n  text-align: left !important;\n  padding-left: 0.55rem !important;\n}\n\n.comp-ladder__th-pos {\n  width: 2.4rem;\n}\n\n.comp-ladder__th-num {\n  width: 1.85rem;\n}\n\n.comp-ladder__th-pts {\n  width: 2.35rem;\n  padding-right: 0.55rem !important;\n  text-align: right !important;\n}\n\n.comp-ladder__table thead th.is-win {\n  color: var(--ladder-win);\n}\n\n.comp-ladder__table thead th.is-draw {\n  color: var(--ladder-draw);\n}\n\n.comp-ladder__table thead th.is-loss {\n  color: var(--ladder-loss);\n}\n\n.comp-ladder__row td {\n  padding: 0.48rem 0.35rem;\n  border-bottom: 1px solid color-mix(in srgb, var(--comp-border) 80%, transparent);\n  vertical-align: middle;\n  transition: background 0.22s var(--comp-ease);\n}\n\n.comp-ladder__row:last-child td {\n  border-bottom: 0;\n}\n\n.comp-ladder__row:hover td {\n  background: color-mix(in srgb, var(--comp-primary) 8%, transparent);\n}\n\n.comp-ladder__pos {\n  text-align: center;\n  font-variant-numeric: tabular-nums;\n  font-weight: 760;\n  color: var(--comp-muted);\n}\n\n.comp-ladder__pos span {\n  display: inline-grid;\n  place-items: center;\n  min-width: 1.55rem;\n  height: 1.55rem;\n  border-radius: 8px;\n  background: color-mix(in srgb, var(--comp-muted) 12%, transparent);\n  font-size: 0.78rem;\n}\n\n.comp-ladder__row.is-podium .comp-ladder__pos span {\n  color: #fbbf24;\n  background: color-mix(in srgb, #fbbf24 16%, transparent);\n}\n\n.comp-ladder__name {\n  max-width: 0;\n  width: 100%;\n  padding-left: 0.45rem !important;\n}\n\n.comp-ladder__name span {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 650;\n  letter-spacing: -0.01em;\n}\n\n.comp-ladder__name em {\n  display: block;\n  margin-top: 0.08rem;\n  font-style: normal;\n  font-size: 0.58rem;\n  font-weight: 750;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--comp-primary);\n}\n\n.comp-ladder__num {\n  text-align: center;\n  font-variant-numeric: tabular-nums;\n  font-weight: 650;\n  color: var(--comp-muted);\n}\n\n.comp-ladder__num.is-win {\n  color: var(--ladder-win);\n  font-weight: 750;\n}\n\n.comp-ladder__num.is-draw {\n  color: var(--ladder-draw);\n}\n\n.comp-ladder__num.is-loss {\n  color: var(--ladder-loss);\n}\n\n.comp-ladder__pts {\n  padding-right: 0.55rem !important;\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n  font-weight: 820;\n  font-size: 0.9rem;\n  letter-spacing: -0.02em;\n}\n\n.comp-ladder__row.is-us td {\n  background: color-mix(in srgb, var(--comp-primary) 18%, transparent);\n}\n\n.comp-ladder__row.is-us td:first-child {\n  box-shadow: inset 3px 0 0 var(--ladder-rail);\n}\n\n.comp-ladder__row.is-us .comp-ladder__pos span {\n  background: var(--comp-primary);\n  color: #fff;\n  font-weight: 800;\n}\n\n.comp-ladder__row.is-us .comp-ladder__name span {\n  font-weight: 780;\n}\n\n.comp-ladder__row.is-us .comp-ladder__pts {\n  color: var(--comp-primary);\n  font-size: 0.98rem;\n}\n\n.comp-page--light .comp-ladder__row.is-us td {\n  background: color-mix(in srgb, var(--comp-primary) 12%, #fff);\n}\n\n.comp-ladder__legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  list-style: none;\n  margin: 0.75rem 0 0;\n  padding: 0;\n}\n\n.comp-ladder__legend li {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.28rem 0.48rem;\n  border-radius: 999px;\n  border: 1px solid var(--comp-border);\n  background: color-mix(in srgb, var(--comp-slate) 55%, transparent);\n  font-size: 0.62rem;\n  color: var(--comp-muted);\n  line-height: 1.25;\n}\n\n.comp-ladder__legend strong {\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  color: var(--comp-text);\n}\n\n.comp-ladder__legend strong.is-win {\n  color: var(--ladder-win);\n}\n\n.comp-ladder__legend strong.is-draw {\n  color: var(--ladder-draw);\n}\n\n.comp-ladder__legend strong.is-loss {\n  color: var(--ladder-loss);\n}\n\n@media (min-width: 420px) {\n  .comp-ladder__us {\n    grid-template-columns: auto minmax(0, 1fr) auto;\n  }\n\n  .comp-ladder__us-stats {\n    grid-column: auto;\n    width: min(11.5rem, 42vw);\n  }\n}\n\n.comp-browse-note {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  margin: 0.85rem 0 0;\n  padding: 0.7rem 0.8rem;\n  border-radius: 16px;\n  border: 1px dashed var(--comp-border);\n  color: var(--comp-muted);\n  font-size: 0.86rem;\n}\n\n.comp-browse-note span {\n  min-width: 0;\n  flex: 1;\n}\n\n.comp-browse-note em {\n  display: block;\n  font-style: normal;\n  font-size: 0.75rem;\n}\n\n.comp-browse-note button {\n  border: 0;\n  background: color-mix(in srgb, var(--comp-primary) 16%, transparent);\n  color: inherit;\n  border-radius: 999px;\n  padding: 0.4rem 0.7rem;\n  font: inherit;\n  font-size: 0.75rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.comp-team-chip {\n  width: 100%;\n  margin-top: 1.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.95rem 1rem;\n  border-radius: 18px;\n  border: 1px solid var(--comp-border);\n  background: var(--comp-glass);\n  backdrop-filter: blur(18px);\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: transform 0.3s var(--comp-ease), border-color 0.2s ease;\n}\n\n.comp-team-chip:hover {\n  transform: translateY(-1px);\n}\n\n.comp-team-chip:active {\n  transform: scale(0.98);\n}\n\n.comp-team-chip__main {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 0;\n}\n\n.comp-team-chip__main > span {\n  min-width: 0;\n}\n\n.comp-team-chip strong {\n  display: block;\n  font-size: 1.05rem;\n}\n\n.comp-team-chip em {\n  display: block;\n  font-style: normal;\n  color: var(--comp-muted);\n  font-size: 0.82rem;\n  margin-top: 0.15rem;\n}\n\n.comp-days {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n  overflow: visible;\n  margin: 1rem 0 0;\n  padding: 0;\n}\n\n.comp-days button {\n  flex: 0 0 auto;\n  min-height: 36px;\n  border: 1px solid var(--comp-border);\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--comp-muted);\n  border-radius: 999px;\n  padding: 0.42rem 0.8rem;\n  font: inherit;\n  font-size: 0.78rem;\n  font-weight: 650;\n  cursor: pointer;\n  transition: all 0.25s var(--comp-ease);\n}\n\n.comp-days button.is-active {\n  background: var(--comp-primary);\n  border-color: transparent;\n  color: #fff;\n}\n\n.comp-stage {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.comp-stage__primary {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  min-width: 0;\n}\n\n.comp-tour-inscribe {\n  padding: 1.1rem 1.05rem 1rem;\n  border-radius: 24px;\n  border: 1px solid var(--comp-border);\n  background:\n    linear-gradient(\n      165deg,\n      color-mix(in srgb, var(--comp-primary) 14%, transparent),\n      transparent 48%\n    ),\n    var(--comp-glass);\n  backdrop-filter: blur(14px);\n}\n\n.comp-tour-inscribe__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.35rem;\n}\n\n.comp-tour-inscribe__kicker {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--comp-muted);\n}\n\n.comp-tour-inscribe__open {\n  border: 1px solid color-mix(in srgb, var(--comp-primary) 45%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-primary) 16%, transparent);\n  color: inherit;\n  font: inherit;\n  font-size: 0.78rem;\n  font-weight: 700;\n  border-radius: 999px;\n  padding: 0.3rem 0.75rem;\n  cursor: pointer;\n}\n\n.comp-tour-inscribe__open:hover {\n  border-color: color-mix(in srgb, var(--comp-primary) 70%, var(--comp-border));\n}\n\n.comp-tour-inscribe h3 {\n  margin: 0;\n  font-size: 1.05rem;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n}\n\n.comp-tour-inscribe__meta {\n  margin: 0.25rem 0 0.75rem;\n  color: var(--comp-muted);\n  font-size: 0.86rem;\n}\n\n.comp-tour-inscribe__date {\n  font-weight: 750;\n  color: color-mix(in srgb, var(--comp-primary) 78%, var(--comp-muted));\n}\n\n.comp-tour-inscribe__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.comp-tour-inscribe__list > li {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  padding: 0.55rem 0.6rem;\n  border-radius: 14px;\n  border: 1px solid color-mix(in srgb, var(--comp-border) 80%, transparent);\n  background: color-mix(in srgb, var(--comp-glass) 70%, transparent);\n}\n\n.comp-tour-inscribe__cats {\n  list-style: none;\n  margin: 0;\n  padding: 0 0 0 2.35rem;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n.comp-tour-inscribe__cats li {\n  font-size: 0.78rem;\n  font-weight: 650;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  border: 1px solid var(--comp-border);\n  color: var(--comp-muted);\n}\n\n.comp-tour-inscribe__cats li.is-in {\n  border-color: color-mix(in srgb, var(--comp-home) 45%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-home) 14%, transparent);\n  color: inherit;\n}\n\n.comp-tour-inscribe__cats li.is-maybe {\n  border-color: color-mix(in srgb, var(--comp-away) 40%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-away) 12%, transparent);\n  color: inherit;\n}\n\n.comp-stage__primary > .comp-next {\n  margin-top: 0;\n}\n\n.comp-next {\n  margin-top: 1.15rem;\n  padding: 1.25rem 1.15rem 1.15rem;\n  border-radius: 24px;\n  border: 1px solid var(--comp-border);\n  background:\n    linear-gradient(\n      165deg,\n      color-mix(in srgb, var(--comp-primary) 22%, transparent),\n      transparent 46%\n    ),\n    var(--comp-glass);\n  backdrop-filter: blur(20px);\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.2);\n}\n\n.comp-next__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.6rem;\n}\n\n.comp-next__top-end {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  flex-shrink: 0;\n}\n\n.comp-next__score-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  min-height: 2rem;\n  padding: 0.22rem 0.65rem;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, var(--comp-primary) 40%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-primary) 16%, var(--comp-glass));\n  color: var(--comp-text);\n  font-variant-numeric: tabular-nums;\n  line-height: 1;\n}\n\n.comp-next__score-badge strong {\n  font-size: 1.05rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n}\n\n.comp-score-sets {\n  display: block;\n  margin: 0.08rem 0 0;\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  opacity: 0.78;\n}\n\n.comp-next__score-badge .comp-score-sets,\n.comp-row__score-corner .comp-score-sets {\n  display: inline;\n  margin: 0 0 0 0.35rem;\n  text-transform: none;\n  letter-spacing: 0.01em;\n  font-variant-numeric: tabular-nums;\n}\n\n.comp-next__live-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n  margin: 0;\n  font-style: normal;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #fecaca;\n}\n\n.comp-next__live-tag::before {\n  content: \"\";\n  width: 0.45rem;\n  height: 0.45rem;\n  border-radius: 999px;\n  background: #ef4444;\n  box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.55);\n  animation: comp-live-pulse 1.4s ease-out infinite;\n}\n\n.comp-next__score-badge.is-live {\n  border-color: color-mix(in srgb, #ef4444 55%, transparent);\n  background: color-mix(in srgb, #ef4444 18%, var(--comp-glass));\n  color: #fecaca;\n  box-shadow: 0 0 0 1px color-mix(in srgb, #ef4444 25%, transparent);\n}\n\n.comp-next__score-badge.is-final.is-win {\n  border-color: color-mix(in srgb, var(--comp-home) 45%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-home) 18%, var(--comp-glass));\n  color: var(--comp-home);\n}\n\n.comp-next__score-badge.is-final.is-loss {\n  border-color: color-mix(in srgb, var(--comp-loss) 48%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-loss) 16%, var(--comp-glass));\n  color: var(--comp-loss);\n}\n\n.comp-next__score-badge.is-final.is-draw {\n  border-color: color-mix(in srgb, var(--comp-muted) 40%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-muted) 14%, var(--comp-glass));\n  color: var(--comp-muted);\n}\n\n.comp-page--light .comp-next__score-badge.is-live {\n  color: #b91c1c;\n  background: color-mix(in srgb, #dc2626 12%, #fff);\n}\n\n.comp-page--light .comp-next__live-tag {\n  color: #b91c1c;\n}\n\n@keyframes comp-live-pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.55);\n  }\n  70% {\n    box-shadow: 0 0 0 0.55rem rgba(239, 68, 68, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0);\n  }\n}\n\n.comp-next__label {\n  margin: 0;\n  font-size: 0.72rem;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  font-weight: 700;\n  color: var(--comp-muted);\n}\n\n.comp-next__when {\n  border-radius: 999px;\n  padding: 0.18rem 0.55rem;\n  background: color-mix(in srgb, var(--comp-home) 16%, transparent);\n  color: var(--comp-home);\n  font-size: 0.7rem;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.comp-next__rec {\n  position: relative;\n  width: 2.5rem;\n  height: 2.5rem;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  place-items: center;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, var(--comp-primary) 40%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-primary) 16%, transparent);\n  color: var(--comp-text);\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  transition: transform 0.2s var(--comp-ease), background 0.2s ease, border-color 0.2s ease;\n}\n\n.comp-next__rec:hover:not(:disabled),\n.comp-next__rec:focus-visible {\n  background: color-mix(in srgb, var(--comp-primary) 28%, transparent);\n  border-color: color-mix(in srgb, var(--comp-primary) 55%, transparent);\n  outline: none;\n}\n\n.comp-next__rec:active:not(:disabled) {\n  transform: scale(0.94);\n}\n\n.comp-next__rec:disabled {\n  opacity: 0.5;\n  cursor: wait;\n}\n\n.comp-next__rec.is-live {\n  border-color: color-mix(in srgb, #ef4444 55%, transparent);\n  background: color-mix(in srgb, #ef4444 18%, transparent);\n  color: #fecaca;\n}\n\n.comp-page--light .comp-next__rec {\n  border-color: color-mix(in srgb, var(--comp-primary) 55%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-primary) 14%, #fff);\n  color: var(--comp-primary);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n}\n\n.comp-page--light .comp-next__rec:hover:not(:disabled),\n.comp-page--light .comp-next__rec:focus-visible {\n  background: color-mix(in srgb, var(--comp-primary) 22%, #fff);\n  border-color: color-mix(in srgb, var(--comp-primary) 70%, transparent);\n}\n\n.comp-page--light .comp-next__rec.is-live {\n  border-color: color-mix(in srgb, #dc2626 65%, transparent);\n  background: color-mix(in srgb, #dc2626 12%, #fff);\n  color: #b91c1c;\n}\n\n.comp-next__rec.is-live::before {\n  content: \"\";\n  position: absolute;\n  top: 0.35rem;\n  right: 0.35rem;\n  width: 0.45rem;\n  height: 0.45rem;\n  border-radius: 999px;\n  background: #ef4444;\n  box-shadow: 0 0 0 2px color-mix(in srgb, #ef4444 25%, transparent);\n}\n\n.comp-page--light .comp-next__rec.is-live::before {\n  background: #dc2626;\n  box-shadow: 0 0 0 2px color-mix(in srgb, #dc2626 20%, #fff);\n}\n\n.comp-next__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.4rem;\n  margin-top: 0.45rem;\n  color: var(--comp-muted);\n  font-size: 0.86rem;\n  min-width: 0;\n}\n\n.comp-dot {\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: var(--comp-muted);\n}\n\n.comp-next__matchup {\n  margin: 1rem 0 0.55rem;\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: start;\n  gap: 0.55rem;\n  font-size: 0.92rem;\n  letter-spacing: -0.02em;\n}\n\n.comp-next__side {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.4rem;\n  min-width: 0;\n  text-align: center;\n}\n\n.comp-next__names {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.12rem;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.comp-next__club-name {\n  font-size: 0.88rem;\n  font-weight: 700;\n  line-height: 1.3;\n  display: block;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.comp-next__team-name {\n  margin: 0;\n  font-size: 0.72rem;\n  font-style: normal;\n  font-weight: 650;\n  line-height: 1.25;\n  color: var(--comp-muted);\n  overflow-wrap: anywhere;\n}\n\n.comp-next__club {\n  appearance: none;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 0;\n  max-width: 100%;\n  cursor: pointer;\n  text-align: center;\n  border-radius: 16px;\n}\n\n.comp-next__club:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 3px;\n}\n\n.comp-next__club:active {\n  transform: scale(0.98);\n}\n\n.comp-next__side strong.comp-next__club-name,\n.comp-next__club strong {\n  font-size: 0.88rem;\n  font-weight: 700;\n  line-height: 1.35;\n  display: block;\n  overflow: visible;\n  padding-block: 0.12em;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.comp-next__vs {\n  display: grid;\n  place-items: center;\n  align-self: start;\n  margin-top: 1.15rem;\n  min-width: 42px;\n  height: 42px;\n  padding: 0 0.35rem;\n  border-radius: 50%;\n  border: 1px solid var(--comp-border);\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--comp-muted);\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.comp-next__vs.comp-next__score {\n  width: auto;\n  min-width: 52px;\n  border-radius: 14px;\n  letter-spacing: 0.02em;\n  text-transform: none;\n  font-size: 1rem;\n  font-variant-numeric: tabular-nums;\n  color: inherit;\n  background: color-mix(in srgb, var(--comp-primary) 18%, var(--comp-glass));\n  border-color: color-mix(in srgb, var(--comp-primary) 40%, var(--comp-border));\n}\n\n.comp-next__vs.comp-next__score.is-final {\n  background: color-mix(in srgb, var(--comp-home) 22%, var(--comp-glass));\n  border-color: color-mix(in srgb, var(--comp-home) 45%, var(--comp-border));\n}\n\n.comp-next__vs.comp-next__score.is-final.is-win {\n  background: color-mix(in srgb, var(--comp-home) 22%, var(--comp-glass));\n  border-color: color-mix(in srgb, var(--comp-home) 45%, var(--comp-border));\n  color: var(--comp-home);\n}\n\n.comp-next__vs.comp-next__score.is-final.is-loss {\n  background: color-mix(in srgb, var(--comp-loss) 20%, var(--comp-glass));\n  border-color: color-mix(in srgb, var(--comp-loss) 48%, var(--comp-border));\n  color: var(--comp-loss);\n}\n\n.comp-next__vs.comp-next__score.is-final.is-draw {\n  background: color-mix(in srgb, var(--comp-muted) 18%, var(--comp-glass));\n  border-color: color-mix(in srgb, var(--comp-muted) 40%, var(--comp-border));\n  color: var(--comp-muted);\n}\n\n.comp-next__vs.comp-next__score.is-live {\n  background: color-mix(in srgb, #ef4444 18%, var(--comp-glass));\n  border-color: color-mix(in srgb, #ef4444 50%, var(--comp-border));\n}\n\n.comp-next.has-score {\n  cursor: pointer;\n}\n\n.comp-next.is-past,\n.comp-next.is-final {\n  border-color: color-mix(in srgb, var(--comp-home) 42%, var(--comp-border));\n  background:\n    linear-gradient(\n      165deg,\n      color-mix(in srgb, var(--comp-home) 18%, transparent),\n      transparent 48%\n    ),\n    var(--comp-glass);\n}\n\n.comp-next.is-final.is-win,\n.comp-next.is-past.is-win {\n  border-color: color-mix(in srgb, var(--comp-home) 42%, var(--comp-border));\n  background:\n    linear-gradient(\n      165deg,\n      color-mix(in srgb, var(--comp-home) 18%, transparent),\n      transparent 48%\n    ),\n    var(--comp-glass);\n}\n\n.comp-next.is-final.is-loss,\n.comp-next.is-past.is-loss {\n  border-color: color-mix(in srgb, var(--comp-loss) 46%, var(--comp-border));\n  background:\n    linear-gradient(\n      165deg,\n      color-mix(in srgb, var(--comp-loss) 18%, transparent),\n      transparent 48%\n    ),\n    var(--comp-glass);\n}\n\n.comp-next.is-final.is-draw,\n.comp-next.is-past.is-draw {\n  border-color: color-mix(in srgb, var(--comp-muted) 36%, var(--comp-border));\n  background:\n    linear-gradient(\n      165deg,\n      color-mix(in srgb, var(--comp-muted) 14%, transparent),\n      transparent 48%\n    ),\n    var(--comp-glass);\n}\n\n.comp-next.is-waiting {\n  border-color: color-mix(in srgb, var(--comp-away) 40%, var(--comp-border));\n  background:\n    linear-gradient(\n      165deg,\n      color-mix(in srgb, var(--comp-away) 16%, transparent),\n      transparent 48%\n    ),\n    var(--comp-glass);\n}\n\n.comp-next.is-live {\n  border-color: color-mix(in srgb, #ef4444 62%, var(--comp-border));\n  box-shadow:\n    0 0 0 1px color-mix(in srgb, #ef4444 35%, transparent),\n    0 18px 40px rgba(0, 0, 0, 0.22),\n    0 0 28px color-mix(in srgb, #ef4444 22%, transparent);\n  background:\n    linear-gradient(\n      165deg,\n      color-mix(in srgb, #ef4444 22%, transparent),\n      transparent 52%\n    ),\n    var(--comp-glass);\n  animation: comp-live-card-glow 2.4s ease-in-out infinite;\n}\n\n@keyframes comp-live-card-glow {\n  0%,\n  100% {\n    box-shadow:\n      0 0 0 1px color-mix(in srgb, #ef4444 35%, transparent),\n      0 18px 40px rgba(0, 0, 0, 0.22),\n      0 0 22px color-mix(in srgb, #ef4444 18%, transparent);\n  }\n  50% {\n    box-shadow:\n      0 0 0 2px color-mix(in srgb, #ef4444 48%, transparent),\n      0 18px 44px rgba(0, 0, 0, 0.24),\n      0 0 36px color-mix(in srgb, #ef4444 30%, transparent);\n  }\n}\n\n.comp-page--light .comp-next.is-live {\n  background:\n    linear-gradient(\n      165deg,\n      color-mix(in srgb, #dc2626 12%, transparent),\n      transparent 52%\n    ),\n    var(--comp-glass);\n}\n\n.comp-next.is-final .comp-next__label,\n.comp-next.is-past .comp-next__label {\n  color: var(--comp-home);\n}\n\n.comp-next.is-final.is-win .comp-next__label,\n.comp-next.is-past.is-win .comp-next__label {\n  color: var(--comp-home);\n}\n\n.comp-next.is-final.is-loss .comp-next__label,\n.comp-next.is-past.is-loss .comp-next__label {\n  color: var(--comp-loss);\n}\n\n.comp-next.is-final.is-draw .comp-next__label,\n.comp-next.is-past.is-draw .comp-next__label {\n  color: var(--comp-muted);\n}\n\n.comp-next.is-waiting .comp-next__label {\n  color: var(--comp-away);\n}\n\n.comp-next.is-live .comp-next__label {\n  color: #fecaca;\n}\n\n.comp-page--light .comp-next.is-live .comp-next__label {\n  color: #b91c1c;\n}\n\n.comp-next__when.is-past {\n  background: color-mix(in srgb, var(--comp-home) 16%, transparent);\n  color: var(--comp-home);\n}\n\n.comp-next.is-loss .comp-next__when.is-past {\n  background: color-mix(in srgb, var(--comp-loss) 16%, transparent);\n  color: var(--comp-loss);\n}\n\n.comp-results-note {\n  margin: 0.75rem 0 0;\n  padding: 0.55rem 0.7rem;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--comp-away) 38%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-away) 12%, var(--comp-glass));\n  color: var(--comp-text);\n  font-size: 0.8rem;\n  font-weight: 550;\n  line-height: 1.4;\n  text-align: left;\n}\n\n.comp-results-note.is-later {\n  border-color: color-mix(in srgb, var(--comp-away) 50%, var(--comp-border));\n}\n\n.comp-next[role=\"button\"] {\n  cursor: pointer;\n}\n\n.comp-row__score {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 0.15rem;\n  min-width: 2.6rem;\n  padding: 0.2rem 0.5rem;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, var(--comp-home) 40%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-home) 16%, transparent);\n  font-size: 0.82rem;\n  font-weight: 750;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.02em;\n}\n\n.comp-row__score.is-win {\n  border-color: color-mix(in srgb, var(--comp-home) 40%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-home) 16%, transparent);\n  color: var(--comp-home);\n}\n\n.comp-row__score.is-loss {\n  border-color: color-mix(in srgb, var(--comp-loss) 45%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-loss) 16%, transparent);\n  color: var(--comp-loss);\n}\n\n.comp-row__score.is-draw {\n  border-color: color-mix(in srgb, var(--comp-muted) 40%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-muted) 14%, transparent);\n  color: var(--comp-muted);\n}\n\n.comp-row.has-score {\n  cursor: pointer;\n}\n\n.comp-row__waiting {\n  display: inline-flex;\n  align-items: center;\n  margin-top: 0.15rem;\n  padding: 0.18rem 0.5rem;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, var(--comp-away) 40%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-away) 14%, transparent);\n  color: var(--comp-away);\n  font-size: 0.68rem;\n  font-weight: 750;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.comp-next__venue {\n  margin: 0.15rem 0 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.comp-page .comp-club-logo {\n  object-fit: contain;\n  background: #fff;\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.16);\n}\n\n.comp-page .comp-club-logo.club-logo-mark--md {\n  width: 72px;\n  height: 72px;\n  border-radius: 20px;\n  padding: 7px;\n  border: 0;\n}\n\n.comp-page .comp-club-logo.club-logo-mark--sm {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  padding: 3px;\n}\n\n.comp-page .comp-club-logo.club-logo-mark--fallback {\n  background: color-mix(in srgb, var(--comp-primary) 22%, transparent);\n  color: var(--comp-primary);\n  box-shadow: none;\n  padding: 0;\n}\n\n.comp-page .comp-club-logo.club-logo-mark--fallback.club-logo-mark--letter {\n  background:\n    radial-gradient(\n      120% 90% at 18% 12%,\n      color-mix(in srgb, #fff 28%, transparent),\n      transparent 55%\n    ),\n    linear-gradient(\n      145deg,\n      color-mix(in srgb, var(--comp-primary) 88%, #0b3d66) 0%,\n      var(--comp-primary) 52%,\n      color-mix(in srgb, var(--comp-primary) 60%, #0ea5e9) 100%\n    );\n  color: #fff;\n  border: 1px solid color-mix(in srgb, var(--comp-primary) 40%, #fff);\n  box-shadow: 0 6px 14px color-mix(in srgb, var(--comp-primary) 22%, transparent);\n}\n\n.comp-page .comp-club-logo.club-logo-mark--sm .club-logo-mark__letter {\n  font-size: 0.95rem;\n}\n\n.comp-page .comp-club-logo.club-logo-mark--md .club-logo-mark__letter {\n  font-size: 1.65rem;\n}\n\n.comp-next__div {\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  color: var(--comp-muted);\n  font-size: 0.88rem;\n}\n\n.pill {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 999px;\n  padding: 0.18rem 0.55rem;\n  font-size: 0.68rem;\n  font-weight: 750;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.pill--home {\n  background: rgba(52, 211, 153, 0.16);\n  color: var(--comp-home);\n}\n\n.pill--away {\n  background: rgba(251, 191, 36, 0.16);\n  color: var(--comp-away);\n}\n\n.comp-rsvp {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 0.4rem;\n  margin-top: 0.75rem;\n}\n\n.comp-rsvp__btn {\n  flex: 1 1 0;\n  min-width: 0;\n  min-height: 36px;\n  border: 1px solid var(--comp-border);\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--comp-text);\n  border-radius: 999px;\n  padding: 0.4rem 0.7rem;\n  font: inherit;\n  font-size: 0.82rem;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: transform 0.25s var(--comp-ease), background 0.2s ease, border-color 0.2s ease;\n}\n\n.comp-rsvp__btn:active {\n  transform: scale(0.97);\n}\n\n.comp-rsvp__btn.is-in {\n  background: rgba(52, 211, 153, 0.18);\n  border-color: color-mix(in srgb, var(--comp-in) 45%, transparent);\n  color: var(--comp-in);\n}\n\n.comp-rsvp__btn.is-out {\n  background: rgba(251, 113, 133, 0.16);\n  border-color: color-mix(in srgb, var(--comp-out) 45%, transparent);\n  color: var(--comp-out);\n}\n\n.comp-rsvp__btn.is-maybe {\n  background: rgba(251, 191, 36, 0.16);\n  border-color: color-mix(in srgb, var(--comp-away) 45%, transparent);\n  color: var(--comp-away);\n}\n\n.comp-lineup {\n  margin-top: 1rem;\n}\n\n.comp-lineup--side {\n  margin-top: 0.35rem;\n  width: 100%;\n  text-align: left;\n}\n\n.comp-lineup--side .comp-lineup__label {\n  justify-content: flex-start;\n  width: 100%;\n  margin-bottom: 0.3rem;\n  font-size: 0.66rem;\n}\n\n.comp-lineup__side-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.12rem;\n  width: 100%;\n}\n\n.comp-lineup__side-list li {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  min-width: 0;\n  padding: 0.22rem 0;\n  border-bottom: 1px solid var(--comp-border);\n  font-size: 0.72rem;\n  line-height: 1.25;\n}\n\n.comp-lineup__side-list li img,\n.comp-lineup__initials {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  flex: 0 0 auto;\n  object-fit: cover;\n}\n\n.comp-lineup__initials {\n  display: grid;\n  place-items: center;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid var(--comp-border);\n  font-size: 0.55rem;\n  font-weight: 700;\n  color: var(--comp-muted);\n}\n\n.comp-lineup__side-list li strong {\n  font-size: 0.72rem;\n  font-weight: 650;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.comp-lineup__side-list li.is-out {\n  opacity: 0.55;\n}\n\n.comp-lineup__side-list li.is-in strong {\n  color: var(--comp-home, #34d399);\n}\n\n.comp-lineup__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  margin: 0 0 0.45rem;\n  color: var(--comp-muted);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.comp-mates {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.comp-mates__item {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  overflow: hidden;\n  display: grid;\n  place-items: center;\n  font-size: 0.68rem;\n  font-weight: 700;\n  background: rgba(255, 255, 255, 0.08);\n  border: 2px solid transparent;\n}\n\n.comp-mates__item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.comp-mates__item.is-in {\n  border-color: var(--comp-in);\n}\n\n.comp-mates__item.is-out {\n  border-color: var(--comp-out);\n  opacity: 0.7;\n}\n\n.comp-presence-block {\n  margin: 0.65rem 0 0;\n}\n\n.comp-presence__label {\n  margin: 0 0 0.35rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--comp-muted);\n}\n\n.comp-presence-phase {\n  margin-top: 0.65rem;\n  padding-top: 0.55rem;\n  border-top: 1px dashed var(--comp-border);\n}\n\n.comp-presence {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.comp-presence__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  gap: 0.45rem;\n  padding: 0.28rem 0;\n  border-bottom: 1px solid var(--comp-border);\n  min-width: 0;\n}\n\n.comp-presence__who {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.comp-presence__who img,\n.comp-presence__ini {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.comp-presence__ini {\n  display: grid;\n  place-items: center;\n  font-size: 0.62rem;\n  font-weight: 700;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.comp-presence__who strong {\n  font-size: 0.82rem;\n  font-weight: 650;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.comp-presence__cls {\n  flex-shrink: 0;\n  font-size: 0.68rem;\n  font-weight: 700;\n  font-style: normal;\n  letter-spacing: 0.03em;\n  color: var(--comp-muted);\n  border: 1px solid var(--comp-border);\n  border-radius: 4px;\n  padding: 0.08rem 0.28rem;\n}\n\n.comp-presence__hint {\n  margin: 0 0 0.35rem;\n  font-size: 0.72rem;\n  line-height: 1.35;\n  color: var(--comp-muted);\n}\n\n.comp-presence__row.is-alt {\n  opacity: 0.95;\n}\n\n.comp-presence__acts {\n  display: inline-flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.25rem;\n  flex: 0 0 auto;\n}\n\n.comp-presence__acts button {\n  min-height: 30px;\n  border: 1px solid var(--comp-border);\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--comp-muted);\n  border-radius: 999px;\n  padding: 0.2rem 0.55rem;\n  font: inherit;\n  font-size: 0.68rem;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  line-height: 1.1;\n}\n\n.comp-presence__acts button:active {\n  transform: scale(0.97);\n}\n\n.comp-opp-preview {\n  margin: 0.75rem 0 0;\n  padding-top: 0.65rem;\n  border-top: 1px dashed var(--comp-border);\n  text-align: left;\n  width: 100%;\n}\n\n.comp-opp-preview.is-embedded {\n  margin: 0.35rem 0 0;\n  padding-top: 0;\n  border-top: 0;\n}\n\n.comp-opp-preview.is-embedded .comp-opp-preview__label {\n  font-size: 0.66rem;\n}\n\n.comp-opp-preview.is-embedded .comp-opp-preview__who strong {\n  font-size: 0.72rem;\n}\n\n.comp-opp-preview.is-embedded .comp-opp-preview__who small {\n  font-size: 0.62rem;\n}\n\n.comp-opp-preview.is-embedded .comp-opp-preview__acts button {\n  font-size: 0.62rem;\n  padding: 0.18rem 0.4rem;\n}\n\n.comp-opp-preview__label {\n  margin: 0 0 0.35rem;\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.5rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--comp-muted);\n}\n\n.comp-opp-preview__label span {\n  font-weight: 650;\n  letter-spacing: 0.02em;\n  text-transform: none;\n  color: var(--comp-primary);\n}\n\n.comp-opp-preview.is-last-match .comp-opp-preview__label span {\n  padding: 0.1rem 0.4rem;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--comp-primary) 16%, transparent);\n}\n\n.comp-opp-preview__source {\n  margin: -0.15rem 0 0.4rem;\n  font-size: 0.68rem;\n  line-height: 1.35;\n  color: var(--comp-muted);\n}\n\n.comp-opp-preview__list {\n  list-style: none;\n  margin: 0 0 0.55rem;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.comp-opp-preview__list li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.45rem;\n  padding: 0.28rem 0;\n  border-bottom: 1px solid var(--comp-border);\n  min-width: 0;\n}\n\n.comp-opp-preview__who {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.comp-opp-preview__who strong {\n  font-size: 0.84rem;\n  font-weight: 650;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.comp-opp-preview__who small {\n  color: var(--comp-muted);\n  font-size: 0.7rem;\n}\n\n.comp-opp-preview__memory {\n  list-style: none;\n  margin: 0.28rem 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.comp-opp-preview__memory li {\n  border: 0;\n  border-bottom: 0;\n  padding: 0.28rem 0.35rem;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.04);\n  display: flex;\n  flex-direction: column;\n  gap: 0.08rem;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.comp-opp-preview__memory li.is-note {\n  background: color-mix(in srgb, #a78bfa 12%, transparent);\n}\n\n.comp-opp-preview__memory li.is-feedback {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, transparent);\n}\n\n.comp-opp-preview__memory em {\n  font-style: normal;\n  font-size: 0.58rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--comp-muted);\n}\n\n.comp-opp-preview__memory span {\n  font-size: 0.7rem;\n  font-weight: 650;\n  line-height: 1.3;\n  overflow-wrap: anywhere;\n}\n\n.comp-opp-preview__acts {\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 0.25rem;\n}\n\n.comp-opp-preview__acts button {\n  min-height: 30px;\n  border: 1px solid var(--comp-border);\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--comp-muted);\n  border-radius: 999px;\n  padding: 0.2rem 0.55rem;\n  font: inherit;\n  font-size: 0.68rem;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.comp-opp-preview__acts button.is-in {\n  background: rgba(52, 211, 153, 0.18);\n  border-color: color-mix(in srgb, var(--comp-in) 45%, transparent);\n  color: var(--comp-in);\n}\n\n.comp-opp-preview__acts button.is-out {\n  background: rgba(251, 113, 133, 0.16);\n  border-color: color-mix(in srgb, var(--comp-out) 45%, transparent);\n  color: var(--comp-out);\n}\n\n.comp-opp-preview__acts button.is-icon {\n  width: 1.7rem;\n  height: 1.7rem;\n  min-width: 1.7rem;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.comp-opp-preview.is-embedded .comp-opp-preview__acts button.is-icon {\n  width: 1.55rem;\n  height: 1.55rem;\n  min-width: 1.55rem;\n  padding: 0;\n  font-size: 0;\n}\n\n.comp-opp-preview__hint {\n  margin: 0.15rem 0 0;\n  color: var(--comp-muted);\n  font-size: 0.72rem;\n  line-height: 1.35;\n}\n\n.comp-presence__row.is-phase-out {\n  opacity: 0.78;\n}\n\n.comp-presence__acts button.is-phase {\n  border-color: color-mix(in srgb, var(--comp-out) 55%, var(--comp-border));\n  color: var(--comp-out);\n}\n\n.comp-presence__acts button.is-in {\n  background: rgba(52, 211, 153, 0.18);\n  border-color: color-mix(in srgb, var(--comp-in) 45%, transparent);\n  color: var(--comp-in);\n}\n\n.comp-presence__acts button.is-out {\n  background: rgba(251, 113, 133, 0.16);\n  border-color: color-mix(in srgb, var(--comp-out) 45%, transparent);\n  color: var(--comp-out);\n}\n\n.comp-presence__status {\n  flex: 0 0 auto;\n  min-height: 28px;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 999px;\n  padding: 0.18rem 0.55rem;\n  font-size: 0.68rem;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  border: 1px solid var(--comp-border);\n  color: var(--comp-muted);\n}\n\n.comp-presence__status.is-in {\n  background: rgba(52, 211, 153, 0.18);\n  border-color: color-mix(in srgb, var(--comp-in) 45%, transparent);\n  color: var(--comp-in);\n}\n\n.comp-presence__status.is-out {\n  background: rgba(251, 113, 133, 0.16);\n  border-color: color-mix(in srgb, var(--comp-out) 45%, transparent);\n  color: var(--comp-out);\n}\n\n.comp-presence__row.is-in {\n  border-color: color-mix(in srgb, var(--comp-in) 28%, var(--comp-border));\n}\n\n.comp-presence__row.is-out {\n  border-color: color-mix(in srgb, var(--comp-out) 28%, var(--comp-border));\n}\n\n.comp-list {\n  margin-top: 0.35rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.comp-list__title {\n  margin: 0.4rem 0 0.15rem;\n  font-size: 0.78rem;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--comp-muted);\n}\n\n.comp-list__md {\n  margin: 0.55rem 0 0.15rem;\n  font-size: 0.72rem;\n  font-weight: 750;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--comp-muted);\n}\n\n.comp-row {\n  position: relative;\n  display: grid;\n  grid-template-columns: minmax(0, 92px) minmax(0, 1fr);\n  gap: 0.75rem;\n  padding: 0.85rem 0.95rem;\n  border-radius: 16px;\n  border: 1px solid var(--comp-border);\n  background: var(--comp-glass);\n  backdrop-filter: blur(14px);\n  cursor: pointer;\n  text-align: left;\n  color: inherit;\n  font: inherit;\n  transition: border-color 0.2s ease, transform 0.25s var(--comp-ease),\n    box-shadow 0.2s ease;\n}\n\n.comp-row:has(.comp-row__score-corner) {\n  padding-right: 4.75rem;\n}\n\n.comp-row:hover {\n  transform: translateY(-1px);\n}\n\n.comp-row.is-active {\n  border-color: color-mix(in srgb, var(--comp-primary) 55%, transparent);\n  box-shadow: 0 0 0 1px color-mix(in srgb, var(--comp-primary) 28%, transparent);\n}\n\n.comp-row.is-past {\n  opacity: 1;\n  border-color: color-mix(in srgb, var(--comp-home) 28%, var(--comp-border));\n}\n\n.comp-row.is-past.is-waiting {\n  border-color: color-mix(in srgb, var(--comp-away) 36%, var(--comp-border));\n  opacity: 1;\n}\n\n.comp-row.has-score,\n.comp-row.is-final {\n  border-color: color-mix(in srgb, var(--comp-home) 40%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-home) 8%, var(--comp-glass));\n}\n\n.comp-row.has-score.is-win,\n.comp-row.is-final.is-win {\n  border-color: color-mix(in srgb, var(--comp-home) 40%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-home) 8%, var(--comp-glass));\n}\n\n.comp-row.has-score.is-loss,\n.comp-row.is-final.is-loss {\n  border-color: color-mix(in srgb, var(--comp-loss) 42%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-loss) 10%, var(--comp-glass));\n}\n\n.comp-row.has-score.is-draw,\n.comp-row.is-final.is-draw {\n  border-color: color-mix(in srgb, var(--comp-muted) 34%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-muted) 8%, var(--comp-glass));\n}\n\n.comp-row.is-live {\n  border-color: color-mix(in srgb, #ef4444 58%, var(--comp-border));\n  background:\n    linear-gradient(\n      90deg,\n      color-mix(in srgb, #ef4444 18%, transparent),\n      transparent 42%\n    ),\n    color-mix(in srgb, #ef4444 8%, var(--comp-glass));\n  box-shadow:\n    0 0 0 1px color-mix(in srgb, #ef4444 28%, transparent),\n    0 0 18px color-mix(in srgb, #ef4444 16%, transparent);\n  padding-left: 0.85rem;\n  border-left: 3px solid #ef4444;\n}\n\n.comp-row.is-live.is-active {\n  border-color: color-mix(in srgb, #ef4444 72%, transparent);\n  box-shadow:\n    0 0 0 1px color-mix(in srgb, #ef4444 40%, transparent),\n    0 0 22px color-mix(in srgb, #ef4444 22%, transparent);\n}\n\n.comp-page--light .comp-row.is-live {\n  background:\n    linear-gradient(\n      90deg,\n      color-mix(in srgb, #dc2626 10%, transparent),\n      transparent 42%\n    ),\n    color-mix(in srgb, #dc2626 5%, #fff);\n}\n\n.comp-row__score-corner {\n  position: absolute;\n  top: 0.55rem;\n  right: 0.55rem;\n  z-index: 1;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n  min-height: 1.55rem;\n  padding: 0.16rem 0.5rem;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, var(--comp-primary) 36%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-primary) 14%, var(--comp-glass));\n  color: var(--comp-text);\n  font-variant-numeric: tabular-nums;\n  line-height: 1;\n  pointer-events: none;\n}\n\n.comp-row__score-corner strong {\n  font-size: 0.88rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n}\n\n.comp-row__live-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.22rem;\n  margin: 0;\n  font-style: normal;\n  font-size: 0.58rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #fecaca;\n}\n\n.comp-row__live-tag::before {\n  content: \"\";\n  width: 0.38rem;\n  height: 0.38rem;\n  border-radius: 999px;\n  background: #ef4444;\n  box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.55);\n  animation: comp-live-pulse 1.4s ease-out infinite;\n}\n\n.comp-row__score-corner.is-live {\n  border-color: color-mix(in srgb, #ef4444 55%, transparent);\n  background: color-mix(in srgb, #ef4444 18%, var(--comp-glass));\n  color: #fecaca;\n}\n\n.comp-row__score-corner.is-final.is-win {\n  border-color: color-mix(in srgb, var(--comp-home) 42%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-home) 16%, var(--comp-glass));\n  color: var(--comp-home);\n}\n\n.comp-row__score-corner.is-final.is-loss {\n  border-color: color-mix(in srgb, var(--comp-loss) 46%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-loss) 14%, var(--comp-glass));\n  color: var(--comp-loss);\n}\n\n.comp-row__score-corner.is-final.is-draw {\n  border-color: color-mix(in srgb, var(--comp-muted) 40%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-muted) 12%, var(--comp-glass));\n  color: var(--comp-muted);\n}\n\n.comp-row__score-corner.is-waiting {\n  border-color: color-mix(in srgb, var(--comp-away) 40%, var(--comp-border));\n  background: color-mix(in srgb, var(--comp-away) 14%, transparent);\n  color: var(--comp-away);\n  font-size: 0.62rem;\n  font-weight: 750;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.comp-page--light .comp-row__score-corner.is-live {\n  color: #b91c1c;\n  background: color-mix(in srgb, #dc2626 12%, #fff);\n}\n\n.comp-page--light .comp-row__live-tag {\n  color: #b91c1c;\n}\n\n.comp-row__when strong {\n  display: block;\n  font-size: 0.86rem;\n}\n\n.comp-row__when span {\n  color: var(--comp-muted);\n  font-size: 0.75rem;\n}\n\n.comp-row__body p {\n  margin: 0.25rem 0 0;\n  font-weight: 650;\n}\n\n.comp-row__name {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 0;\n}\n\n.comp-row__name span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.comp-row__body small {\n  color: var(--comp-muted);\n}\n\n.comp-events {\n  margin-top: 1.15rem;\n}\n\n.comp-events__head h2 {\n  margin: 0;\n  font-size: 1.2rem;\n  letter-spacing: -0.03em;\n}\n\n.comp-events__head-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem 1rem;\n}\n\n.comp-events__head p {\n  margin: 0.35rem 0 0;\n  color: var(--comp-muted);\n  line-height: 1.5;\n}\n\n.comp-fltt-card__toggle {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 44px minmax(0, 1fr) auto;\n  align-items: start;\n  gap: 0.55rem 0.85rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  font: inherit;\n  cursor: pointer;\n}\n\n.comp-fltt-card__toggle .comp-event-card__icon,\n.comp-fltt-card__toggle .comp-fltt-card__date,\n.comp-fltt-card__toggle .comp-event-card__body,\n.comp-fltt-card__toggle .comp-fltt-card__meta {\n  grid-area: auto;\n}\n\n.comp-fltt-card__toggle .comp-event-card__icon {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  margin-top: 0.1rem;\n}\n\n.comp-fltt-card__date {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 3.35rem;\n  min-height: 3.35rem;\n  padding: 0.35rem 0.25rem;\n  border-radius: 14px;\n  border: 1px solid color-mix(in srgb, var(--comp-primary) 45%, var(--comp-border));\n  background:\n    linear-gradient(\n      165deg,\n      color-mix(in srgb, var(--comp-primary) 28%, transparent),\n      color-mix(in srgb, var(--comp-primary) 8%, var(--comp-glass))\n    );\n  box-shadow: inset 0 1px 0 color-mix(in srgb, #fff 18%, transparent);\n  line-height: 1.05;\n  text-align: center;\n}\n\n.comp-fltt-card__date-weekday {\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--comp-muted);\n}\n\n.comp-fltt-card__date-day {\n  display: block;\n  margin: 0.08rem 0;\n  font-size: 1.35rem;\n  font-weight: 800;\n  letter-spacing: -0.04em;\n  font-variant-numeric: tabular-nums;\n  color: inherit;\n}\n\n.comp-fltt-card__date-month {\n  font-size: 0.68rem;\n  font-weight: 750;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: color-mix(in srgb, var(--comp-primary) 72%, var(--comp-muted));\n}\n\n.comp-fltt-card__when {\n  display: inline;\n  font-weight: 750;\n  color: color-mix(in srgb, var(--comp-primary) 78%, var(--comp-muted));\n}\n\n.comp-fltt-card__toggle .comp-event-card__body {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.comp-fltt-card__venue {\n  display: inline-flex;\n  align-items: flex-start;\n  gap: 0.3rem;\n  margin: 0.15rem 0.85rem 0.55rem 4.2rem;\n  max-width: calc(100% - 5.05rem);\n  font-size: 0.78rem;\n  color: var(--comp-muted);\n  line-height: 1.35;\n  text-decoration: none;\n  overflow-wrap: anywhere;\n}\n\n.comp-fltt-card__venue:hover {\n  color: var(--comp-primary);\n  text-decoration: underline;\n}\n\n.comp-fltt-card__venue:focus-visible {\n  outline: 2px solid color-mix(in srgb, var(--comp-primary) 70%, transparent);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.comp-fltt-card__meta {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding-top: 0.2rem;\n  flex-shrink: 0;\n}\n\n.comp-fltt-card__meta .is-rot,\n.comp-fltt-card__meta svg.is-rot {\n  transform: rotate(180deg);\n  transition: transform 0.2s ease;\n}\n\n.comp-event-card.comp-event-card--fltt {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  grid-template-columns: none;\n  grid-template-areas: none;\n  gap: 0;\n}\n\n.comp-event-card.kind-tournament.is-open {\n  grid-template-columns: 1fr;\n  grid-template-areas: none;\n  align-items: stretch;\n}\n\n.comp-fltt-card__detail {\n  margin-top: 0.85rem;\n  padding-top: 0.85rem;\n  border-top: 1px solid var(--comp-border);\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.comp-fltt-card__ball {\n  margin: 0;\n  font-size: 0.85rem;\n  color: var(--comp-muted);\n}\n\n.comp-fltt-card__notes {\n  margin: 0;\n  font-size: 0.82rem;\n  color: var(--comp-muted);\n  white-space: pre-line;\n  line-height: 1.4;\n}\n\n.comp-fltt-card__detail .comp-rsvp {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.45rem;\n  align-items: stretch;\n}\n\n.comp-fltt-card__detail .comp-rsvp__btn,\n.comp-fltt-card__detail .comp-get-results {\n  flex: unset;\n  width: 100%;\n  min-width: 0;\n  justify-content: center;\n  white-space: normal;\n  line-height: 1.25;\n  text-align: center;\n  overflow-wrap: anywhere;\n}\n\n/* Primary RSVP action needs the full row — long labels (FR/PT/NL) must not collide. */\n.comp-fltt-card__detail .comp-rsvp > .comp-rsvp__btn:first-child {\n  grid-column: 1 / -1;\n}\n\n.comp-fltt-cats {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.comp-fltt-cats legend {\n  padding: 0;\n  margin-bottom: 0.35rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--comp-muted);\n}\n\n.comp-fltt-cat {\n  display: grid;\n  grid-template-columns: auto 3.2rem 1fr auto;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.45rem 0.55rem;\n  border-radius: 12px;\n  border: 1px solid var(--comp-border);\n  background: color-mix(in srgb, var(--comp-glass) 80%, transparent);\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.comp-fltt-cat.is-in {\n  border-color: color-mix(in srgb, var(--comp-primary) 45%, var(--comp-border));\n}\n\n.comp-fltt-cat__time {\n  font-variant-numeric: tabular-nums;\n  color: var(--comp-muted);\n}\n\n.comp-fltt-cat__code {\n  font-weight: 600;\n}\n\n.comp-fltt-cat em {\n  font-style: normal;\n  font-size: 0.72rem;\n  color: var(--comp-primary);\n}\n\n.comp-fltt-participants h3 {\n  margin: 0 0 0.4rem;\n  font-size: 0.9rem;\n}\n\n.comp-fltt-participants ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.comp-fltt-participants li {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 0.25rem 0.75rem;\n  padding: 0.4rem 0.5rem;\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--comp-primary) 8%, transparent);\n  font-size: 0.88rem;\n}\n\n.comp-fltt-participants li span {\n  color: var(--comp-muted);\n}\n\n.comp-muted {\n  color: var(--comp-muted);\n  font-size: 0.9rem;\n}\n\n.comp-get-results .is-spin,\n.is-spin {\n  animation: comp-spin 0.9s linear infinite;\n}\n\na.comp-get-results {\n  text-decoration: none;\n}\n\n@keyframes comp-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.comp-events__grid {\n  list-style: none;\n  margin: 0.9rem 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.comp-event-card {\n  width: 100%;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-template-areas:\n    \"icon body\"\n    \"icon pill\";\n  align-items: center;\n  gap: 0.35rem 0.75rem;\n  padding: 1rem 0.95rem;\n  border-radius: 20px;\n  border: 1px solid var(--comp-border);\n  background: var(--comp-glass);\n  backdrop-filter: blur(16px);\n  color: inherit;\n  text-align: left;\n  font: inherit;\n  cursor: default;\n}\n\nbutton.comp-event-card {\n  cursor: pointer;\n  transition: transform 0.3s var(--comp-ease), border-color 0.2s ease;\n}\n\nbutton.comp-event-card:hover {\n  transform: translateY(-1px);\n}\n\n.comp-event-card--champ {\n  margin-top: 0.95rem;\n  background: linear-gradient(\n      120deg,\n      color-mix(in srgb, var(--comp-primary) 22%, transparent),\n      transparent 60%\n    ),\n    var(--comp-glass);\n}\n\n.comp-event-card__icon {\n  grid-area: icon;\n  width: 44px;\n  height: 44px;\n  border-radius: 14px;\n  display: grid;\n  place-items: center;\n  background: color-mix(in srgb, var(--comp-primary) 16%, transparent);\n  color: var(--comp-primary);\n}\n\n.comp-event-card .pill {\n  grid-area: pill;\n  justify-self: start;\n}\n\n.kind-cup .comp-event-card__icon {\n  background: rgba(251, 191, 36, 0.16);\n  color: var(--comp-away);\n}\n\n.kind-tournament .comp-event-card__icon {\n  background: rgba(167, 139, 250, 0.16);\n  color: #c4b5fd;\n}\n\n.comp-page--light .kind-tournament .comp-event-card__icon {\n  color: #6d28d9;\n}\n\n.comp-event-card__body {\n  grid-area: body;\n  min-width: 0;\n}\n\n.comp-event-card__body strong {\n  display: block;\n  font-size: 0.98rem;\n  letter-spacing: -0.02em;\n}\n\n.comp-event-card__body em {\n  display: block;\n  margin-top: 0.2rem;\n  font-style: normal;\n  color: var(--comp-muted);\n  font-size: 0.78rem;\n}\n\n.comp-sheet {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n}\n\n.comp-sheet__scrim {\n  position: absolute;\n  inset: 0;\n  border: 0;\n  background: rgba(2, 6, 23, 0.55);\n  backdrop-filter: blur(6px);\n}\n\n.comp-sheet__panel {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  max-height: min(82vh, 720px);\n  overflow: auto;\n  padding: 0.6rem 1.1rem calc(1.4rem + env(safe-area-inset-bottom, 0px));\n  border-radius: 24px 24px 0 0;\n  background: var(--comp-slate);\n  border: 1px solid var(--comp-border);\n  animation: comp-sheet-up 0.4s var(--comp-ease);\n}\n\n@keyframes comp-sheet-up {\n  from {\n    transform: translateY(24px);\n    opacity: 0.6;\n  }\n  to {\n    transform: none;\n    opacity: 1;\n  }\n}\n\n.comp-sheet__grab {\n  width: 42px;\n  height: 4px;\n  border-radius: 99px;\n  background: rgba(148, 163, 184, 0.45);\n  margin: 0.25rem auto 0.7rem;\n}\n\n.comp-sheet__panel header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.comp-sheet__panel h2 {\n  margin: 0;\n  font-size: 1.1rem;\n}\n\n.comp-sheet__panel header button {\n  border: 0;\n  background: rgba(255, 255, 255, 0.06);\n  color: inherit;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n}\n\n.comp-search {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0.9rem 0 0.4rem;\n  padding: 0.65rem 0.8rem;\n  border-radius: 12px;\n  border: 1px solid var(--comp-border);\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--comp-muted);\n}\n\n.comp-search input {\n  flex: 1;\n  border: 0;\n  background: transparent;\n  color: var(--comp-text);\n  font: inherit;\n  outline: none;\n}\n\n.comp-sheet__sec {\n  margin: 1rem 0 0.4rem;\n  font-size: 0.72rem;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--comp-muted);\n  font-weight: 700;\n}\n\n.comp-sheet__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.comp-sheet__list button {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  min-height: 48px;\n  padding: 0.75rem 0.1rem;\n  border: 0;\n  border-bottom: 1px solid var(--comp-border);\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n  font: inherit;\n}\n\n.comp-sheet__team {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  min-width: 0;\n}\n\n.comp-sheet__team strong {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.comp-sheet__div {\n  color: var(--comp-muted);\n  font-size: 0.82rem;\n  flex-shrink: 0;\n}\n\n.comp-rsvp__btn:focus-visible,\n.comp-team-chip:focus-visible,\n.comp-days button:focus-visible,\n.comp-sheet__list button:focus-visible,\n.comp-tabs button:focus-visible,\n.comp-teams__card:focus-visible,\n.comp-browse:focus-visible,\n.comp-get-results:focus-visible,\n.comp-empty__cta:focus-visible,\n.comp-row:focus-visible,\n.comp-event-card:focus-visible {\n  outline: 2px solid var(--comp-primary);\n  outline-offset: 2px;\n}\n\n.comp-championship,\n.comp-stage,\n.comp-stage-head,\n.comp-next,\n.comp-list,\n.comp-events,\n.comp-events__grid,\n.comp-row,\n.comp-presence,\n.comp-presence__row,\n.comp-opp-preview,\n.comp-opp-preview__list,\n.comp-teams,\n.comp-days {\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n@media (max-width: 719px) {\n  .comp-page {\n    padding-left: max(1.15rem, env(safe-area-inset-left, 0px));\n    padding-right: max(1.15rem, env(safe-area-inset-right, 0px));\n  }\n\n  .comp-page__inner {\n    max-width: 100%;\n  }\n\n  .comp-hero__stats {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .comp-next__matchup {\n    gap: 0.35rem;\n  }\n\n  .comp-row {\n    grid-template-columns: minmax(0, 78px) minmax(0, 1fr);\n    gap: 0.55rem;\n    padding: 0.8rem 0.8rem;\n  }\n\n  .comp-row:has(.comp-row__score-corner) {\n    padding-right: 4.35rem;\n  }\n\n  .comp-row.is-live {\n    padding-left: 0.7rem;\n  }\n\n  .comp-days {\n    overflow-x: auto;\n    flex-wrap: nowrap;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    padding-bottom: 0.15rem;\n    margin-inline: 0;\n  }\n\n  .comp-days::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n@media (min-width: 900px) {\n  .comp-page {\n    padding-top: 1.75rem;\n    padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px));\n    padding-left: max(1.5rem, env(safe-area-inset-left, 0px));\n    padding-right: max(1.5rem, env(safe-area-inset-right, 0px));\n  }\n\n  .comp-page__inner {\n    max-width: min(1080px, 100%);\n  }\n\n  .comp-hero h1 {\n    font-size: 2.55rem;\n  }\n\n  .comp-hero__stats {\n    max-width: 520px;\n  }\n\n  .comp-tabs {\n    max-width: 420px;\n  }\n\n  .comp-stage {\n    display: grid;\n    grid-template-columns: 1.12fr 0.88fr;\n    align-items: start;\n    gap: 1.25rem;\n  }\n\n  .comp-stage__primary {\n    gap: 1.15rem;\n  }\n\n  .comp-next {\n    margin-top: 0.85rem;\n  }\n\n  .comp-list {\n    margin-top: 0.85rem;\n  }\n\n  .comp-page .comp-club-logo.club-logo-mark--md {\n    width: 88px;\n    height: 88px;\n  }\n\n  .comp-events__grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .comp-event-card:not(.comp-event-card--fltt) {\n    grid-template-columns: auto 1fr auto;\n    grid-template-areas: \"icon body pill\";\n  }\n\n  .comp-event-card:not(.comp-event-card--fltt) .pill {\n    justify-self: end;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .comp-page *,\n  .comp-page *::before,\n  .comp-page *::after {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n\n/* FLTT apps STD singles results (team-info) — player \"My matches\" */\n.comp-std-matches {\n  margin: 1.25rem 0 1.75rem;\n  padding: 1rem 1.1rem 1.15rem;\n  border: 1px solid var(--comp-border);\n  border-radius: 20px;\n  background: var(--comp-glass);\n  color: var(--comp-text);\n}\n\n.comp-std-matches__head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem 1rem;\n  margin-bottom: 0.85rem;\n}\n\n.comp-std-matches__head h3 {\n  margin: 0 0 0.25rem;\n  font-size: 1.05rem;\n}\n\n.comp-std-matches__head p {\n  margin: 0;\n  font-size: 0.88rem;\n  color: var(--comp-muted);\n}\n\n.comp-std-matches__groups {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.comp-std-matches__group-head {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.45rem;\n  font-size: 0.86rem;\n}\n\n.comp-std-matches__group-head span {\n  opacity: 0.7;\n  white-space: nowrap;\n}\n\n.comp-std-matches__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0.45rem;\n}\n\n.comp-std-match {\n  --match-tone: color-mix(in srgb, var(--comp-primary) 10%, var(--comp-slate));\n  --match-edge: transparent;\n  --match-score: var(--comp-text);\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  grid-template-areas:\n    \"outcome main\"\n    \"outcome actions\"\n    \"editor editor\";\n  column-gap: 0.55rem;\n  row-gap: 0.28rem;\n  align-items: start;\n  padding: 0.55rem 0.65rem 0.55rem 0.5rem;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--match-edge) 28%, var(--comp-border));\n  background:\n    linear-gradient(\n      105deg,\n      color-mix(in srgb, var(--match-edge) 22%, transparent) 0%,\n      color-mix(in srgb, var(--match-edge) 8%, transparent) 42%,\n      transparent 72%\n    ),\n    var(--match-tone);\n  color: var(--comp-text);\n  box-shadow: inset 3px 0 0 var(--match-edge);\n}\n\n.comp-std-match.is-win {\n  --match-edge: #16a34a;\n  --match-tone: color-mix(in srgb, #16a34a 14%, var(--comp-slate));\n  --match-score: #86efac;\n}\n\n.comp-std-match.is-loss {\n  --match-edge: #dc2626;\n  --match-tone: color-mix(in srgb, #dc2626 14%, var(--comp-slate));\n  --match-score: #fca5a5;\n}\n\n.comp-std-match__outcome {\n  grid-area: outcome;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.7rem;\n  height: 1.7rem;\n  margin-top: 0.05rem;\n  border-radius: 8px;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  background: color-mix(in srgb, var(--match-edge, var(--comp-muted)) 22%, transparent);\n  color: var(--match-score);\n  border: 1px solid color-mix(in srgb, var(--match-edge, var(--comp-border)) 45%, transparent);\n}\n\n.comp-std-match__main {\n  grid-area: main;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 0.1rem 0.65rem;\n  align-items: baseline;\n  min-width: 0;\n}\n\n.comp-std-match__opp {\n  font-weight: 700;\n  font-size: 0.88rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.comp-std-match__opp em {\n  font-style: normal;\n  font-weight: 500;\n  color: var(--comp-muted);\n}\n\n.comp-std-match__score {\n  font-variant-numeric: tabular-nums;\n  font-weight: 800;\n  font-size: 1rem;\n  line-height: 1.1;\n  color: var(--match-score);\n  letter-spacing: 0.01em;\n}\n\n.comp-std-match__meta {\n  grid-column: 1 / -1;\n  font-size: 0.72rem;\n  color: var(--comp-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.comp-std-match__actions {\n  grid-area: actions;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n.comp-std-match__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n  border: 1px solid var(--comp-border);\n  background: color-mix(in srgb, var(--comp-primary) 10%, var(--comp-slate));\n  border-radius: 999px;\n  padding: 0.24rem 0.58rem;\n  font-size: 0.72rem;\n  font-weight: 650;\n  cursor: pointer;\n  color: var(--comp-text);\n  text-decoration: none;\n}\n\n.comp-std-match__notes {\n  grid-area: editor;\n  margin: 0.1rem 0 0;\n  font-size: 0.8rem;\n  opacity: 0.88;\n  white-space: pre-wrap;\n}\n\n.comp-std-match__editor {\n  grid-area: editor;\n  margin-top: 0.2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.comp-std-match__editor label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  font-size: 0.82rem;\n}\n\n.comp-std-match__editor textarea {\n  width: 100%;\n  resize: vertical;\n  border-radius: 8px;\n  border: 1px solid var(--comp-border);\n  background: var(--comp-slate);\n  color: var(--comp-text);\n  padding: 0.45rem 0.55rem;\n  font: inherit;\n}\n\n.comp-std-match__editor-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.comp-std-match__editor-actions button {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  border: 1px solid var(--comp-border);\n  border-radius: 8px;\n  padding: 0.35rem 0.7rem;\n  font: inherit;\n  font-size: 0.85rem;\n  cursor: pointer;\n  background: color-mix(in srgb, var(--comp-primary) 18%, var(--comp-slate));\n  color: var(--comp-text);\n}\n\n.comp-std-match__videos {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.comp-std-match__videos button {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n  font: inherit;\n  font-size: 0.85rem;\n  padding: 0.25rem 0;\n}\n\n.comp-std-matches__create {\n  margin-top: 1rem;\n}\n\n.comp-std-matches__create summary {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.comp-std-matches__form {\n  margin-top: 0.75rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(11rem, 1fr));\n  gap: 0.65rem;\n}\n\n.comp-std-matches__form label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  font-size: 0.8rem;\n}\n\n.comp-std-matches__form input,\n.comp-std-matches__form textarea {\n  border-radius: 8px;\n  border: 1px solid var(--comp-border);\n  background: var(--comp-slate);\n  color: var(--comp-text);\n  padding: 0.4rem 0.5rem;\n  font: inherit;\n}\n\n.comp-std-matches__form-notes {\n  grid-column: 1 / -1;\n}\n\n.comp-std-matches__form button[type=\"submit\"] {\n  grid-column: 1 / -1;\n  justify-self: start;\n  border: 0;\n  border-radius: 8px;\n  padding: 0.45rem 0.9rem;\n  font: inherit;\n  cursor: pointer;\n  background: color-mix(in srgb, var(--comp-primary) 22%, var(--comp-slate));\n  color: var(--comp-text);\n}\n\n/* Club tournament results — Finalized shell + podium + matches */\n.comp-std-results {\n  margin: 1.25rem 0 1.5rem;\n  border: 1px solid var(--comp-border);\n  border-radius: 20px;\n  background: var(--comp-glass);\n  color: var(--comp-text);\n  overflow: hidden;\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n}\n\n.comp-std-results.is-open {\n  border-color: color-mix(in srgb, var(--comp-primary) 42%, var(--comp-border));\n}\n\n.comp-std-results__shell {\n  width: 100%;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 0.75rem;\n  align-items: center;\n  padding: 0.95rem 1rem;\n  border: 0;\n  background: color-mix(in srgb, var(--comp-primary) 12%, transparent);\n  text-align: left;\n  cursor: pointer;\n  font: inherit;\n  color: var(--comp-text);\n}\n\n.comp-std-results__shell:hover {\n  background: color-mix(in srgb, var(--comp-primary) 18%, transparent);\n}\n\n.comp-std-results__panel {\n  padding: 0.85rem 1rem 1.1rem;\n  border-top: 1px solid var(--comp-border);\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  color: var(--comp-text);\n}\n\n.comp-std-results__head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem 1rem;\n}\n\n.comp-std-results__head p {\n  margin: 0;\n  font-size: 0.88rem;\n  color: var(--comp-muted);\n  max-width: 36rem;\n}\n\n.comp-std-results__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.comp-std-results__card {\n  border: 1px solid var(--comp-border);\n  border-radius: 12px;\n  background: var(--comp-slate);\n  color: var(--comp-text);\n  overflow: hidden;\n  transition:\n    border-color 0.18s ease,\n    box-shadow 0.18s ease;\n}\n\n.comp-std-results__card.has-data {\n  border-left: 3px solid color-mix(in srgb, var(--comp-primary) 70%, transparent);\n}\n\n.comp-std-results__card.is-selected {\n  border-color: color-mix(in srgb, var(--comp-primary) 45%, var(--comp-border));\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--comp-primary) 22%, transparent);\n}\n\n.comp-std-results__toggle {\n  width: 100%;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 0.75rem;\n  align-items: center;\n  padding: 0.85rem 1rem;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n  font: inherit;\n  color: var(--comp-text);\n}\n\n.comp-std-results__icon {\n  display: grid;\n  place-items: center;\n  width: 2.4rem;\n  height: 2.4rem;\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--comp-primary) 18%, var(--comp-slate));\n  color: var(--comp-primary);\n}\n\n.comp-std-results__body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n}\n\n.comp-std-results__body strong {\n  font-size: 0.98rem;\n  color: var(--comp-text);\n}\n\n.comp-std-results__body em {\n  font-style: normal;\n  font-size: 0.82rem;\n  color: var(--comp-muted);\n}\n\n.comp-std-results__shell .is-rot,\n.comp-std-results__toggle .is-rot {\n  transform: rotate(180deg);\n}\n\n.comp-std-results__detail {\n  padding: 0 1rem 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.9rem;\n  border-top: 1px solid var(--comp-border);\n}\n\n.comp-std-results__congrats {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.comp-std-results__congrats-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  padding: 0.75rem 0.9rem;\n  border-radius: 12px;\n  background:\n    linear-gradient(\n      135deg,\n      color-mix(in srgb, #f59e0b 22%, transparent),\n      color-mix(in srgb, var(--comp-primary) 16%, transparent)\n    );\n  border: 1px solid color-mix(in srgb, #f59e0b 35%, var(--comp-border));\n  color: var(--comp-text);\n}\n\n.comp-std-results__congrats-banner p {\n  margin: 0;\n  font-weight: 650;\n  font-size: 0.98rem;\n  line-height: 1.35;\n}\n\n.comp-std-results__congrats h4,\n.comp-std-results__category h4,\n.comp-std-results__matches-title {\n  margin: 0.35rem 0 0.25rem;\n  font-size: 0.82rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--comp-muted);\n}\n\n.comp-std-results__podium-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.comp-std-results__podium-list li {\n  display: block;\n  padding: 0;\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--comp-primary) 10%, var(--comp-slate));\n  font-size: 0.9rem;\n  color: var(--comp-text);\n}\n\n.comp-std-results__finalist {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 0.35rem;\n  align-items: center;\n  padding: 0.2rem 0.3rem 0.2rem 0.2rem;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  font: inherit;\n  color: var(--comp-text);\n}\n\n.comp-std-results__finalist-main {\n  min-width: 0;\n  display: grid;\n  grid-template-columns: 2.6rem 2.2rem minmax(0, 1fr);\n  gap: 0.5rem;\n  align-items: center;\n  padding: 0.35rem 0.35rem;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n  font: inherit;\n  color: inherit;\n}\n\n.comp-std-medal {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 0;\n  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.28));\n}\n\n.comp-page .sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.comp-std-results__avatar {\n  position: relative;\n  width: 2.4rem;\n  height: 2.4rem;\n  border-radius: 999px;\n  overflow: hidden;\n  display: grid;\n  place-items: center;\n  background: color-mix(in srgb, var(--comp-primary) 18%, var(--comp-slate));\n  color: var(--comp-text);\n}\n\n.comp-std-results__avatar img,\n.comp-std-results__avatar video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.comp-std-results__avatar > span {\n  font-weight: 700;\n  font-size: 0.95rem;\n  letter-spacing: 0.02em;\n}\n\n.comp-std-results__winner-badge {\n  position: absolute;\n  right: -2px;\n  bottom: -2px;\n  width: 1rem;\n  height: 1rem;\n  border-radius: 999px;\n  background: #ca8a04;\n  color: #fff;\n  font-size: 0.62rem;\n  font-weight: 700;\n  display: grid;\n  place-items: center;\n  border: 1px solid #fff;\n}\n\n.comp-std-results__finalist-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  min-width: 0;\n}\n\n.comp-std-results__finalist-text strong {\n  font-size: 0.92rem;\n}\n\n.comp-std-results__gallery-btn {\n  appearance: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.2rem;\n  padding: 0.4rem 0.55rem;\n  border-radius: 999px;\n  border: 1px solid var(--comp-border);\n  background: color-mix(in srgb, var(--comp-primary) 12%, var(--comp-slate));\n  color: var(--comp-text);\n  font-size: 0.72rem;\n  font-weight: 650;\n  cursor: pointer;\n  font: inherit;\n}\n\n.comp-std-gallery {\n  position: fixed;\n  inset: 0;\n  z-index: 21000;\n  width: auto;\n  height: auto;\n  background: #07080d;\n  color: #f7f4ee;\n  overflow: hidden;\n  outline: none;\n  /* Fill the visual viewport — avoid 100svh/100dvh mismatch leaving a bottom gap. */\n}\n\n.comp-std-gallery__reel {\n  position: absolute;\n  inset: 0;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scroll-snap-type: y mandatory;\n  overscroll-behavior: none;\n  touch-action: pan-y;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.comp-std-gallery__reel::-webkit-scrollbar {\n  display: none;\n}\n\n.comp-std-gallery.is-picking .comp-std-gallery__reel {\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.comp-std-gallery__slide {\n  position: relative;\n  box-sizing: border-box;\n  /* Exact gallery viewport — chrome/dock overlay; no empty padded band. */\n  flex: 0 0 100%;\n  width: 100%;\n  height: 100%;\n  min-height: 100%;\n  padding: 0;\n  scroll-snap-align: start;\n  scroll-snap-stop: always;\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n  background: #07080d;\n}\n\n.comp-std-gallery__blur {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: blur(32px) saturate(1.2);\n  transform: scale(1.12);\n  opacity: 0.38;\n  pointer-events: none;\n}\n\n.comp-std-gallery__media {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  max-width: none;\n  max-height: none;\n  object-fit: contain;\n  object-position: center;\n  background: transparent;\n}\n\n.comp-std-gallery__audio {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  color: #fff;\n  background: #0b0f19;\n  padding: 1.5rem;\n  box-sizing: border-box;\n}\n\n.comp-std-gallery__media.is-audio {\n  position: relative;\n  inset: auto;\n  width: min(90%, 28rem);\n  height: auto;\n  max-width: 100%;\n}\n\n.comp-std-gallery__chrome,\n.comp-std-gallery__dock,\n.comp-std-gallery__rail,\n.comp-std-gallery__step,\n.comp-std-gallery__mute {\n  position: absolute;\n  z-index: 3;\n}\n\n.comp-std-gallery__chrome {\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: calc(0.7rem + env(safe-area-inset-top, 0px)) 0.85rem 2.4rem;\n  background: linear-gradient(\n    180deg,\n    rgba(7, 8, 13, 0.78) 0%,\n    rgba(7, 8, 13, 0.18) 62%,\n    transparent 100%\n  );\n  pointer-events: none;\n}\n\n.comp-std-gallery__who {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  min-width: 0;\n  pointer-events: none;\n}\n\n.comp-std-gallery__chrome-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  flex-shrink: 0;\n  pointer-events: auto;\n}\n\n.comp-std-gallery__remove {\n  color: #fecaca;\n  background: rgba(127, 29, 29, 0.55);\n}\n\n.comp-std-gallery__remove:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.comp-std-gallery__kicker {\n  margin: 0 0 0.08rem;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: rgba(247, 244, 238, 0.72);\n}\n\n.comp-std-gallery__who h3 {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.15;\n}\n\n.comp-std-gallery__close,\n.comp-std-gallery__mute,\n.comp-std-gallery__nav,\n.comp-std-gallery__remove {\n  pointer-events: auto;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(12, 14, 20, 0.55);\n  color: #f7f4ee;\n  border-radius: 999px;\n  width: 2.35rem;\n  height: 2.35rem;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  backdrop-filter: blur(14px);\n}\n\n.comp-std-gallery__close:focus-visible,\n.comp-std-gallery__mute:focus-visible,\n.comp-std-gallery__nav:focus-visible,\n.comp-std-gallery__remove:focus-visible,\n.comp-std-gallery__rail button:focus-visible,\n.comp-std-gallery__device:focus-visible {\n  outline: 2px solid #f5c542;\n  outline-offset: 2px;\n}\n\n.comp-std-gallery__mute {\n  right: 0.85rem;\n  bottom: calc(7.4rem + env(safe-area-inset-bottom, 0px));\n}\n\n.comp-std-gallery__rail {\n  right: 0.72rem;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: column;\n  gap: 0.32rem;\n  pointer-events: none;\n}\n\n.comp-std-gallery__rail button {\n  pointer-events: auto;\n  width: 0.38rem;\n  height: 0.38rem;\n  padding: 0;\n  border: 0;\n  border-radius: 999px;\n  background: rgba(247, 244, 238, 0.32);\n  cursor: pointer;\n}\n\n.comp-std-gallery__rail button.is-active {\n  height: 1.15rem;\n  background: #f5c542;\n}\n\n.comp-std-gallery__step {\n  right: 0.72rem;\n  top: calc(50% + 4.6rem);\n  display: none;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.comp-std-gallery__nav:disabled {\n  opacity: 0.35;\n  cursor: default;\n}\n\n.comp-std-gallery__dock {\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 2.4rem 0.85rem calc(0.85rem + env(safe-area-inset-bottom, 0px));\n  background: linear-gradient(\n    0deg,\n    rgba(7, 8, 13, 0.88) 0%,\n    rgba(7, 8, 13, 0.28) 58%,\n    transparent 100%\n  );\n  pointer-events: none;\n}\n\n.comp-std-gallery__hint {\n  pointer-events: none;\n  margin: 0 0 0.65rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.28rem;\n  font-size: 0.78rem;\n  font-weight: 650;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba(247, 244, 238, 0.82);\n  animation: comp-std-gallery-hint 1.6s ease-in-out infinite;\n}\n\n.comp-std-gallery__actions {\n  pointer-events: auto;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n}\n\n.comp-std-gallery__file {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.comp-std-gallery__device {\n  flex: 1 1 10rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  margin: 0;\n  min-height: 2.55rem;\n  padding: 0.45rem 0.85rem;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background: rgba(247, 244, 238, 0.12);\n  color: #f7f4ee;\n  font: inherit;\n  font-size: 0.82rem;\n  font-weight: 650;\n  cursor: pointer;\n  backdrop-filter: blur(12px);\n}\n\n.comp-std-gallery__device.is-busy,\n.comp-std-gallery__device:disabled {\n  opacity: 0.65;\n  pointer-events: none;\n}\n\n.comp-std-gallery__empty {\n  position: absolute;\n  inset: 0;\n  height: auto;\n  margin: 0;\n  padding: 1.5rem 1.2rem calc(7rem + env(safe-area-inset-bottom, 0px));\n  border: 0;\n  background: radial-gradient(ellipse at 50% 42%, #1b2230 0%, #07080d 68%);\n  color: #f7f4ee;\n  display: grid;\n  place-content: center;\n  gap: 0.4rem;\n  cursor: pointer;\n  font: inherit;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n.comp-std-gallery__empty.is-busy {\n  opacity: 0.65;\n  cursor: wait;\n  pointer-events: none;\n}\n\n.comp-std-gallery__empty strong {\n  font-size: 1.05rem;\n  font-weight: 700;\n}\n\n.comp-std-gallery__empty span {\n  font-size: 0.86rem;\n  color: rgba(247, 244, 238, 0.7);\n  max-width: 18rem;\n  justify-self: center;\n}\n\n.comp-std-gallery__pick {\n  position: absolute;\n  z-index: 4;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  max-height: min(72vh, 34rem);\n  overflow: auto;\n  padding: 1rem 0.9rem calc(1rem + env(safe-area-inset-bottom, 0px));\n  border-radius: 18px 18px 0 0;\n  background: #12141c;\n  color: #f7f4ee;\n  border-top: 1px solid rgba(255, 255, 255, 0.12);\n  box-shadow: 0 -18px 40px rgba(0, 0, 0, 0.45);\n}\n\n.comp-std-gallery__pick-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.7rem;\n}\n\n.comp-std-gallery__pick-head p {\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n.comp-std-gallery__pick-empty {\n  margin: 0;\n  color: rgba(247, 244, 238, 0.7);\n}\n\n.comp-std-gallery__pick-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(6.5rem, 1fr));\n  gap: 0.5rem;\n}\n\n.comp-std-gallery__pick-list button {\n  width: 100%;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 12px;\n  overflow: hidden;\n  padding: 0;\n  background: #1a1d27;\n  cursor: pointer;\n  color: #f7f4ee;\n  font: inherit;\n}\n\n.comp-std-gallery__pick-list img,\n.comp-std-gallery__pick-list video {\n  width: 100%;\n  aspect-ratio: 1;\n  object-fit: cover;\n  display: block;\n}\n\n.comp-std-gallery__pick-list span {\n  display: block;\n  padding: 0.35rem 0.45rem;\n  font-size: 0.72rem;\n  text-align: left;\n}\n\n.comp-std-gallery .comp-page__error {\n  color: #fecaca;\n}\n\n@keyframes comp-std-gallery-hint {\n  0%,\n  100% {\n    transform: translateY(0);\n    opacity: 0.72;\n  }\n  50% {\n    transform: translateY(-5px);\n    opacity: 1;\n  }\n}\n\n@media (min-width: 720px) {\n  .comp-std-gallery__step {\n    display: flex;\n  }\n\n  .comp-std-gallery__pick {\n    left: 50%;\n    right: auto;\n    width: min(34rem, calc(100% - 2rem));\n    transform: translateX(-50%);\n    border-radius: 18px 18px 0 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .comp-std-gallery__hint {\n    animation: none;\n  }\n\n  .comp-std-gallery__reel {\n    scroll-behavior: auto;\n  }\n}\n\n.comp-std-results__place {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.comp-std-results__podium-list li em,\n.comp-std-results__vs em {\n  font-style: normal;\n  color: var(--comp-muted);\n  font-size: 0.82rem;\n}\n\n.comp-events__section-title {\n  margin: 0 0 0.65rem;\n  font-size: 0.78rem;\n  font-weight: 650;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  opacity: 0.7;\n}\n\n.comp-std-results__cat-podium {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem 0.85rem;\n  margin: 0 0 0.45rem;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.comp-std-results__cat-podium span {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n}\n\n.comp-std-results__matches {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0.4rem;\n}\n\n.comp-std-results__match-block + .comp-std-results__congrats,\n.comp-std-results__congrats + .comp-std-results__match-block,\n.comp-std-results__match-block + .comp-std-results__match-block {\n  margin-top: 0.75rem;\n  padding-top: 0.55rem;\n  border-top: 1px dashed var(--comp-border);\n}\n\n.comp-std-results__gallery-hint {\n  margin: 0.45rem 0 0;\n  font-size: 0.72rem;\n  line-height: 1.35;\n  color: var(--comp-muted);\n}\n\n.comp-std-results__match {\n  --match-tone: color-mix(in srgb, var(--comp-primary) 8%, var(--comp-slate));\n  --match-edge: transparent;\n  --match-score: var(--comp-text);\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 0.35rem 0.5rem;\n  align-items: center;\n  padding: 0.45rem 0.55rem;\n  border-radius: 11px;\n  background: var(--match-tone);\n  color: var(--comp-text);\n  font-size: 0.84rem;\n  border: 1px solid color-mix(in srgb, var(--match-edge) 26%, var(--comp-border));\n  box-shadow: inset 3px 0 0 var(--match-edge);\n  overflow: visible;\n}\n\n.comp-std-results__match.is-compact {\n  grid-template-columns: auto minmax(0, 1fr) auto auto;\n  grid-template-areas:\n    \"outcome main score notes\";\n  align-items: center;\n  column-gap: 0.5rem;\n  row-gap: 0.15rem;\n  padding: 0.48rem 0.55rem 0.48rem 0.42rem;\n  background:\n    linear-gradient(\n      105deg,\n      color-mix(in srgb, var(--match-edge) 24%, transparent) 0%,\n      color-mix(in srgb, var(--match-edge) 9%, transparent) 48%,\n      transparent 78%\n    ),\n    var(--match-tone);\n}\n\n.comp-std-results__outcome {\n  grid-area: outcome;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.55rem;\n  height: 1.55rem;\n  border-radius: 7px;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  background: color-mix(in srgb, var(--match-edge, var(--comp-muted)) 22%, transparent);\n  color: var(--match-score);\n  border: 1px solid color-mix(in srgb, var(--match-edge, var(--comp-border)) 45%, transparent);\n  flex: 0 0 auto;\n}\n\n.comp-std-results__match.is-compact > .comp-std-results__score {\n  grid-area: score;\n  justify-self: end;\n  align-self: center;\n  margin: 0;\n  padding: 0.12rem 0.45rem;\n  border-radius: 999px;\n  font-variant-numeric: tabular-nums;\n  font-weight: 800;\n  font-size: 0.92rem;\n  line-height: 1.15;\n  white-space: nowrap;\n  letter-spacing: 0.01em;\n  color: var(--match-score);\n  background: color-mix(in srgb, var(--match-edge, var(--comp-muted)) 16%, transparent);\n  border: 1px solid color-mix(in srgb, var(--match-edge, var(--comp-border)) 32%, transparent);\n}\n\n.comp-std-results__match.is-compact .comp-std-results__match-main {\n  grid-area: main;\n  min-width: 0;\n  padding-right: 0.1rem;\n}\n\n.comp-std-results__match .cm-player-notes {\n  --cm-primary: var(--comp-primary, #0877bc);\n  --cm-text: var(--comp-text);\n  margin: 0;\n  justify-self: end;\n}\n\n.comp-std-results__match.is-compact .cm-player-notes {\n  grid-area: notes;\n  align-self: center;\n  justify-self: end;\n  margin-top: 0;\n}\n\n.comp-std-results__match.is-compact .cm-player-notes__icon-btn {\n  width: 1.75rem;\n  height: 1.75rem;\n}\n\n.comp-std-results__match.is-win {\n  --match-edge: #16a34a;\n  --match-tone: color-mix(in srgb, #16a34a 13%, var(--comp-slate));\n  --match-score: #86efac;\n}\n\n.comp-std-results__match.is-loss {\n  --match-edge: #dc2626;\n  --match-tone: color-mix(in srgb, #dc2626 13%, var(--comp-slate));\n  --match-score: #fca5a5;\n}\n\n.comp-page--light .comp-std-results__match.is-win,\n.comp-page--light .comp-std-match.is-win {\n  --match-score: #15803d;\n}\n\n.comp-page--light .comp-std-results__match.is-loss,\n.comp-page--light .comp-std-match.is-loss {\n  --match-score: #b91c1c;\n}\n\n.comp-std-results__match-hit {\n  appearance: none;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  width: 100%;\n  padding: 0.4rem 0.5rem;\n  cursor: pointer;\n}\n\n.comp-std-results__match.is-open .comp-std-results__match-hit {\n  background: color-mix(in srgb, var(--comp-primary) 14%, transparent);\n}\n\n.comp-std-results__match-main {\n  min-width: 0;\n}\n\n.comp-std-results__match-compact {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  grid-template-areas:\n    \"player\"\n    \"rating\"\n    \"vs\"\n    \"opp-rating\";\n  row-gap: 0.08rem;\n  align-items: baseline;\n}\n\n.comp-std-results__match-compact .comp-std-results__player-row {\n  grid-area: player;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.comp-std-results__match-compact .comp-std-results__player {\n  font-size: 0.78rem;\n  font-weight: 650;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n  padding-right: 0;\n}\n\n.comp-std-results__media-btn {\n  appearance: none;\n  border: 0;\n  background: color-mix(in srgb, var(--comp-primary, #0877bc) 16%, transparent);\n  color: var(--comp-primary, #0877bc);\n  width: 1.35rem;\n  height: 1.35rem;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  padding: 0;\n  cursor: pointer;\n  line-height: 0;\n}\n\n.comp-std-results__media-btn:hover,\n.comp-std-results__media-btn:focus-visible {\n  background: color-mix(in srgb, var(--comp-primary, #0877bc) 28%, transparent);\n  outline: none;\n}\n\n.comp-std-results__match-compact .comp-std-results__rating,\n.comp-std-results__match-compact .comp-std-results__opp-rating {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: var(--comp-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.comp-std-results__match-compact .comp-std-results__rating {\n  grid-area: rating;\n}\n\n.comp-std-results__match-compact .comp-std-results__opp-rating {\n  grid-area: opp-rating;\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 0.2rem 0.35rem;\n  white-space: normal;\n}\n\n.comp-std-results__match-compact .comp-std-results__opp-sep {\n  color: var(--comp-muted);\n  font-weight: 700;\n}\n\n.comp-std-results__match-compact .comp-std-results__vs {\n  grid-area: vs;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.8rem;\n  color: var(--comp-muted);\n}\n\n.comp-std-results__match-compact .comp-std-results__stage {\n  display: inline;\n  color: var(--comp-muted);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n.comp-std-results__fb-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.15rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: var(--comp-muted);\n}\n\n.comp-std-results__match-meta {\n  margin: 0;\n  font-size: 0.72rem;\n  color: var(--comp-muted);\n}\n\n.comp-std-results__match.is-open .comp-std-results__feedback {\n  padding: 0.45rem 0.5rem 0.55rem;\n  border-top: 1px solid var(--comp-border);\n}\n\n.comp-std-results__match-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1.4fr) auto auto;\n  gap: 0.35rem 0.55rem;\n  align-items: baseline;\n}\n\n.comp-std-results__match-tools {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.comp-std-results__match-tools button {\n  appearance: none;\n  border: 1px solid var(--comp-border);\n  background: color-mix(in srgb, var(--comp-primary) 12%, var(--comp-slate));\n  color: var(--comp-text);\n  border-radius: 999px;\n  padding: 0.22rem 0.6rem;\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 650;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n  cursor: pointer;\n}\n\n.comp-std-results__match-tools button.is-on {\n  border-color: color-mix(in srgb, var(--comp-primary) 55%, transparent);\n  background: color-mix(in srgb, var(--comp-primary) 22%, var(--comp-slate));\n}\n\n.comp-std-results__match-tools button span {\n  min-width: 1rem;\n  text-align: center;\n  font-variant-numeric: tabular-nums;\n  opacity: 0.8;\n}\n\n.comp-std-results__feedback {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.comp-std-results__feedback ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.comp-std-results__feedback li {\n  position: relative;\n  padding: 0.4rem 1.7rem 0.4rem 0.5rem;\n  border-radius: 10px;\n  border: 1px solid var(--comp-border);\n  background: color-mix(in srgb, var(--comp-primary) 10%, var(--comp-slate));\n}\n\n.comp-std-results__feedback li span {\n  display: block;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--comp-muted);\n  margin-bottom: 0.15rem;\n}\n\n.comp-std-results__feedback li p {\n  margin: 0;\n  font-size: 0.84rem;\n  color: var(--comp-text);\n  white-space: pre-wrap;\n}\n\n.comp-std-results__feedback li button {\n  position: absolute;\n  top: 0.35rem;\n  right: 0.35rem;\n  border: 0;\n  background: transparent;\n  color: var(--comp-muted);\n  cursor: pointer;\n  padding: 0.15rem;\n}\n\n.comp-std-results__feedback textarea {\n  width: 100%;\n  border-radius: 10px;\n  border: 1px solid var(--comp-border);\n  background: var(--comp-slate);\n  color: var(--comp-text);\n  font: inherit;\n  padding: 0.45rem 0.55rem;\n  resize: vertical;\n  min-height: 3.2rem;\n}\n\n.comp-std-results__player {\n  font-weight: 600;\n}\n\n.comp-std-results__score {\n  font-variant-numeric: tabular-nums;\n  font-weight: 700;\n}\n\n.comp-std-results__stage {\n  color: var(--comp-muted);\n  font-size: 0.78rem;\n  white-space: nowrap;\n}\n\n@media (min-width: 641px) {\n  .comp-std-matches__list {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 0.55rem;\n  }\n\n  .comp-std-results__matches {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 0.5rem;\n  }\n\n  .comp-std-results__match-block.is-mine .comp-std-results__matches {\n    grid-template-columns: 1fr;\n  }\n\n  .comp-std-results__match-compact {\n    grid-template-columns: minmax(0, 1.05fr) minmax(0, 1.4fr);\n    grid-template-areas:\n      \"player vs\"\n      \"rating opp-rating\";\n    align-items: baseline;\n    column-gap: 0.55rem;\n  }\n}\n\n@media (max-width: 640px) {\n  .comp-std-results__match {\n    font-size: 0.8rem;\n  }\n  .comp-std-results__match.is-compact {\n    grid-template-columns: auto minmax(0, 1fr) auto;\n    grid-template-areas:\n      \"outcome main score\"\n      \"outcome main notes\";\n    align-items: start;\n  }\n  .comp-std-results__match.is-compact .cm-player-notes {\n    align-self: end;\n  }\n  .comp-std-results__match-hit {\n    padding: 0.32rem 0.42rem;\n  }\n  .comp-std-results__match-row {\n    grid-template-columns: 1fr auto;\n    grid-template-areas:\n      \"player score\"\n      \"vs vs\"\n      \"stage stage\";\n  }\n  .comp-std-results__match-row .comp-std-results__player {\n    grid-area: player;\n  }\n  .comp-std-results__match-row .comp-std-results__score {\n    grid-area: score;\n  }\n  .comp-std-results__match-row .comp-std-results__vs {\n    grid-area: vs;\n  }\n  .comp-std-results__match-row .comp-std-results__stage {\n    grid-area: stage;\n  }\n}\n\n.comp-events__card {\n  margin: 0 0 0.9rem;\n  padding: 0.9rem 0;\n  border-bottom: 1px solid var(--comp-line, rgba(255, 255, 255, 0.08));\n}\n\n.comp-events__card h3 {\n  margin: 0 0 0.25rem;\n}\n\n.comp-events__card button {\n  margin-top: 0.55rem;\n  font: inherit;\n  cursor: pointer;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
